export const huLangDashboard = {
  headerSearch: {
    placeholder: 'Termékek keresése',
    cancel: 'Mégse',
    empty: 'Nincs találat',
    noShop: 'Még nincsenek kereshető termékek',
  },
  adminUi: {
    podcastEnterShowTitle: 'Add meg a podcast címét',
    podcastMaximum: 'Maximum',
    podcastCharacters: 'karakter',
    podcastShowTitleExists: 'Már létezik podcast ezzel a címmel',
    podcastEditShow: 'Podcast szerkesztése',
    podcastNewShow: 'Új podcast',
    podcastCover: 'Borítókép',
    podcastTitle: 'Cím',
    podcastShowTitlePlaceholder: 'Podcast címe',
    podcastCategory: 'Kategória',
    podcastCategoryPlaceholder: 'pl. Igaz bűnügyek',
    podcastDescription: 'Leírás',
    podcastDescriptionPlaceholder: 'Miről szól ez a podcast…',
    podcastSubscribeButtons: '„Feliratkozás” gombok',
    podcastAddPlatform: 'Platform hozzáadása',
    podcastSave: 'Mentés',
    podcastCreate: 'Létrehozás',
    episodeOne: 'epizód',
    episodeFew: 'epizód',
    episodeMany: 'epizód',
    edit: 'Szerkesztés',
    delete: 'törlés',
    addShow: 'Podcast hozzáadása',
    importFromRss: 'Importálás RSS-ből',
    importFromRssFeed: 'Importálás RSS-hírcsatornából',
    importFromRssHint: 'Illessz be egy podcast RSS-linket — az epizódok automatikusan bekerülnek egy új podcastba.',
    import: 'Importálás',
    trackWordOne: 'szám',
    trackWordFew: 'szám',
    trackWordMany: 'szám',
    albumLabel: 'Album',
    pause: 'Szünet',
    play: 'Lejátszás',
    emptyTracks: 'Még nincs szám ebben az albumban',
    untitled: 'Névtelen',
    show: 'Podcast',
    audioFileNotAttached: 'Nincs csatolt hangfájl',
    paypalConnectionTitle: 'Válassz PayPal-kapcsolódási módot',
    paypalConnectionSubtitle: 'Válaszd a számodra legmegfelelőbb kapcsolódási módot',
    paypalRecommendedBadge: 'Ajánlott',
    paypalPartnerTitle: 'PayPal Partneren keresztül',
    paypalPartnerFeatureQuickConnect: 'Gyors kapcsolódás 1 kattintással',
    paypalPartnerFeatureAutoTokens: 'Automatikus token-frissítés',
    paypalPartnerFeatureMostSecure: 'A legbiztonságosabb módszer',
    paypalPartnerFeatureNoApiKeys: 'Nincs szükség API-kulcsok másolására',
    paypalPartnerButton: 'Csatlakozás Partneren keresztül',
    paypalDirectTitle: 'Közvetlenül (API hitelesítő adatok)',
    paypalDirectFeatureClientIdSecret: 'Client ID és Secret szükséges',
    paypalDirectFeatureManualSetup: 'Manuális beállítás',
    paypalDirectFeatureFullControl: 'Teljes kontroll az API felett',
    paypalDirectFeatureAdvancedUsers: 'Haladó felhasználóknak',
    paypalDirectButton: 'Közvetlen csatlakozás',
    clientIdRequired: 'A Client ID megadása kötelező',
    clientSecretRequired: 'A Client Secret megadása kötelező',
    invalidPaypalCredentials: 'Érvénytelen PayPal hitelesítő adatok',
    connectPaypalDirectly: 'PayPal közvetlen csatlakoztatása',
    paypalConnectedSuccessfully: 'A PayPal sikeresen csatlakoztatva!',
    yourPaypalClientId: 'A PayPal Client ID-d a Dashboardból',
    yourPaypalClientSecret: 'A PayPal Client Secret-ed a Dashboardból',
    chooseOperatingMode: 'Válassz üzemmódot',
    sandboxTest: 'Sandbox (Teszt)',
    liveProduction: 'Élő (Production)',
    whereToFindCredentials: '💡 Hol találod a hitelesítő adatokat?',
    goTo: 'Menj a',
    createOrSelectApp: 'Hozz létre egy új App-ot, vagy válassz egy meglévőt',
    copyClientIdAndSecret: 'Másold ki a Client ID-t és a Secret-et',
    cancel: 'Mégse',
    connected: 'Csatlakoztatva!',
    connect: 'Csatlakozás',
    monobankTokenTooltip: 'Token a Monobank Business Acquiring-ből',
    monobankTokenPlaceholder: 'Add meg a Monobank tokent',
    whereToGetToken: 'Hol szerezhetsz tokent?',
    statusChangedTo: 'Állapot módosítva erre',
    all: 'Összes',
    loading: 'Betöltés...',
    noBookingsYet: 'Még nincs foglalás',
    noBookingsWithStatus: 'Nincs ilyen állapotú foglalás',
    nightsAbbr: 'éjszaka',
    uah: 'UAH',
    oneNightDeposit: 'Egyéjszakás előleg',
    fullPrepayment: 'Teljes előrefizetés',
    online: 'Online',
    confirm: 'Megerősítés',
    complete: 'Teljesítve',
    restore: 'Visszaállítás',
    bookingCalendarBooked: 'Lefoglalva',
    bookingCalendarBlockedManually: 'Manuálisan letiltva',
    bookingCalendarAvailable: 'Elérhető',
    bookingCalendarNoSettings: 'Nincs beállítás',
    bookingCalendarSaveItemFirst: 'Előbb mentsd el a terméket',
    bookingCalendarLoading: 'Betöltés...',
    bookingCalendarBlocked: 'Letiltva',
    bookingCalendarSelected: 'Kiválasztva',
    bookingCalendarSelectedDates: 'Kiválasztott dátumok',
    bookingCalendarPricePerDay: 'Ár/nap',
    bookingCalendarOpen: 'Megnyitás',
    bookingCalendarBlock: 'Letiltás',
    bookingCalendarCancel: 'Mégse',
    responseDeleted: 'Válasz törölve',
    deleteAllConfirm: 'Törlöd az összes választ? Ez a művelet nem vonható vissza.',
    allResponsesDeleted: 'Minden válasz törölve',
    responseOne: 'válasz',
    responseFew: 'válasz',
    responseMany: 'válasz',
    deleteAll: 'Összes törlése',
    allForms: 'Minden űrlap',
    noResponsesYet: 'Még nincs válasz',
    fieldName: 'Név',
    fieldPhone: 'Telefon',
    fieldAddress: 'Cím',
    fieldComment: 'Megjegyzés',
    customFields: 'További mezők',
    more: 'Több',
    view: 'Megtekintés',
    track: 'Szám',
    showing: 'Megjelenítve',
    of: 'a',
    ordersLower: 'rendelés',
    ordersEmpty: 'Még nincs bejegyzés',
    ordersCountLabel: 'bejegyzés',
    ordersName: 'Név',
    ordersPhone: 'Telefon',
    ordersLoading: 'Betöltés...',
    ordersComment: 'Megjegyzés',
    ordersPayment: 'Fizetés',
    ordersPrev: 'Előző',
    ordersNext: 'Következő',
    revokeAccessConfirm: 'Visszavonod a hozzáférést?',
    accessRevoked: 'Hozzáférés visszavonva',
    activeGrants: 'aktív hozzáférés',
    noActiveGrants: 'Nincs aktív hozzáférés',
    type: 'Típus',
    grantedBy: 'Megadta',
    started: 'Kezdve',
    until: 'Eddig',
    revoke: 'Visszavonás',
    deleted: 'Törölve',
    subscribers: 'feliratkozó',
    noSubscribersYet: 'Még nincs feliratkozó',
    phone: 'Telefon',
    name: 'Név',
    step: 'Lépés',
    done: 'kész',
    stepFailedSingular: 'lépés sikertelen',
    stepFailedPlural: 'lépés sikertelen',
    done2: 'Kész.',
    actionFailed: 'A művelet végrehajtása sikertelen.',
    starterCoffeeSite: 'Készíts weboldalt egy kávézónak',
    starterFaq: 'Adj hozzá egy GYIK blokkot 5 kérdéssel',
    starterTranslate: 'Fordítsd le az egész oldalt angolra',
    starterBrandColors: 'Válassz a márkámhoz illő színeket',
    stopped: 'Leállítva.',
    scopeSite: 'Oldal',
    scopePage: 'Lap',
    followUpAddPhoto: 'Adj hozzá még egy fotót',
    followUpAddQuestion: 'Adj hozzá még egy kérdést',
    followUpAddPlan: 'Adj hozzá még egy árcsomagot',
    followUpAddService: 'Adj hozzá még egy szolgáltatást',
    followUpAddBlock: 'Adj hozzá még egy blokkot',
    followUpMakeBetter: 'Tedd még jobbá',
    followUpTweakColors: 'Igazítsd a színeket a márkámhoz',
    followUpChangeColors: 'Színek módosítása',
    followUpTranslateEnglish: 'Fordítsd angolra',
    undoneDeletedPrefix: 'Visszavonva — eltávolítva',
    undoneOf: 'a',
    undoneCreatedBlocks: 'létrehozott blokk',
    planAnalyzing: 'Kérés elemzése',
    planCheckingSite: 'Az oldal állapotának ellenőrzése',
    planChoosingBlocks: 'Blokkok kiválasztása',
    planPreparing: 'Terv előkészítése',
    hideDetails: 'Részletek elrejtése',
    details: 'Részletek',
    emptyStateTitle: 'Miben segíthetek?',
    emptyStateSubtitle: 'Írd le, mit szeretnél — vagy válassz egy példát alább',
    undoing: 'Visszavonás…',
    undo: 'Visszavonás',
    blockSingular: 'blokk',
    blockPlural: 'blokk',
    usageCostTitle: 'A kérés költsége',
    tokens: 'token',
    stop: 'Leállítás',
    scopeSiteTitle: 'Módosítások az egész oldalon',
    scopePageTitle: 'Módosítások csak az aktuális lapon',
    customDesign: 'Egyéni dizájn',
    appointmentEmbedTitle: 'Beágyazási URL',
    appointmentEmbedSubtitle: 'Calendly beágyazása iframe-ként',
    appointmentEmbedCaption: 'Calendly URL',
    appointmentEmbedTooltip: 'Illessz be egy Calendly esemény-URL-t (pl. https://calendly.com/you/30min)',
    appointmentEmbedInvalid: 'Adj meg egy érvényes Calendly URL-t (pl. https://calendly.com/you/30min)',
  },
  ama: {
    questions: 'kérdés',
    all: 'Összes',
    unanswered: 'Megválaszolatlan',
    answered: 'Megválaszolt',
    loading: 'Betöltés...',
    noQuestions: 'Még nincs kérdés',
    anonymous: 'Névtelen',
    noName: 'Nincs név',
    yourAnswer: 'A válaszod',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    cancel: 'Mégse',
    enterAnswer: 'Írd be a válaszod...',
    saveAnswer: 'Válasz mentése',
    confirmDelete: 'Törlöd ezt a kérdést?',
    answerSaved: 'Válasz mentve',
    deleted: 'Törölve',
  },
  adsManager: {
    estimatedAudience: 'Becsült közönség mérete',
    audienceTooLarge: 'A közönséged nagyon széles — érdemes szűkíteni.',
    audienceTooNarrow: 'A közönséged nagyon szűk — érdemes szélesíteni.',
    audience: 'Közönség',
    suggestedAudience: 'Ajánlott közönség használata',
    suggestedAudienceHint: 'Széles célzás, a legjobb elérésért',
    buildYourOwn: 'Építsd fel saját magad',
    buildYourOwnHint: 'Állítsd be az életkort, nemet és országokat',
    expectedViewers: 'Várható hirdetésmegtekintők',
    totalBudget: 'Teljes kampányköltségvetés',
    duration: 'Időtartam',
    days: 'nap',
    advancedSchedule: 'Speciális ütemezés',
    hideAdvanced: 'Speciális ütemezés elrejtése',
    adPreview: 'Hirdetés előnézete',
    sponsored: 'Szponzorált',
    seeMore: 'Tovább',
    learnMore: 'Tudj meg többet',
    yourPage: 'A Te oldalad',
  },
  pinnedDock: {
    title: 'Kitűzött blokkok',
    label: 'KITŰZVE',
    expand: 'Kitűzött blokkok kibontása',
    collapse: 'Kitűzött blokkok összecsukása',
  },
  reviewButton: {
    title: '„Írj véleményt” gomb',
    desc: 'Jelenítsen meg egy gombot az értékelések alatt, amely a látogatókat a véleményírás helyére irányítja.',
    buttonText: 'Gomb szövege',
    link: 'Link',
    leaveReview: 'Írj véleményt',
    googleHint: 'Hagyd üresen, hogy a Google-értékelési oldaladat használja.',
    design: 'Gomb dizájnja',
    background: 'Háttér',
    textColor: 'Szöveg',
  },
  common: {
    you: 'Te',
    post: 'Bejegyzés',
    article: 'Cikk',
    create: 'Létrehozás',
    message: 'Üzenet',
    popular: 'Népszerű',
    emptyIntegrations: 'Először integrációt kell hozzáadnod',
    categories: 'Kategóriák',
    edit: 'Szerkesztés',
    share: 'Megosztás',
    plan: 'Csomag',
    sort: 'Rendezés',
    addArticle: 'Cikk hozzáadása',
    articles: 'Cikkek',
    users: 'felhasználó',
    scans: 'beolvasás',
    clicks: 'kattintás',
    copy: 'Másolás',
    customize: 'Testreszabás',
    link: 'link',
    save: 'Mentés',
    uploadFile: 'Fájl feltöltése',
    customImage: 'Egyéni kép',
    customImageTooltip: 'Egyéni kép feltöltése',
    size: 'Méret',
    sizeTooltip: 'Húzd a csúszkát a méret beállításához',
    auto: 'Automatikus',
    rectangle: 'Négyzet alakú',
    custom: 'Egyéni',
    clean: 'Törlés',
    cleaning: 'Törlés',
    download: 'Letöltés',
    downloading: 'Letöltés',
    preview: 'ELŐNÉZET',
    cover: 'Borítókép',
    coverTooltip: 'Tölts fel egy borítóképet',
    title: 'Cím',
    new: 'Új',
    pro: 'Pro',
    free: 'Ingyenes',
    limit: 'Limit',
    websites: 'weboldal',
    site: 'Oldal',
    apiKey: 'API kulcs',
    name: 'Név',
    passwordChange: 'Jelszó módosítása',
    draft: 'Piszkozat',
    page: 'Lap',
    areYouSure: 'Biztos vagy benne?',
    drop: 'Húzd ide',
    video: 'videó',
    image: 'kép',
    chooseFile: 'Fájl kiválasztása',
    nothingFound: 'Nincs eredmény',
    enterCorrectLink: 'Adj meg helyes linket',
    off: 'Ki',
    disconnect: 'LEVÁLASZTÁS',
    connect: 'CSATLAKOZÁS',
    copied: 'Másolva',
    saved: 'Mentve',
    lostConnection: 'Kapcsolat megszakadt',
    addedCategory: 'Kategória hozzáadva',
    none: 'Nincs',
    left: 'Bal',
    right: 'Jobb',
    thin: 'Vékony',
    solid: 'Folytonos',
    double: 'Dupla',
    welcome: 'Üdvözlünk',
    category: 'Kategória',
    product: 'Termék',
    website: 'Weboldal',
    items: 'Tételek',
    square: 'Négyzet',
    round: 'Kör',
    border: 'Keret',
    shadow: 'Árnyék',
    subtle: 'Finom',
    soft: 'Puha',
    hard: 'Éles',
    block: 'Blokk',
    primary: 'Elsődleges',
    additional: 'További',
    normal: 'Normál',
    bold: 'Félkövér',
    uploadVideo: 'Videó feltöltése',
    compact: 'Kompakt',
    card: 'Kártya',
    top: 'Fent',
    center: 'Középen',
    bottom: 'Lent',
    button: 'Gomb',
    addNewItem: 'Új tétel hozzáadása',
    blockEmptyTitle: 'Még nincs itt semmi',
    blockEmptyText: 'Ebben a blokkban még nincs tétel. Adj hozzá egyet, hogy megjelenjen az oldaladon.',
    noItemsTitle: 'Még nincs semmi tételed',
    noItemsText: 'Add hozzá az első tételt a blokk feltöltéséhez.',
    price: 'Ár',
    priceCaption: 'Add meg a terméked árát',
    oldPrice: 'Régi ár',
    oldPriceCaption: 'A régi ár áthúzva jelenik meg',
    areYouSureDeleteItem: 'Biztosan eltávolítod ezt a tételt?',
    add: 'Hozzáadás',
    active: 'Aktív',
    isActive: 'aktív',
    isDisabled: 'letiltva',
    uploadImage: 'Kép feltöltése',
    design: 'Dizájn',
    addAccount: 'Fiók hozzáadása',
    hey: 'Hé',
    activeBackground: 'Aktív háttér',
    activeText: 'Aktív szöveg',
    connectDomain: 'Domain csatlakoztatása',
    shortLink: 'Rövid link',
    appearanceSaved: 'Megjelenés mentve!',
    blockAdded: 'Blokk hozzáadva!',
    comingSoon: 'Hamarosan',
    easyMoney: 'Könnyű pénz',
    content: 'Tartalom',
    audience: 'Közönség',
    view: 'Megtekintés',
    delete: 'Törlés',
    file: 'Fájl',
    type: 'Típus',
    from: 'Ettől',
    to: 'Eddig',
    fullName: 'Teljes név',
    lastTimeUsed: 'Utolsó használat',
    noMediaFiles: 'Még nincs médiafájl...',
    withdraw: 'Kifizetés',
    congrats: 'Gratulálunk!',
    makeMoneyOnline: 'Keress pénzt online!',
  },
  sort: {
    title: 'Rendezés',
    search: 'Keresés',
    default: 'Alapértelmezett rendezés',
    dateNew: 'Dátum: legújabb elöl',
    dateOld: 'Dátum: legrégebbi elöl',
    priceLow: 'Ár: alacsonytól magasig',
    priceHigh: 'Ár: magastól alacsonyig',
    nameA: 'Név: A-tól Z-ig',
    nameZ: 'Név: Z-től A-ig',
    popular: 'Legnépszerűbb',
  },
  emailMenu: {
    broadcasts: 'Körlevelek',
    automations: 'Automatizálások',
    templates: 'Sablonok',
    settings: 'Beállítások',
    noEmails: 'Még nincs e-mail',
    newBroadcast: 'Új körlevél',
  },
  aiContent: {
    title: 'Hozd létre az első AI-tartalmadat!',
    text: 'Tervezz és tegyél közzé tartalmat egyszerre minden közösségi médiában!',
    create: 'AI-tartalom létrehozása',
  },
  pageDesign: {
    page: 'Lap dizájnja',
    image: 'Kép',
  },
  toolsMenu: {
    title: 'Eszközök',
    account: 'Fiók',
    instantPages: 'Gyors lapok',
    instantPagesText: 'Gyorsan betöltődő önálló lapok',
    agents: 'Ügynökök',
    agentsText: 'AI-asszisztensek, amik kezelik a profilodat',
    socialPlanner: 'Közösségi tervező',
    socialPlannerText: 'Tartalom ütemezés és inspiráció',
    emailMarketing: 'E-mail marketing',
    emailMarketingText: 'Növeld a kontaktlistádat',
    smartReply: 'Instagram válasz',
    smartReplyText: 'Automatikus kommentek és üzenetek küldése',
    linkShortener: 'Rövid linkek',
    linkShortenerText: 'Rövidítsd le a hosszú URL-eket',
    posts: 'Bejegyzések',
    postsText: 'Bejegyzések létrehozása és kezelése',
    blog: 'Blog',
    blogText: 'Blogcikkek létrehozása és kezelése',
  },
  insideMenu: {
    planner: 'Tervező',
    aiContent: 'AI-tartalom',
    aiPosts: 'AI-bejegyzések',
    postIdeas: 'Bejegyzésötletek',
    contentPlanner: 'Tartalomtervező',
    aiImages: 'AI-képek',
    adBuilder: 'Hirdetéskészítő',
    brandProjects: 'Brand DNA',
    aiVideo: 'AI-videó',
    integrations: 'Integrációk',
    products: 'Termékek',
    orders: 'Rendelések',
    payments: 'Fizetések',
    links: 'Linkek',
    qrCodes: 'QR-kódok',
  },
  orders: {
    title: 'Rendelések',
    empty: 'Még nincs rendelésed',
    all: 'Minden rendelés',
    shop: 'Bolt',
    digital: 'Digitális termékek',
    appointments: 'Foglalások',
    services: 'Szolgáltatások',
    donations: 'Adományok',
  },
  discounts: {
    title: 'Kedvezmények',
    newDiscount: '+ Új kedvezmény',
    code: 'Kód',
    titleCol: 'Cím',
    type: 'Típus',
    value: 'Érték',
    status: 'Állapot',
    used: 'Felhasznált',
    actions: 'Műveletek',
    statusAll: 'Minden állapot',
    statusActive: 'Aktív',
    statusExpired: 'Lejárt',
    statusScheduled: 'Ütemezve',
    statusInactive: 'Inaktív',
    searchPlaceholder: 'Keresés kód vagy cím szerint...',
    clearFilters: 'Szűrők törlése',
    emptyTitle: 'Még nincs kedvezmény',
    emptySubtitle: 'Hozd létre az első promóciós kódot a termékeidhez',
    createDiscount: 'Kedvezmény létrehozása',
    createTitle: 'Kedvezmény létrehozása',
    editTitle: 'Kedvezmény szerkesztése',
    fieldTitle: 'Cím',
    fieldTitlePlaceholder: 'pl. Tavaszi akció',
    fieldCode: 'Kód',
    fieldCodePlaceholder: 'pl. SAVE20',
    generate: 'Generálás',
    sectionDiscount: 'Kedvezmény',
    fieldTrigger: 'Hogyan érvényesül',
    triggerCode: 'Kedvezménykód',
    triggerAutomatic: 'Automatikus (kód nélkül)',
    triggerAutomaticHint:
      'Automatikusan érvényesül a fizetésnél a feltételek teljesülésekor — kód nélkül. Állíts be lent egy minimális rendelési összeget az összeg alapú kedvezményhez.',
    automaticBadge: 'Automatikus',
    fieldType: 'Típus',
    typePercentage: 'Százalék',
    typeFixed: 'Fix összeg',
    typeFreeShipping: 'Ingyenes szállítás',
    fieldValue: 'Érték',
    sectionConditions: 'Feltételek (opcionális)',
    appliesTo: 'Érvényes ezekre',
    appliesToAll: 'Minden termék',
    appliesToShop: 'Bolt',
    appliesToDigital: 'Digitális',
    appliesToCourses: 'Kurzusok',
    appliesToServices: 'Szolgáltatások',
    appliesToEvents: 'Események',
    minOrderAmount: 'Min. rendelési összeg ($)',
    maxDiscountAmount: 'Max. kedvezmény összege ($) — 0 = nincs limit',
    minItemCount: 'Min. tételszám a rendelésben — 0 = nincs követelmény',
    specificProducts: 'Meghatározott termékek — üres = minden jogosult',
    specificProductsPlaceholder: 'Termékek keresése...',
    noProductsFound: 'Nincs találat',
    sectionLimits: 'Korlátok',
    usageLimit: 'Teljes felhasználási limit — 0 = korlátlan',
    usageLimitPerUser: 'Limit ügyfelenként — 0 = korlátlan',
    sectionSchedule: 'Ütemezés',
    startDate: 'Kezdő dátum — üres = azonnal kezdődik',
    endDate: 'Befejező dátum — üres = nincs lejárat',
    active: 'Aktív',
    cancel: 'Mégse',
    save: 'Kedvezmény mentése',
    createdSuccess: 'Kedvezmény létrehozva',
    updatedSuccess: 'Kedvezmény frissítve',
    deletedSuccess: 'Kedvezmény törölve',
    loadError: 'Nem sikerült betölteni a kedvezményeket',
    saveError: 'Nem sikerült menteni a kedvezményt',
    deleteError: 'Nem sikerült törölni a kedvezményt',
  },
  donation: {
    chooseSmiles: 'Válassz mosolyokat',
    item: 'Tétel',
    itemTitle: 'Az adománytétel címe',
    price: 'Ár',
    thanksMessagePlaceholder: 'Nagyon szépen köszönjük',
    thanksMessage: 'Köszönő üzenet',
    thanksMessageCaption: 'A köszönő üzenet a támogatóidnak jelenik meg az adományozás után',
    addDonation: 'Adomány hozzáadása',
    addAmount: '+ Összeg hozzáadása',
    buttonTitle: 'Gomb címe',
    buttonTitleCaption: 'Az adománygomb címe',
    acceptDonations: 'Adományok elfogadása',
    donationsType: 'Adományok',
    tips: 'Borravalók',
    type: 'Típus',
    addAnotherAmount: '+ Újabb összeg hozzáadása',
  },
  blog: {
    empty: 'Még nincs blogod',
  },
  apps: {
    empty: 'Még nincs appod',
  },
  payments: {
    title: 'Fizetések',
    text: 'Még nincs tranzakciód',
    single: 'Egyszeri fizetések',
    subscriptions: 'Előfizetések',
    wallet: 'Pénztárca',
    connectPromo: 'Csatlakoztass egy Stripe- vagy PayPal-fiókot a UniLink oldaladhoz, és fogadd az összes fizetést a pénztárcádba.',
    connectSystem: 'Fizetési rendszer csatlakoztatása',
    manageCards: 'Kártyáid kezelése',
    addNewCard: 'Új kártya hozzáadása',
    editCard: 'Kártyaadatok szerkesztése',
    addCard: 'Kártyaadatok hozzáadása',
    cardHolder: 'Kártyabirtokos neve',
    cardHolderNecessary: 'Ez szükséges',
    withdrawalSuccess: 'A kifizetési kérelmedet sikeresen elküldtük!',
    withdrawalError: 'Valami hiba történt, próbáld újra később.',
    change: 'Módosítás',
  },
  store: {
    emptyTitle: 'Még nincs terméked',
    emptyText: 'Kezdd az első termékeddel',
    emptyButton: 'Termék hozzáadása',
    createFirstProduct: 'Hozd létre az első terméked',
    startAdding: 'Kezdd a kedvenc termékeid, digitális termékeid vagy szolgáltatásaid hozzáadásával. Egy hely, ahol mindent eladhatsz és promótálhatsz, amit kínálsz.',
    activate: 'Bolt aktiválása',
    empty: 'Még nincs terméked',
    products: 'Termékek',
    addProducts: 'Termékek hozzáadása',
    whatDoYouWant: 'Mit szeretnél eladni?',
    externalProduct: 'Külső termék URL',
    createOwnProduct: 'Hozd létre saját terméked',
    shop: 'Bolt',
    shopText: 'Fizikai és digitális termékek eladása',
    digital: 'Digitális termékek',
    digitalText: 'Digitális letölthető tartalom eladása',
    course: 'Kurzus vagy oktatóanyag',
    courseText: 'Adj hozzá kurzust vagy oktatóanyagot a weboldalhoz',
    service: 'Szolgáltatások',
    serviceText: 'Adj hozzá szolgáltatásokat az ügyfeleidnek',
    appointment: 'Időpontok',
    appointmentText: 'Engedd, hogy a látogatók időpontot foglaljanak a naptáradban',
    event: 'Események vagy jegyek',
    eventText: 'Hozz létre eseményt, és hívd meg a közönségedet',
    tips: 'Borravaló',
    tipsText: 'Adj borravalót a kedvenc alkotóidnak',
    donation: 'Adományok',
    donationText: 'Adj adományt',
    membership: 'Tagság',
    membershipText: 'Adj hozzá tagságot a weboldalhoz',
    links: 'Külső link',
    linksText: 'Adj hozzá külső linket bármely weboldalhoz',
    coupon: 'Kupon',
    couponText: 'Adj hozzá kupont a weboldaladhoz',
    singleProduct: 'Egyedi termék',
    singleProductText: 'Adj el egy terméket egyszerű fizetéssel',
    booking: 'Foglalás',
    bookingText: 'Engedd, hogy a látogatók lefoglalják a helyiségeidet vagy ingatlanjaidat',
    rental: 'Bérlés',
    rentalText: 'Listázz bérelhető tételeket elérhetőséggel és árazással',
    add: 'Hozzáadás',
    manageStore: 'Bolt kezelése',
    displayLast: 'Legutóbbi termék megjelenítése',
  },
  products: {
    info: 'Info',
    uploadCover: 'Tölts fel egy borítóképet, majd add meg a címet és a leírást',
    thumbnail: 'Bélyegkép',
    thumbnailError: 'Adj hozzá egy bélyegképet',
    title: 'Cím',
    titleTooltip: 'Add meg a terméked nevét',
    shortDescription: 'Rövid leírás',
    shortDescriptionTooltip: 'Add meg a terméked rövid leírását',
    description: 'Leírás',
    descriptionTooltip: 'Add meg a terméked leírását',
    descriptionTooltipExtra: 'A termék jellemzőinek, típusainak, színének, méreteinek stb. opcionális leírása',
    price: 'Ár',
    priceTooltip: 'Add meg a terméked árát',
    oldPrice: 'Régi ár',
    oldPriceTooltip: 'A régi ár áthúzva jelenik meg',
    category: 'Kategória',
    categoryTooltip: 'Válaszd ki a terméked kategóriáját',
    image: 'Kép',
    imageTooltip: 'Tölts fel képet a terékedhez',
    groups: 'Csoportok',
    rate: 'Értékelés',
    rateTooltip: 'Add meg a terméked értékelését',
    buttonTitle: 'Gomb szövege',
    buttonTitleTooltip: 'Add meg a terméked gombjának szövegét',
    features: 'Jellemzők',
    featuresTooltip: 'A Showcase kártya elrendezésben megjelenő előnyök listája',
    featurePlaceholder: 'Előny',
    addFeature: 'Jellemző hozzáadása',
    limitQuantity: 'Mennyiség korlátozása',
    itemsLeft: 'Hátralévő darab',
    itemsLeftTooltip: 'A terméked darabszáma',
    trackStock: 'Mennyiség követése',
    stockQuantity: 'Készlet mennyisége',
    stockQuantityTooltip: 'A készleten lévő egységek jelenlegi száma. Minden fizetett rendeléssel automatikusan csökken; amikor eléri a 0-t, a termék nem vásárolható tovább.',
    lowStockThreshold: 'Alacsony készlet riasztás',
    lowStockThresholdTooltip: 'Kapj értesítést, ha a készlet ennyire vagy ez alá csökken.',
    maxOrderQuantity: 'Maximális rendelési mennyiség',
    maxOrderQuantityTooltip: 'A maximális egységszám, amit egy ügyfél egy rendelésben megvásárolhat. Hagyd üresen, ha nincs korlát.',
    minOrderQuantity: 'Minimális rendelési mennyiség',
    minOrderQuantityTooltip: 'A minimális egységszám, amit egy ügyfélnek egy rendelésben meg kell vásárolnia. Hagyd üresen, ha nincs korlát.',
    pendingReviews: {
      title: 'Függőben lévő értékelések',
      subtitle: 'Fogadd el vagy rejtsd el a vásárlói értékeléseket, mielőtt nyilvánosan megjelennének',
      empty: 'Nincs moderálásra váró értékelés.',
      approve: 'Elfogadás',
      hide: 'Elrejtés',
    },
    attachments: 'Csatolmányok',
    addAttachments: 'Adj hozzá csatolmányokat a termékeidhez',
    addNewAttachment: 'Új elem hozzáadása',
    file: 'Fájl',
    uploadFile: 'Fájl feltöltése',
    uploadCoverTitle: 'Borítókép feltöltése',
    optionalDescription: 'A termék jellemzőinek, típusainak, színének, méreteinek stb. opcionális leírása',
    customReviews: 'Egyéni értékelések',
    addCustomReviews: 'Adj hozzá értékeléseket a termékeidhez',
    name: 'Név',
    nameTooltip: 'Add meg az ügyfeled nevét',
    comment: 'Megjegyzés',
    commentTooltip: 'Add meg az ügyfeled megjegyzését',
    rateTooltipCustomer: 'Az ügyfél értékelése',
    imageTooltipCustomer: 'Tölts fel képet az ügyfeledről',
    displayPriceOnPreview: 'Ár megjelenítése az előnézetben',
    displayDetailsOnPreview: 'Részletek megjelenítése az előnézetben',
    postOnSocials: 'Közzététel a közösségi médiában',
    sendAnEmail: 'E-mail küldése',
    highlights: 'Kiemelések',
    listProductSetup: 'Listázd a terméket, és állítsd be a bolt blokkot',
    whereToSell: 'Hol szeretnéd eladni ezt a terméket?',
    youHaveProducts: '{count} terméked van',
    shareThisProduct: 'Termék megosztása',
    shareAProduct: 'Termék megosztása',
    monetizeWays: 'Különböző módok, ahogyan pénzt kereshetsz a UniLinken',
    addProductToProfile: 'Adj hozzá egy {title} elemet a profilodhoz',
    productPage: 'Termék oldal',
    setUpPayments: 'Állítsd be a fizetéseidet',
    connectPaymentMethods: 'Kapcsold össze a fizetési módjaidat, hogy elkezdhess pénzt keresni a Unilinken',
    addPaymentMethod: 'Adj hozzá egy {type} fizetési módot a követőid befizetéseinek fogadásához',
    withdrawAttempt: 'Ez egy kísérlet egy adósság behajtására, és minden információt erre a célra fogunk felhasználni.',
    withdrawSuccess: 'A kifizetési kérelmedet sikeresen elküldtük!',
    yourVisitorsPay: 'A látogatóid előbb fizetnek, majd átirányítjuk őket a {method} felé',
    emailAddress: 'e-mail cím',
    calendlyLink: 'Calendly link',
  },
  posts: {
    posts: 'Bejegyzések',
    title: 'Hozd létre az első bejegyzésedet',
    description: 'A Posts az, ahol könnyen és vizuálisan hozhatsz létre chat automatizációkat. Próbáld ki a céljaid alapján ajánlott automatizációkat',
    activate: 'Bejegyzések aktiválása',
    managePosts: 'Bejegyzések kezelése',
    postsTab: 'Bejegyzések fül',
    displayLast: 'Legutóbbi bejegyzések megjelenítése',
    tabNavigation: 'Fülnavigáció beállításai',
    createFirstPost: 'Hozd létre az első közösségi bejegyzésedet!',
    autoPostsText: 'Tervezz és publikálj tartalmat az összes közösségi médiára egyszerre!',
    createPost: 'Bejegyzés létrehozása',
  },
  messages: {
    title: 'Üzenetek',
    empty: 'Nincs üzenet',
    addText: 'Adj hozzá egy üzenet gombot a Header blokkhoz, hogy a felhasználók könnyen üzenetet küldhessenek neked.',
    addButton: 'Üzenet gomb hozzáadása',
  },
  smartReply: {
    title: 'Instagram válasz',
    clicks: 'kattintás',
    createTitle: 'Hozd létre az első Instagram válaszodat!',
    text: 'Használj Instagram Auto-DM-eket, hogy automatikusan megosszd a linkeket a közönségeddel!',
    createButton: 'Auto DM létrehozása',
    subtitleComment: 'Automatikus DM linkkel egy hozzászólásra válaszolva',
    subtitleDm: 'Automatikus DM egy üzenetre vagy Storyra válaszolva',
    ready: 'kész',
    edit: 'Szerkesztés',
    stepContentTitle: 'IG tartalom',
    stepContentSub: 'Válassz egy bejegyzést vagy Reelt',
    storiesAndDmsSub: 'Auto-DM, amikor valaki válaszol egy Storyra vagy üzenetet küld a postafiókodba',
    stepTriggerTitle: 'Kiváltó',
    stepTriggerSub: 'Kulcsszavak a hozzászólásokban',
    stepTriggerSubDm: 'Kulcsszavak az üzenetekben',
    stepDmTitle: 'DM',
    stepDmSub: 'Az automatikusan elküldött üzenet',
    dmSummary: 'Üzenet beállítva',
    activatesNow: 'Az automatikus válasz azonnal aktiválódik',
    saveAutomation: 'Automatikus válasz mentése',
    savedToast: 'Automatikus válasz létrehozva',
    linkLabel: 'Válassz link célt',
    selectDestination: 'Válassz egy linket, terméket vagy cikket',
    change: 'Módosítás',
    choose: 'Kiválasztás',
    remove: 'Eltávolítás',
    optional: 'opcionális',
    buttonText: 'Gomb szövege',
    addLink: 'Link hozzáadása',
    attachLink: 'Link csatolása',
    noLinks: 'Még nincs link — előbb adj hozzá egy linket a Link in Bio részben.',
    tabLinks: 'Linkek',
    tabProducts: 'Termékek',
    noProducts: 'Még nincs termék — előbb hozz létre egy terméket a boltodban.',
    tabArticles: 'Cikkek',
    noArticles: 'Még nincs cikk — előbb hozz létre egy cikket.',
    choosePost: 'Válassz egy bejegyzést vagy Reelt',
    searchPosts: 'Keresés a bejegyzéseid között',
    loadingPosts: 'Bejegyzések betöltése…',
    done: 'Kész',
    oneSelected: '1 bejegyzés kiválasztva',
    postSelected: 'Bejegyzés kiválasztva',
    noPosts: 'Még nincs bejegyzés — publikálj egy bejegyzést vagy Reelt az Instagramon.',
    postsError: 'Nem sikerült betölteni a bejegyzéseket. Próbáld újra.',
    reauthTitle: 'Előfordulhat, hogy néhány DM nem kerül kézbesítésre.',
    reauthText: 'Az Instagram megköveteli, hogy újra engedélyezd a fiókot.',
    reconnect: 'Újracsatlakozás',
    statActive: 'Aktív automatizációk',
    statDmSent: 'Elküldött DM-ek · 30 nap',
    statClicks: 'Linkkattintások',
    activeReplies: 'Aktív automatikus válaszok',
    filterAll: 'Összes',
    filterActive: 'Aktív',
    filterOff: 'Kikapcsolva',
  },
  virtualBackgrounds: {
    title: 'Virtuális hátterek',
    canvasSize: 'Vászon mérete',
    fmtCall: 'Zoom · Teams · Meet',
    fmtStories: 'Stories · Reels',
    fmtSquare: 'Négyzet',
    fmtClassic: 'Klasszikus',
    background: 'Háttér',
    bg_color: 'Szín',
    bg_gradient: 'Színátmenet',
    bg_photo: 'Fotó',
    bg_pattern: 'Minta',
    from: 'Ettől',
    to: 'Eddig',
    angle: 'Szög',
    ink: 'Tinta',
    paper: 'Papír',
    blur: 'Elmosás',
    darken: 'Sötétítés',
    presets: 'Előbeállítások',
    uploadImage: 'Kép feltöltése',
    removeImage: 'Kép eltávolítása',
    replace: 'Cserélés',
    remove: 'Eltávolítás',
    photoPlaceholder: 'Tölts fel egy képet a panelről',
    overlay: 'Átfedés',
    showName: 'Név megjelenítése',
    namePlaceholder: 'A neved',
    subtitlePlaceholder: 'Alcím / felhasználónév',
    typeface: 'Betűtípus',
    textColour: 'Szöveg színe',
    nameSizeLabel: 'Név mérete',
    position: 'Pozíció',
    showQr: 'QR-kód megjelenítése',
    qrPlaceholder: 'https://link',
    style: 'Stílus',
    qrCard: 'Kártya',
    qrBrand: 'Márka',
    qrLight: 'Világos',
    qrSolid: 'Egyszínű',
    qrSizeLabel: 'QR-kód mérete',
    logo: 'Logó / avatar',
    uploadLogo: 'Logó feltöltése (PNG)',
    logoSizeLabel: 'Logó mérete',
    finishing: 'Befejezés',
    vignette: 'Vinyetta',
    vignetteHint: 'Puha sötét szélek a mélységhatásért',
    shuffle: 'Keverés',
    reset: 'Visszaállítás',
    dragHint: 'Húzd a nevet, a QR-kódot vagy a logót a vászonon az áthelyezéshez',
    preparing: 'Előkészítés…',
    download: 'Letöltés',
    sizeHint: '1920 × 1080 JPG formátumban mentve',
  },
  emailSignatures: {
    title: 'E-mail aláírások',
    details: 'Részletek',
    name: 'Név',
    jobTitle: 'Beosztás',
    company: 'Cég',
    email: 'E-mail',
    phone: 'Telefon',
    website: 'Weboldal',
    style: 'Stílus',
    styleModern: 'Modern',
    styleClassic: 'Klasszikus',
    styleMinimal: 'Minimál',
    styleBold: 'Bátor',
    styleCard: 'Kártya',
    accent: 'Kiemelő szín',
    showAvatar: 'Fotó megjelenítése',
    showQr: 'QR-kód megjelenítése',
    preview: 'Előnézet',
    copySignature: 'Aláírás másolása',
    copyHtml: 'HTML másolása',
    copied: 'Aláírás lemásolva',
    copiedHtml: 'HTML lemásolva',
    instructions: {
      gmail: 'Gmail: Beállítások → Az összes beállítás megjelenítése → Általános → Aláírás → Új létrehozása, majd illeszd be (Ctrl/Cmd+V) és mentsd el a változtatásokat.',
      outlook:
        'Outlook: Fájl → Beállítások → Levelek → Aláírások → Új, majd illeszd be. Új Outlook / webes verzió: Beállítások → Levelek → Írás és válasz → illeszd be az aláírás mezőbe.',
      apple: 'Apple Mail: Mail → Beállítások → Aláírások → adj hozzá egy aláírást, majd illeszd be. Kapcsold ki a „Mindig az alapértelmezett üzenet betűtípusát használja” opciót.',
    },
  },
  businessCards: {
    title: 'Névjegykártyák',
    emptyTitle: 'Hozd létre a digitális névjegykártyádat',
    emptySubtitle: 'Add hozzá az elérhetőségi adataidat, hogy bárki egy koppintással elmenthesse a telefonjára — majd oszd meg egy QR-kóddal vagy egy .vcf fájllal.',
    createButton: 'Névjegykártya létrehozása',
    sectionButton: 'Elérhetőség mentése gomb',
    sectionButtonSubtitle: 'Hogyan nézzen ki az „Elérhetőség mentése” gomb, és hol jelenjen meg a profilodon.',
    showButton: 'Megjelenítés a profilomon',
    showButtonSubtitle: 'Az „Elérhetőség mentése” gomb megjelenítése a nyilvános oldaladon.',
    placement: 'Gomb elhelyezése',
    placementSubtitle: 'Válaszd ki, hol jelenjen meg a gomb.',
    showInHeader: 'Megjelenítés a fejrészben',
    placementHeader: 'Profil fejrész',
    placementHeaderHint: 'A neved és az avatarod alatt jelenik meg.',
    placementContact: 'Kapcsolatok szekció',
    placementContactHint: 'A Kapcsolatok felugró ablakban jelenik meg.',
    placementBottom: 'Lebegő gomb',
    placementBottomHint: 'Az oldal aljához rögzül, amíg a látogatók görgetnek.',
    none: 'Nincs',
    buttonLabel: 'Gomb felirata',
    buttonLabelSubtitle: 'A gombon megjelenő szöveg.',
    saveContact: 'Elérhetőség mentése',
    sectionDetails: 'Elérhetőségi adatok',
    sectionDetailsSubtitle: 'Ezek az adatok kerülnek mentésre a névjegykártyára.',
    leadCapture: 'Kapcsolatok gyűjtése',
    leadCaptureSubtitle: 'Engedd, hogy akik megkapják a kártyádat, megosszák vissza az adataikat — közvetlenül a Közönségedbe.',
    leadCaptureToggle: '„Oszd meg az adataidat” engedélyezése',
    leadCaptureToggleHint: 'Egy kapcsolatfelvételi űrlapot jelenít meg a nyilvános kártyádon.',
    leadTag: 'Új érdeklődők megjelölése',
    leadTagSubtitle: 'Minden begyűjtött kapcsolat ezzel a címkével kerül megjelölésre (pl. esemény vagy kampány neve).',
    leadTagPlaceholder: 'pl. Konferencia 2026',
    delete: 'Névjegykártya törlése',
    previewHint: 'Így néz ki a kártyád a látogatók számára.',
    share: 'Megosztás és QR',
    shareSubtitle: 'Szkenneld be a kódot, vagy oszd meg a linket a profilod megnyitásához.',
    download: '.vcf letöltése',
    copyLink: 'Link másolása',
    copied: 'Link lemásolva!',
    renewLink: 'Link megújítása',
    renewing: 'Megújítás…',
    renewConfirm: 'Megújítod a kártya linkjét? A jelenlegi QR-kódod és a megosztott linkek nem fognak tovább működni.',
    linkRenewed: 'Kártya linkje megújítva',
    scans: '{count} beolvasás',
    digitalCard: 'Digitális kártya',
    physicalCard: 'Fizikai kártya',
    cardStyle: 'Kártya stílusa',
    cardStyleSubtitle: 'Állítsd be a megjelenített nevedet, válassz háttérszínt, és add hozzá a kártyádat egy pénztárcához.',
    displayName: 'Megjelenített név',
    backgroundColour: 'Háttérszín',
    addAppleWallet: 'Hozzáadás az Apple Wallethez',
    addGoogleWallet: 'Hozzáadás a Google Wallethez',
    nameLabel: 'Név',
    urlLabel: 'URL',
    walletScanTitle: 'Szkenneld be a QR-kódot a pénztárcádba mentéshez',
    walletScanSubtitle: 'El lesz mentve a telefonod digitális pénztárcájába.',
    walletUseLink: 'Vagy használd ezt a linket helyette',
    walletComingSoonTitle: 'Már majdnem itt van',
    walletComingSoon: 'A Wallet passok hamarosan érkeznek.',
    done: 'Kész',
    physicalTitle: 'Fizikai kártya rendelése',
    physicalSubtitle: 'Az NFC névjegykártyák hamarosan érkeznek.',
  },
  shortLinks: {
    title: 'Rövid linkek',
    addLink: 'Link hozzáadása',
    name: 'Név',
    slug: 'Slug',
    slugTooltip: 'A Slugot a szerkesztés gombra kattintva módosíthatod',
    destinationUrl: 'Cél URL',
    metadata: 'Metaadatok',
    utmTags: 'UTM-címkék',
    customizeMetadata: 'Testreszabhatod a link metaadatait',
    metaTitle: 'Cím',
    metaDescription: 'Leírás',
    favicon: 'Favicon',
    imagePreview: 'Kép előnézete',
    addUtm: 'UTM-címkék hozzáadása a linkhez (opcionális)',
    utmCampaign: 'UTM kampány',
    utmMedium: 'UTM médium',
    utmSource: 'UTM forrás',
    utmTerm: 'UTM kifejezés',
    utmContent: 'UTM tartalom',
    utmId: 'UTM azonosító',
    utmPlacement: 'UTM elhelyezés',
    utmCreative: 'UTM kreatív',
    pasteLink: 'Illeszd be a hosszú linket ide',
    shorten: 'Link rövidítése',
    edit: 'Elem részleteinek szerkesztése',
  },
  audience: {
    title: 'Közönség',
    total: 'Összesen',
    totalMembers: 'Közönségtagok összesen',
    totalContacts: 'Kapcsolatok összesen',
    forms: 'Űrlapok',
    subscribers: 'Feliratkozók',
    customers: 'Ügyfelek',
    noAudienceMembers: 'Nincs kapcsolat',
    emptyAudienceMembers: 'Adj hozzá új kapcsolatokat a gombra kattintva',
    addAudienceMember: 'Kapcsolat hozzáadása',
    noSubscribers: 'Nincs feliratkozó',
    emptySubscribers: 'Adj hozzá új feliratkozókat blokkok hozzáadásával a Link in Biódhoz',
    addDataCollect: 'Adatgyűjtő blokk hozzáadása',
    noResponses: 'Nincs válasz',
    emptyResponses: 'Adj hozzá új válaszokat blokkok hozzáadásával a Link in Biódhoz',
    addFormBlock: 'Űrlap blokk hozzáadása',
    noCustomers: 'Nincs ügyfél',
    emptyCustomers: 'Adj hozzá új ügyfeleket termék hozzáadásával a Link in Biódhoz',
    addProduct: 'Termék hozzáadása',
    addContactModal: {
      title: 'Új kapcsolat hozzáadása',
      name: 'Név',
      nameTooltip: 'Add meg a kapcsolatod nevét',
      email: 'E-mail',
      emailTooltip: 'Add meg a kapcsolatod e-mail címét',
      phone: 'Telefon',
      phoneTooltip: 'Add meg a kapcsolatod telefonszámát',
      telegram: 'Telegram',
      telegramTooltip: 'Add meg a kapcsolatod Telegram felhasználónevét vagy URL-jét',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Add meg a kapcsolatod WhatsApp számát',
      instagram: 'Instagram',
      instagramTooltip: 'Add meg a kapcsolatod Instagram felhasználónevét vagy URL-jét',
      messenger: 'Messenger',
      messengerTooltip: 'Add meg a kapcsolatod Messenger felhasználónevét vagy URL-jét',
      viber: 'Viber',
      viberTooltip: 'Add meg a kapcsolatod Viber számát',
      address: 'Cím',
      addressTooltip: 'Add meg a kapcsolatod címét',
      add: 'Hozzáadás',
    },
    search: {
      search: 'Keresés',
      error: 'Érvénytelen karakter van a keresőmezőben',
      notFound: 'Nincs találat',
    },
  },
  auth: {
    logIn: 'Bejelentkezés',
    logInWith: 'Bejelentkezés ezzel:',
    signIn: 'Bejelentkezés',
    signInWith: 'Regisztráció ezzel:',
    email: 'E-mail',
    password: 'Jelszó',
    notHaveAccount: 'Nincs még fiókod?',
    createAccount: 'Új fiók létrehozása',
    createYourAccount: 'Hozd létre a fiókodat',
    signUp: 'Regisztráció',
    haveAccount: 'Ha már van fiókod',
    or: 'vagy',
    reset: 'Visszaállítás',
    resetPassword: 'Jelszó visszaállítása',
    resetTitle: 'A helyreállító linket elküldtük az e-mail címedre',
    goToHome: 'Ugrás a főoldalra',
    byClicking: 'A kattintással',
    youAreAgree: 'elfogadod a UniLink',
    terms: 'Szolgáltatási feltételeit',
    andConfirm: 'és megerősíted',
    usagePolicy: 'Használati szabályzatunkat',
    signInGoogle: 'Bejelentkezés Google fiókkal',
    forgotPassword: 'Elfelejtetted a jelszavad?',
  },
  menu: {
    moreApps: 'További alkalmazások',
    account: 'Fiók',
    more: 'Több',
    storyWidget: 'Stories beágyazása',
    integrations: 'Integrációk',
    socialAccounts: 'Közösségi médiafiókok',
    aiContent: 'AI tartalom',
    aiPosts: 'AI bejegyzések',
    postIdeas: 'Bejegyzésötletek',
    contentPlanner: 'Tartalomtervező',
    aiImages: 'AI képek',
    adBuilder: 'Hirdetéskészítő',
    aiVideo: 'AI Video',
    planner: 'Tervező',
    customers: 'Ügyfelek',
    subscribers: 'Feliratkozók',
    forms: 'Űrlapok',
    allAudience: 'Teljes közönség',
    payments: 'Fizetések',
    orders: 'Rendelések',
    products: 'Termékek',
    events: 'Események',
    appointments: 'Időpontok',
    discounts: 'Kedvezmények',
    affiliates: 'Affiliate partnerek',
    instantPages: 'Instant oldalak',
    openInNewTab: 'Megnyitás új lapon',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'Weboldal',
    store: 'Bolt',
    audience: 'Közönség',
    emailMarketing: 'E-mail marketing',
    postPlaner: 'Bejegyzéstervező',
    posts: 'Bejegyzések',
    agents: 'Ügynökök',
    community: 'Közösség',
    profileHealth: 'Profil állapota',
    socialPlanner: 'Social Planner',
    shortLinks: 'Rövid linkek',
    businessCards: 'Névjegykártyák',
    emailSignatures: 'E-mail aláírások',
    virtualBackgrounds: 'Virtuális hátterek',
    adsCampaigns: 'Hirdetéskezelő',
    views: 'Megtekintések',
    clicks: 'Kattintások',
    allWebsites: 'Minden weboldal',
    createNewAccount: 'Új fiók létrehozása',
    createNewWebsite: 'Új profil létrehozása',
    tools: 'Eszközök',
    borderGenerator: 'Keretgenerátor',
    yourPlan: 'A csomagod:',
    upgrade: 'Frissítés',
    accountSettings: 'Fiókbeállítások',
    manageWebsites: 'Profilok kezelése',
    updates: 'Frissítések',
    autoUpdate: 'Automatikus frissítés',
    logOut: 'Kijelentkezés',
    myPages: 'Saját oldalaim',
    design: 'Design',
    heading: 'Cím',
    analytics: 'Analitika',
    settings: 'Beállítások',
    open: 'Megnyitás',
    language: 'Nyelv',
    siteLanguage: 'Nyilvános oldal nyelve',
    dashboardLanguage: 'Vezérlőpult nyelve',
    movePage: 'Oldal áthelyezése',
    editBlock: 'Blokk szerkesztése',
    renameBlock: 'Blokk átnevezése',
    rename: 'Átnevezés',
    deleteBlock: 'Blokk törlése',
    archiveBlock: 'Blokk archiválása',
    archive: 'Archiválás',
    scheduleBlock: 'Blokk ütemezése',
    copyBlock: 'Blokk másolása',
    dublicateBlock: 'Blokk duplikálása',
    content: 'Tartalom',
    preview: 'Előnézet',
    thumbnail: 'Bélyegkép',
    copy: 'Másolás',
    moveBlock: 'Blokk áthelyezése',
    move: 'Áthelyezés',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    schedule: 'Ütemezés',
    dublicate: 'Duplikálás',
    smartReply: 'Instagram válasz',
    marketing: 'Marketing',
    selectBlocks: 'Blokkok kiválasztása',
    selectAll: 'Összes kiválasztása',
    cancelSelection: 'Mégse',
    blocksSelected: 'kiválasztva',
    moveToPage: 'Áthelyezés oldalra',
    newPage: 'Új oldal',
    openPage: 'Oldal megnyitása',
    pageSettings: 'Oldal beállításai',
    deletePage: 'Oldal törlése',
    appInBio: 'App in Bio',
    blog: 'Blog',
    buildFromReference: 'Építés referencia alapján',
    publish: 'Közzététel',
    creatorHub: 'Creator Hub',
    qrCodes: 'QR-kódok',
    apps: 'Alkalmazások',
    automations: 'Automatizációk',
    messages: 'Beérkezett üzenetek',
    form: 'Űrlapok beágyazása',
    embedTools: 'Beágyazási eszközök',
  },
  modal: {
    addInstagram: 'Instagram hozzáadása',
    addYourInstagram: 'Add hozzá az Instagram fiókodat',
    cropYourAvatar: 'Vágd körül az avatarodat',
    removeSite: 'Biztosan törölni szeretnéd az oldalt?',
    areYouSure: 'Biztosan szeretnéd',
    areYouSureDelete: 'Biztosan törölni szeretnéd ezt a szekciót?',
    areYouSureArchive: 'Biztosan archiválni szeretnéd ezt a blokkot?',
    areYouSurePermanentDelete: 'Biztosan véglegesen törölni szeretnéd ezt a blokkot? Ez a művelet nem vonható vissza.',
    remove: 'eltávolítani',
    site: 'oldalt',
    removeAccountText: 'törölni a fiókodat',
    moveBlock: 'Blokk áthelyezése másik oldalra',
    moveBlockText: 'Ez a blokkot egy másik oldal aljára helyezi át. Ezután átrendezheted a blokkot az új oldalon',
    profileTitle: 'Profilkép módosítása',
    profileText: 'Válassz egy képet vagy GIF-et az eszközödről.',
    profileAvatar: 'Profil avatar',
    addProfilePicture: 'Profilkép hozzáadása',
    storiesTitle: 'Stories',
    storiesText: 'Oszd meg a mindennapi pillanataidat.',
    thoughtsTitle: 'Gondolatok',
    thoughtsText: 'Oszd meg a gondolataidat.',
    accountPageDescription: 'Ez a fiókoldalad, ahol testreszabhatod az oldalad kinézetét, hozzáadhatsz különböző funkcióblokkokat és még sok mást.',
  },
  modalSubscribe: {
    plan: 'Csomag',
    usdMonth: 'USD/hó',
    sites: 'Oldalak',
    sitesMuch: 'Oldalak',
    notification: 'Értesítések',
    noNotification: 'Még nincs értesítés',
    inCategory: 'Nincs elem a',
    categoryYet: 'kategóriában még.',
    externalPixels: 'Külső pixelek',
    parameters: 'paraméter',
    analyticsReports: 'Analitika és jelentések',
    noUniLinkLogo: 'Nincs UniLink logó',
    inProfile: 'a profilban',
    verifiedBadge: 'Ellenőrzött jelvény',
    your: 'A te',
    customDomain: 'egyéni domained',
    emailMarketing: 'E-mail marketing',
    liveSupport: 'Élő support',
    dataSecured: 'Az adatok a PCI DSS szabványnak megfelelően vannak védve',
    thankYou: 'Köszönjük az érdeklődésed. Hamarosan kapcsolatba lépünk veled.',
    socialMediaScheduler: 'Közösségi média ütemező',
    featureRequest: 'Funkciókérés',
    markAllRead: 'Összes olvasottnak jelölése',
    currentPlan: 'Jelenlegi csomag',
    features: 'Funkciók',
  },
  buttons: {
    upgrade: 'Csomag frissítése',
    buyProPlan: 'Pro csomag vásárlása',
    continue: 'Folytatás',
    skip: 'Kihagyás',
    cancel: 'Mégse',
    confirm: 'Megerősítés',
    back: 'Vissza',
    save: 'Mentés',
    add: 'Hozzáadás',
    added: 'Hozzáadva',
    done: 'Kész',
    ok: 'OK',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    remove: 'Eltávolítás',
    setAsDefault: 'Alapértelmezettként beállítás',
    subscribeNow: 'Feliratkozás most',
    yes: 'Igen',
    preview: 'Előnézet',
    generate: 'Generálás',
    changePassword: 'Jelszó módosítása',
    deleteAccount: 'Fiók törlése',
    removeAccount: 'Fiók eltávolítása',
    deleteProfile: 'Profil törlése',
    addBlock: 'Blokk hozzáadása',
    copyLink: 'Link másolása',
    active: 'Aktív',
    update: 'Frissítés',
    updatePro: 'Csomag frissítése',
    prev: 'Előző',
    next: 'Következő',
    uploadImage: 'Kép feltöltése',
    uploadVideo: 'Videó feltöltése',
    loadMore: 'Továbbiak betöltése',
    uploadProductImage: 'Termékkép feltöltése',
    claim: 'Igénylés',
    removeSite: 'Webhely eltávolítása',
    move: 'Áthelyezés',
    addButton: 'Gomb hozzáadása',
    actionButton: 'Cselekvésgomb',
    directMessage: 'Közvetlen üzenet',
    subscribe: 'Feliratkozás',
    button: 'Gomb',
    generateWithAI: 'Generálás AI-val',
    cta: 'CTA',
    cart: 'Kosár',
    direct: 'Direct',
    follow: 'Követés',
    addNewItem: 'Új elem hozzáadása',
  },
  support: {
    liveSupport: 'Élő support',
    response: 'Munkaidőben (8:00–22:00 GMT+3) általában 1 percen belül válaszolunk',
    founder: 'Denys Bilozor',
    ceo: 'Alapító és vezérigazgató (CEO) a UniLinknél',
  },
  wizard: {
    createNewProfile: 'Új profil létrehozása',
    createProfile: 'Profil létrehozása',
    continue: 'Folytatás',
    tellUs: 'Mesélj magadról',
    addSocialLinks: 'Add hozzá az összes közösségi hálót, mi megjelenítjük az adatbázisodban',
    addMoreLinks: 'További linkek hozzáadása',
    addLink: 'Link hozzáadása',
    selectCategory: 'Válassz egy kategóriát, amely legjobban leír téged:',
    chooseTemplate: 'Válassz sablont',
    skip: 'Kihagyás',
    step: 'Lépés',
    of: '/',
    yourName: 'Neved',
    search: 'Keresés',
    blog: 'Blog',
    creator: 'Alkotó',
    music: 'Zene',
    events: 'Események',
    esoteric: 'Ezotéria',
    fashion: 'Divat',
    influencer: 'Influenszer',
    food: 'Étel',
    smallBusiness: 'Kisvállalkozás',
    marketing: 'Marketing',
    education: 'Oktatás',
    socialMedia: 'Közösségi média',
    coaching: 'Coaching',
    ecommerce: 'E-kereskedelem',
    healthAndFitness: 'Egészség és fitnesz',
    beautyWellness: 'Szépség és wellness',
  },
  billing: {
    back: 'Vissza',
    findPlan: 'Találd meg a neked megfelelő csomagot',
    changeAnytime: 'Bármikor módosíthatod.',
    subtitle: 'Frissítsd, csökkentsd vagy mondd le bármikor.',
    currentPlan: 'Jelenlegi csomag',
    mostPopular: 'Legnépszerűbb',
    upgradeTo: 'Frissítés {plan} csomagra',
    includes: 'Tartalmazza:',
    everythingIn: 'Minden, amit a {plan} tartalmaz, plusz:',
    secure: 'A fizetések a PCI DSS szabványnak megfelelően vannak védve.',
  },
  field: {
    fullName: 'Teljes név',
    username: 'felhasználónév',
    addValue: 'Érték hozzáadása',
    newValue: 'Új érték',
    placeholderDefault: 'Szöveg, számok, szimbólumok stb.',
    addInstagramUsername: 'Instagram felhasználónév hozzáadása',
    nameDefault: 'Jhon',
    enterYourLink: 'Add meg a linkedet',
    searchImage: 'Kép keresése',
    pasteLink: 'Link beillesztése',
    pasteLinkTip: 'Adj hozzá egy linket bármely weboldalra',
    searchGIFs: 'GIF keresése',
    searchIcons: 'Ikon keresése',
    searchVideo: 'Videó keresése',
    search: 'Keresés',
    insertURL: 'URL beszúrása',
    writeYourDescription: 'Írd meg a leírásod',
    headerCTAbutton: 'Fejléc, CTA gomb',
    enterTitle: 'Add meg a címet',
    enterDescription: 'Add meg a leírást',
    enterURL: 'Add meg a kanonikus URL-t',
  },
  tooltip: {
    addImage: 'Kép hozzáadása',
    labelModalTitle: 'Címke beállítások',
    addLabel: '+ Címke hozzáadása',
    label: 'Címke',
    labelCaption: 'Add meg a címkét',
    labelText: 'Címke szövege',
    labelTextCaption: 'Add meg a címke szövegét',
    labelTextPlaceholder: 'Címke',
    labelUrl: 'Címke URL-je',
    labelUrlCaption: 'Add meg a címke URL-jét',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Nincs címke',
    colorFrom: 'Szín innen',
    colorTo: 'Szín ide',
    highlight: 'Kiemelés',
    firstName: 'Keresztnév',
    firstNameCaption: 'Add meg a keresztneved',
    lastName: 'Vezetéknév',
    lastNameCaption: 'Add meg a vezetékneved',
    jobTitle: 'Beosztás',
    jobTitleCaption: 'Add meg a beosztásod',
    organization: 'Szervezet',
    organizationCaption: 'Add meg a szervezeted',
    email: 'E-mail',
    emailCaption: 'Add meg az e-mail címed',
    workPhone: 'Munkahelyi telefon',
    workPhoneCaption: 'Add meg a munkahelyi telefonszámod',
    mobilePhone: 'Mobiltelefon',
    mobilePhoneCaption: 'Add meg a mobiltelefonszámod',
    website: 'Weboldal',
    websiteCaption: 'Add meg a weboldalad',
    information: 'Információ',
    informationCaption: 'Add meg az információt',
    streetAddress: 'Utca, házszám',
    streetAddressCaption: 'Add meg a lakcímed',
    city: 'Város',
    cityCaption: 'Add meg a városod',
    state: 'Megye/állam',
    stateCaption: 'Add meg a megyédet/államodat',
    postalCode: 'Irányítószám',
    postalCodeCaption: 'Add meg az irányítószámod',
    country: 'Ország',
    countryCaption: 'Add meg az országod',
    titleColor: 'Cím színe',
    titleColorCaption: 'Módosíthatod a cím színét',
    fontFamily: 'Betűtípus',
    fontFamilyCaption: 'Módosíthatod a betűtípust',
    fontSize: 'Betűméret',
    fontSizeLabel: 'Címke betűmérete',
    fontSizeCaption: 'Módosíthatod a betűméretet',
    fontSelect: 'Betűtípus',
    fontSelectCaption: 'Válassz betűtípust',
    imageMargin: 'Kép margója',
    profilePicture: 'Profilkép',
    profilePictureCaption: 'Módosítsd a profilképed',
    pictureSize: 'Kép mérete',
    pictureSizeCaption: 'Módosíthatod a kép méretét',
    title: 'Cím',
    titleCaption: 'Add meg a címet',
    blockCaption: 'Add meg a blokk címét',
    titlePageCaption: 'Add meg az oldal címét',
    templates: 'Sablonok',
    templatesCaption: 'Válassz sablont az oldaladhoz',
    myTemplates: 'Sablonjaim',
    myTemplatesEmpty: 'Még nincs sablonod. Mentsd el a jelenlegi oldal dizájnját, hogy később újra felhasználhasd.',
    saveAsTemplate: 'Mentés sablonként',
    saveCurrentAsTemplate: 'Jelenlegi mentése sablonként',
    templateSaved: 'Sablon mentve',
    templateApplied: 'Sablon alkalmazva',
    buildFromReference: 'Építés referenciából',
    templateAppliedCount: 'Sablon alkalmazva — {n} blokk hozzáadva',
    searchTemplates: 'Sablonok keresése…',
    favorites: 'Kedvencek',
    previewLive: 'Élő előnézet',
    previewingTemplate: 'Előnézet',
    exitPreview: 'Kilépés',
    templateKind: 'Mit tartalmazzon',
    publish: 'Közzététel',
    unpublish: 'Közzététel visszavonása',
    templatePublished: 'Sablon közzétéve',
    templateUnpublished: 'Sablon közzététele visszavonva',
    discoverTemplates: 'Közösség felfedezése',
    discoverSubtitle: 'Más alkotók által közzétett ingyenes sablonok a UniLinken.',
    discoverEmpty: 'Még nincs nyilvános sablon — legyél az első, aki közzétesz egyet.',
    pricing: 'Árazás',
    background: 'Háttér',
    backgroundColor: 'Háttérszín',
    textBackground: 'Szöveg háttere',
    textBackgroundCaption: 'Válassz szöveghátteret',
    textColor: 'Szövegszín',
    textColorCaption: 'Válassz szövegszínt',
    gradientBackground: 'Színátmenetes háttér',
    gradientColor: 'Színátmenet színe',
    BackgroundType: 'Típus',
    backgroundSource: 'Háttér forrása',
    backgroundSourceCaption: 'Válassz háttérforrást',
    backgroundStyle: 'Háttér stílusa',
    backgroundStyleCaption: 'Válassz háttérstílust',
    backgroundStylesNormal: 'Normál',
    backgroundStylesGlass: 'Üveg',
    backgroundStylesOutline: 'Körvonal',
    backgroundTypeCaption: 'Válassz háttértípust',
    color: 'Szín',
    colorTooltip: 'Módosíthatod a színt',
    backgroundOpacityTooltip: 'Húzd a csúszkát a háttér átláthatóságának beállításához',
    backgroundBlur: 'Háttér elmosása',
    backgroundBlurCaption: 'Húzd a csúszkát a háttér elmosásához',
    backgroundBrightness: 'Háttér fényereje',
    backgroundBrightnessCaption: 'Húzd a csúszkát a háttér fényerejének módosításához',
    backgroundContrast: 'Háttér kontrasztja',
    backgroundContrastCaption: 'Húzd a csúszkát a háttér kontrasztjának módosításához',
    color1: '1. szín',
    color2: '2. szín',
    colorCaption: 'Add meg az oldalad színét',
    gradient: 'Színátmenet',
    image: 'Kép',
    photo: 'Fotó',
    gif: 'GIF',
    animation: 'Animáció',
    video: 'Videó',
    hexColor: 'Hex szín',
    direction: 'Irány',
    gradientDirection: 'Színátmenet iránya',
    directionCaption: 'Húzd a csúszkát a színátmenet irányának beállításához',
    offset: 'Eltolás',
    gradientOffset: 'Színátmenet eltolása',
    offsetCaption: 'Húzd a csúszkát a színátmenet eltolásának beállításához',
    backgroundDarkness: 'Háttér sötétítése',
    backgroundDarknessCaption: 'Húzd a csúszkát a háttérkép sötétítéséhez',
    uploadVideo: 'Videó feltöltése',
    uploadFile: 'Fájl feltöltése',
    uploadVideoCaption: 'Az oldalad hátterének videója',
    linkToVideo: 'Videó linkje',
    linkToVideoCaption: 'Adj hozzá videólinket',
    videoWithSound: 'Videó hanggal',
    videoWithSoundCaption: 'Videó lejátszása hanggal',
    fonts: 'Betűtípusok',
    fontRoles: {
      heading: 'Címsor',
      subtitle: 'Alcím',
      body: 'Globális',
    },
    fontWeight: 'Betűvastagság',
    fontWeightCaption: 'Kattints, és válaszd ki a sorsod',
    preloader: 'Betöltő animáció',
    preview: 'Előnézet',
    hideLogo: 'UniLink logó elrejtése',
    cover: 'Borítókép',
    coverCaption: 'Borítókép módosítása',
    coverCaptionHeader: 'Adj hozzá képet vagy videót a fejléc borítójához',
    pageNavigation: 'Oldalnavigáció',
    websiteNavigation: 'Fül navigáció',
    backgroundOpacity: 'Háttér átláthatósága',
    backgroundOpacityCaption: 'Húzd a csúszkát a gomb hátterének átláthatóságához',
    borderRadius: 'Sarok lekerekítése',
    borderRadiusCaption: 'Húzd a csúszkát a sarok lekerekítésének beállításához',
    heightTabs: 'Fülek magassága',
    heightTabsCaption: 'Húzd a csúszkát a fülek magasságának beállításához',
    backgroundShadow: 'Háttér árnyéka',
    backgroundShape: 'Háttér alakja',
    backgroundBorder: 'Háttér kerete',
    opacity: 'Átláthatóság',
    opacityCaption: 'Húzd a csúszkát az átláthatóság beállításához',
    shape: 'Alak',
    shapeCaption: 'Alak beállítása',
    text: 'Szöveg',
    textCaption: 'Add meg a szöveget',
    textSize: 'Szövegméret',
    textSizeCaption: 'Húzd a csúszkát a szövegméret beállításához',
    additionalText: 'További szöveg',
    username: 'Felhasználónév',
    currency: 'Pénznem',
    language: 'Nyelv',
    timeZone: 'Időzóna',
    websiteNiche: 'Weboldal témája',
    websiteNicheCaption: 'Add meg a weboldalad témáját',
    renameCaption: 'Blokk címének átnevezése',
    description: 'Leírás',
    descriptionCaption: 'Add meg a leírást',
    actionButton: 'Cselekvésgomb',
    actionButtonCaption: 'A CTA gomb cselekvésre motiválja a látogatókat',
    animationDirection: 'Animáció iránya',
    animationDirectionCaption: 'Válassz animáció irányt',
    buttonTitle: 'Gomb címe',
    buttonTitleCaption: 'Add meg a gomb címét',
    buttonUrl: 'Gomb URL-je',
    buttonUrlCaption: 'Az URL új ablakban nyílik meg',
    imageSize: 'Kép mérete',
    imageSizeCaption: 'Húzd a csúszkát a kép méretének beállításához',
    view: 'Nézet',
    viewCaption: 'Válassz nézetet',
    margin: 'Margó',
    marginCaption: 'Húzd a csúszkát margó hozzáadásához az elem tetejéhez és aljához',
    separateTopBottom: 'Felül / Alul',
    padding: 'Belső margó',
    paddingCaption: 'Húzd a csúszkát belső margó hozzáadásához az elem tetejéhez és aljához',
    fullWidth: 'Teljes szélesség',
    lineHeight: 'Sormagasság',
    lineHeightCaption: 'Módosíthatod a sormagasságot',
    button: 'Gomb',
    titleSize: 'Cím mérete',
    titleSizeCaption: 'Módosíthatod a cím méretét',
    titleLineHeight: 'Cím sormagassága',
    titleLineHeightCaption: 'Testreszabhatod a cím sormagasságát több dizájn lehetőségért',
    layout: 'Elrendezés',
    layoutCaption: 'Hozd létre a kívánt fejléc elrendezést',
    layoutAlign: 'Elrendezés igazítása',
    alignText: 'Szöveg igazítása',
    align: 'Igazítás',
    alignCaption: 'Válassz igazítást',
    position: 'Pozíció',
    positionCaption: 'Válassz pozíciót',
    width: 'Szélesség',
    widthCaption: 'Válassz szélességet a bannerhez',
    nameHeader: 'Név',
    nameCaption: 'Add meg a fiókod nevét',
    shortBio: 'Rövid bemutatkozás',
    shortBioCaption: 'Add meg a fiókod rövid bemutatkozását',
    externalLink: 'Külső link',
    externalLinkCaption: 'Add meg a fiókodhoz tartozó külső linket',
    location: 'Helyszín',
    locationCaption: 'Add meg a helyszíned',
    locationMap: 'Helyszín térkép',
    locationMapCaption: 'Add meg a helyszíned URL-jét',
    rightIcon: 'Jobb oldali ikon',
    rightIconCaption: 'Ez az ikon a gomb jobb oldalán jelenik meg',
    buttons: 'Gombok',
    buttonsCaption: 'Adj hozzá cselekvésgombokat',
    nameLogo: 'Név logó',
    nameLogoCaption: 'Töltsd fel a neved logóját',
    buttonText: 'Gomb szövege',
    buttonTextCaption: 'Add meg a gombod nevét',
    buttonColor: 'Gomb színe',
    buttonColorCaption: 'Válassz színt a gombhoz',
    buttonColorCTACaption: 'Válassz háttérszínt a CTA gombhoz',
    cartColor: 'Kosár színe',
    cartColorCaption: 'Válassz háttérszínt a kosárhoz',
    ctaButton: 'CTA gomb',
    ctaButtonCaption: 'Ez az ikon a gomb jobb oldalán jelenik meg',
    style: 'Stílus',
    socialIconsStyleCaption: 'Kiválaszthatod a közösségi ikonok stílusát',
    socialIconsShape: 'Közösségi ikonok alakja',
    socialIconsShapeCaption: 'Kiválaszthatod a közösségi ikonok alakját',
    headerTextColorCaption: 'Kiválaszthatod a fejléc szövegszínét',
    pictureShape: 'Kép alakja',
    pictureShapeCaption: 'Kiválaszthatod a profilkép alakját',
    socialLinks: 'Közösségi linkek',
    socialLinksCaption: 'Adj hozzá közösségi link gombokat a gyors kapcsolatfelvételhez az ügyfeleiddel egy kattintással',
    URL: 'URL',
    URLCaption: 'Add meg az URL-címet',
    heading: 'Címsor',
    headingTitle: 'Címsor címe',
    headingTitleCaption: 'Add meg a címsor címét',
    headingDescription: 'Címsor leírása',
    headingDescriptionCaption: 'Add meg a címsor leírását',
    headingImage: 'Címsor képe',
    headingImageCaption: 'Töltsd fel a címsorhoz tartozó képet',
    headingPosition: 'Címsor pozíciója',
    headingInsideBlock: 'Blokkon belül',
    headingOutsideBlock: 'Blokkon kívül',
    headingDivider: 'Címsor elválasztó',
    canonicalURL: 'Kanonikus URL',
    seo: 'SEO',
    seoCaption: 'Szabd testre a terméked SEO meta tagekkel',
    themes: 'Témák',
    brandColors: 'Brand Kit',
    applyBrandColors: 'Alkalmazás a profilra',
    syncBlocks: 'Összes blokk szinkronizálása',
    brandColorsApplied: 'Márkaszínek alkalmazva',
    generatedPalette: 'Generált paletta',
    applying: 'Alkalmazás...',
    syncing: 'Szinkronizálás...',
    backgroundType: 'Háttér típusa',
    palettes: 'Paletták',
    previewTitle: 'Cím',
    previewTitleCaption: 'Add meg az előnézet címét',
    previewDescription: 'Leírás',
    previewDescriptionCaption: 'Add meg az előnézet leírását',
    previewButton: 'Gomb szövege',
    previewButtonCaption: 'Add meg az előnézet gombjának szövegét',
    previewLabel: 'Címke szövege',
    previewLabelCaption: 'Add meg az előnézet címkéjének szövegét',
    previewThumbnail: 'Miniatűr',
    previewThumbnailCaption: 'Töltsd fel az előnézet miniatűrjét',
  },
  table: {
    clicks: 'Kattintások',
    signups: 'Regisztrációk',
    views: 'Megjelenítések',
    orderNumber: 'Rendelésszám',
    amount: 'Összeg',
    credits: 'Kreditek',
    invoice: 'Számla',
    email: 'E-mail',
    card: 'Kártya',
    currency: 'Pénznem',
    name: 'Név',
    contact: 'Kapcsolat',
    optIn: 'Hozzájárulás',
    notes: 'Megjegyzések',
    address: 'Cím',
    date: 'Dátum',
    action: 'Művelet',
    custom: 'Egyéni',
    status: 'Állapot',
    tags: 'Címkék',
    view: 'Megtekintés',
    remove: 'Eltávolítás',
    sendEmail: 'E-mail küldése',
    details: 'Részletek',
    purchases: 'Vásárlások',
    order: 'Rendelés',
    money: 'Összeg',
    type: 'Típus',
    orderCode: 'Rendelési kód',
  },
  settings: {
    title: 'Beállítások',
    settings: 'beállítások',
    accountSettings: 'Fiókbeállítások',
    email: 'E-mail',
    subscription: 'Előfizetés',
    billingHistory: 'Számlázási előzmények',
    dueTo: 'Esedékes',
    subscriptionDueTo: 'Előfizetés esedékes',
    accountLabel: 'Fiók',
    profileLabel: 'Profil',
    switchProfile: 'Profil váltása',
    createNewProfile: 'Új profil létrehozása',
    active: 'Aktív',
    currentPlan: 'Jelenlegi csomag',
    freePlanHint: 'Frissíts a Pro funkciók feloldásához és a korlátok megszüntetéséhez.',
    to: 'eddig',
    renews: 'Megújul',
    passwordChangeDesc: 'Módosítsd a fiókod jelszavát',
    apiKeyDesc: 'Használd ezt a kulcsot az API kérések hitelesítéséhez',
    apiDocumentation: 'API dokumentáció',
    dashboardLanguageDesc: 'A fiókod felhasználói felületének nyelve',
    cancelSubscription: 'Előfizetés lemondása',
    cancelSubscriptionConfirm: 'Biztosan lemondod az előfizetésed?',
    subscriptionCancelled: 'Az előfizetésed lemondva. A csomagod a számlázási időszak végéig aktív marad.',
    subscriptionCancelError: 'Nem sikerült lemondani az előfizetést. Kérjük, vedd fel a kapcsolatot az ügyfélszolgálattal.',
    deleteFirst: 'Végleges törlés:',
    deleteSecond: 'és minden hozzá tartozó adat. Ez a művelet nem vonható vissza.',
    account: {
      title: 'Fiók',
      usernameNotAvailable: 'A felhasználónév nem elérhető',
      setupCustomDomain: 'Egyéni domain beállítása',
      subtitle: 'Fiók e-mail, számlázás, jelszó és API kulcs',
    },
    profile: {
      title: 'Profil',
      usernameNotAvailable: 'A felhasználónév nem elérhető',
      setupCustomDomain: 'Egyéni domain beállítása',
      subtitle: 'Felhasználónév, nyelv, pénznem, időzóna kezelése',
      category: 'Kategória',
      categoryCaption: 'Add meg a profilod kategóriáját',
      usernameDesc: 'A nyilvános felhasználóneved',
      currencyDesc: 'Bevételekhez és kifizetésekhez használt',
      languageDesc: 'A látogatóidnak megjelenő nyelv',
      timeZoneDesc: 'Ütemezéshez és analitikához',
      categoryDesc: 'Ez írja le legjobban a profilod',
      privateProfile: 'Privát profil',
      privateProfileDesc: 'Csak a jóváhagyott követők láthatják a profilod',
    },
    aiassistant: {
      title: 'AI asszisztens',
      subtitle: 'Szabd testre az AI asszisztensedet jobb, személyre szabottabb válaszokért',
      titleText: 'Segíts az AI-nak megérteni, ki vagy, a relevánsabb válaszokért',
      customAiTitle: 'Egyéni utasítások',
      customAiPlaceholder: 'Adj hozzá bármilyen konkrét utasítást az AI számára...',
      customAiDescription: 'Ezek az utasítások minden AI-val folytatott beszélgetésre vonatkoznak',
      nicknameTitle: 'Hogyan szólítson téged az AI?',
      nicknamePlaceholder: 'Becenév',
      titleBio: 'Bemutatkozás / Leírás',
      bioPlaceholder: 'Mondj el pár szót magadról...',
      occupation: 'Mivel foglalkozol?',
      occupationPlaceholder: 'pl. Mérnökhallgató a Waterloo Egyetemen',
      aboutYouTitle: 'Rólad',
      aboutYouTooltip: 'Mondj el az AI asszisztensednek egy kicsit magadról',
      locationTitle: 'Helyszín',
      locationPlaceholder: 'pl. Kyiv, Ukrajna',
      categoryTitle: 'Kategória',
    },
    notifications: {
      title: 'Értesítések',
      subtitle: 'Állítsd be az értesítéseket új látogatói e-mailekről és rendelésekről',
      text: 'Csatlakoztass üzenetküldő alkalmazásokat, hogy értesítést kapj az ügyfelek e-mailjeiről és rendeléseiről',
      setUpWebhooks: 'Állítsd be a webhookokat a Webhookok szekcióban',
      save: 'Mentés',
      connect: 'CSATLAKOZÁS',
      disconnect: 'KAPCSOLAT BONTÁSA',
      webhook: 'Webhook',
      emailSubmit: 'Adatgyűjtés beküldése',
      formSubmit: 'Űrlap beküldése',
      showSubmit: 'Bolt beküldése',
      digitalSubmit: 'Digitális termék beküldése',
      appointmentSubmit: 'Időpont beküldése',
      requestSubmit: 'Szolgáltatás beküldése',
      donationSubmit: 'Adomány beküldése',
      email: 'E-mail',
      settings: 'beállítások',
      cartSubmit: 'Kosár beküldése',
      linkClick: 'Linkre kattintás',
      contactClick: 'Kapcsolatra kattintás',
      all: 'Összes',
      updates: 'Frissítések',
      messages: 'Üzenetek',
      opportunities: 'Lehetőségek',
      insights: 'Elemzések',
      activity: 'Aktivitás',
      system: 'Rendszer',
      news: 'Hírek',
      more: 'Több megjelenítése',
      less: 'Kevesebb megjelenítése',
      connectedAccounts: 'Csatlakoztatott fiókok',
      addEmailAccount: 'E-mail fiók hozzáadása',
    },
    paymentSystem: {
      title: 'Fizetési rendszer',
      subtitle: 'Állítsd be a kifizetéseket Stripe vagy PayPal segítségével',
      text: 'Feldolgozási díjak megtekintése',
      connected: 'Csatlakoztatva',
      active: 'Fizetések elfogadása a weboldalon',
      pending: 'Folyamatban',
      disconnect: 'Kapcsolat bontása',
      connect: 'Csatlakoztatás',
      add: 'Hozzáadás',
      ofYourAccount: 'a fiókodból',
      save: 'Mentés',
    },
    manualPayments: {
      title: 'Manuális / offline fizetések',
      hint: 'Az ügyfelek offline fizetnek (bankátutalás, készpénz, QR). A rendelést manuálisan erősíted meg.',
      save: 'Mentés',
      iban: 'IBAN',
      accountHolder: 'Számlatulajdonos neve',
      bankName: 'Bank neve',
      phone: 'Telefon',
      payeeName: 'Kedvezményezett neve',
      instruction: 'Utasítás',
      instructionHint: 'Formázás: **félkövér** ~áthúzott~ _dőlt_',
      requireProof: 'Fizetési igazolás megkövetelése',
      requireProofHint: 'A megrendelés véglegesítéséhez az ügyfeleknek fel kell tölteniük egy képernyőképet (nyugta, átutalási visszaigazolás vagy bármilyen fizetési igazolás).',
      markPaidOnConfirm: 'Megjelölés kifizetettként az ügyfél megerősítésekor',
      markPaidOnConfirmHint: 'Automatikusan „Kifizetve” állapotra állítja a fizetési státuszt, amint az ügyfél megerősíti a fizetést.',
      contactBeforePay: 'Eladóval való kapcsolatfelvétel engedélyezése fizetés előtt',
      contactBeforePayHint: 'Lehetővé teszi, hogy az ügyfelek fizetés helyett üzenetet küldjenek az eladónak — több megkeresés, de nagyobb bizalom és kevesebb lemondás.',
    },
    shop: {
      title: 'Bolt',
      subtitle: 'Kategória és tulajdonság beállítása',
      label: {
        title: 'Címkék',
        subtitle: 'Címkék hozzáadása a termékkártyákhoz',
        addValue: 'Érték hozzáadása',
        save: 'Mentés',
        value: 'Érték',
        enterTitle: 'Add meg a címet',
        maximum: 'Legfeljebb 5 érték adható meg',
        add: 'Hozzáadás',
        edit: 'Szerkesztés',
        labels: 'Címkék',
      },
      category: {
        title: 'Kategóriák',
        subtitle: 'Kategória hozzáadása a termékeidhez',
        addCategory: 'Kategória hozzáadása',
        save: 'Mentés',
        maximum: 'A maximális szám',
        editTitle: 'Kategória',
        name: 'Név',
        namePlaceholder: 'Add meg a kategóriát',
        visibility: 'Láthatóság',
        visible: 'Látható',
        hidden: 'Rejtett',
        description: 'Leírás',
        descriptionHint: 'A leírás legfeljebb 100 karakter lehet',
        descriptionPlaceholder: 'Adj hozzá egy rövid leírást',
        cover: 'Borítókép',
        view: 'Megnyitás',
        share: 'Megosztás',
        linkCopied: 'Link vágva',
        saveFirst: 'Először mentsd el a kategóriát',
        moveOut: 'Kiemelés',
      },
      property: {
        title: 'Tulajdonság',
        subtitle: 'Tulajdonság hozzáadása a termékeidhez',
        addProperties: 'Tulajdonságok hozzáadása',
        properties: 'Tulajdonságok',
        type: 'Típus',
        typeTooltip: 'A tulajdonságaid típusa',
        titleModal: 'Cím',
        titleModalTooltip: 'A tulajdonságaid neve',
        enterTitle: 'Add meg a címet',
        value: 'Érték',
        addValue: 'Érték hozzáadása',
        maximum: 'Legfeljebb ennyi érték adható meg',
        save: 'Mentés',
        cancel: 'Mégse',
        remove: 'Eltávolítás',
        addPropertyToItem: 'Tulajdonság hozzáadása a tételhez',
        add: 'Hozzáadás',
        edit: 'Szerkesztés',
        propertiesSmall: 'tulajdonság',
        required: 'Kötelező',
        requiredTooltip: 'Kötelező tulajdonságok megadása vásárláshoz',
        selectAll: 'Összes kijelölése',
      },
      preorderForm: {
        title: 'Előrendelési űrlap',
        subtitle: 'Az előrendelési űrlap mezőinek beállítása',
        fields: 'Mezők',
        fieldsTooltip: 'Mezők hozzáadása az űrlaphoz',
        required: 'Kötelező',
        submitButton: 'Beküldés gomb felirata',
        redirectUrl: 'Átirányítási URL (opcionális)',
        resultText: 'Eredmény szövege',
        save: 'Mentés',
        name: 'Név',
        emailAddress: 'E-mail cím',
        phone: 'Telefon',
        address: 'Cím',
        comment: 'Megjegyzés',
      },
      shipping: {
        title: 'Ügyfél adatai',
        subtitle: 'A vásárlótól fizetéskor kért mezők',
        fields: 'Mezők',
        fieldsTooltip: 'Mezők hozzáadása a fizetési űrlaphoz',
        required: 'Kötelező',
        save: 'Mentés',
        name: 'Név',
        emailAddress: 'E-mail cím',
        phone: 'Telefon',
        address: 'Cím',
        comment: 'Megjegyzés',
        addCustomField: 'Egyéni mező hozzáadása',
        addFormInfo: 'Űrlapinfó hozzáadása',
        editFormInfo: 'Űrlapinfó szerkesztése',
        type: 'Típus',
        typeTooltip: 'Egyéni mező típusa',
        fieldName: 'Mező neve',
        fieldNameTooltip: 'Az egyéni mező neve',
        placeholder: 'Helyőrző szöveg',
        placeholderTooltip: 'Az egyéni mező helyőrző szövege',
        delete: 'Törlés',
        update: 'Frissítés',
        add: 'Hozzáadás',
      },
      delivery: {
        title: 'Szállítási módok',
        subtitle: 'Állítsd be a szállítást, a helyi kiszállítást és az önátvételt a boltodhoz.',
        loading: 'Betöltés…',
        inactive: 'inaktív',
        confirmDelete: 'Törlöd ezt a szállítási módot?',
        category: {
          shipping: 'Szállítás',
          localDelivery: 'Helyi kiszállítás',
          selfPickup: 'Önátvétel',
        },
        rateType: {
          free: 'Ingyenes',
          conditionalFree: 'Feltételesen ingyenes',
          flatRate: 'Fix díj',
          customRates: 'Egyéni díjak',
          carrierApi: 'Futárszolgálat API',
        },
        carrier: {
          custom: 'Egyéni futárszolgálat',
        },
        add: {
          shipping: 'Szállítás hozzáadása',
          localDelivery: 'Helyi kiszállítás hozzáadása',
          selfPickup: 'Önátvétel hozzáadása',
        },
        actions: {
          edit: 'Szerkesztés',
          delete: 'Törlés',
          save: 'Mentés',
          cancel: 'Mégse',
        },
        fields: {
          name: 'Név',
          namePh: 'pl. Standard szállítás',
          description: 'Leírás',
          isActive: 'Aktív',
          estimatedDays: 'Becsült napok száma',
          currency: 'Pénznem',
          countryCodes: 'Országkódok (CSV)',
          carrier: 'Futárszolgálat',
          rateType: 'Díjtípus',
          flatPrice: 'Fix ár',
          freeThreshold: 'Ingyenes eddig (végösszeg)',
          fallbackPrice: 'Alapértelmezett ár',
          customRates: 'Egyéni díjsorok',
          senderCity: 'Feladó városának neve',
          senderCityRef: 'Feladó városának hivatkozása',
          pickupInstructions: 'Átvételi útmutató',
          pickupCharge: 'Átvételi díj',
          askPickupDateTime: 'Átvételi dátum/idő kérése fizetésnél',
        },
        rateRow: {
          subtotal: 'Végösszeg szerint',
          weight: 'Súly szerint (g)',
          min: 'Min',
          max: 'Max',
          price: 'Ár',
          add: 'Sor hozzáadása',
        },
      },
      legal: {
        title: 'Jogi dokumentumok',
        subtitle: 'ÁSZF, Adatvédelem, Visszaküldési szabályzat — az ügyfeleknek fizetéskor megjelenítve.',
        loading: 'Betöltés…',
        empty: 'Még nincs jogi dokumentum.',
        inactive: 'inaktív',
        required: 'kötelező',
        confirmDelete: 'Törlöd ezt a dokumentumot?',
        addNew: '+ Dokumentum hozzáadása',
        types: {
          terms: 'Általános Szerződési Feltételek',
          privacy: 'Adatvédelmi Szabályzat',
          returns: 'Visszaküldési / Visszatérítési Szabályzat',
          shipping: 'Szállítási Szabályzat',
          cookies: 'Cookie Szabályzat',
          custom: 'Egyéni',
        },
        fields: {
          title: 'Cím',
          titlePh: 'pl. Általános Szerződési Feltételek',
          type: 'Dokumentum típusa',
          content: 'Tartalom',
          contentPh: 'Írd ide a jogi szöveget…',
          isActive: 'Aktív',
          requireAcceptance: 'Elfogadás kötelező a fizetésnél',
        },
        actions: {
          edit: 'Szerkesztés',
          delete: 'Törlés',
          save: 'Mentés',
          cancel: 'Mégse',
        },
      },
      checkoutGroup: 'Fizetés',
      serviceCharge: {
        title: 'Szolgáltatási díj',
        subtitle: 'Adj hozzá szolgáltatási díjat vagy borravalót minden rendeléshez.',
        label: 'Leírás',
        labelPh: 'pl. Szolgáltatási díj 5% és szállítási borravaló 3 $',
        rate: 'Díjkulcs',
        rateHint: 'A rendelés végösszegének százaléka.',
        amount: 'Összeg',
        amountHint: 'Fix összeg, ami hozzáadódik.',
      },
      tip: {
        title: 'Borravaló',
        subtitle: 'Engedd meg, hogy az ügyfelek borravalót adjanak fizetéskor.',
        enable: 'Borravaló engedélyezése',
        presets: 'Borravaló-beállítások (%)',
        noPresets: 'Még nincs beállítás — adj hozzá egyet lent.',
        presetPh: 'pl. 10',
        addPreset: '+ Beállítás hozzáadása',
        presetsHint: 'Gyorsválasztó gombként jelenik meg fizetésnél. Legfeljebb 6.',
        remove: 'Eltávolítás',
        allowCustom: 'Egyéni összeg engedélyezése',
        label: 'Felirat szövege',
        labelPh: 'pl. Adj borravalót a kiváló szolgáltatásért',
        save: 'Mentés',
        saving: 'Mentés…',
      },
      orderNumber: {
        title: 'Rendelésszám',
        subtitle: 'Testreszabhatod a rendelésszámok megjelenését.',
        next: 'Következő rendelésszám',
        prefix: 'Előtag',
        suffix: 'Utótag',
        showInMessage: 'Megjelenítés a számlán és a rendelési üzenetben',
        reset: 'Rendelésszám visszaállítása',
      },
      orderMessage: {
        title: 'Rendelési üzenet',
        subtitle: 'Testreszabhatod az ügyfeleknek küldött rendelés-visszaigazolást.',
        footer: 'Üzenet lábjegyzete',
        footerPh: 'pl. Köszönjük a rendelést! Kövess minket: @yourbrand',
        footerHint: 'Minden rendelés-visszaigazoláshoz hozzáfűződik.',
        plain: 'Egyszerű szöveges üzenet',
        plainHint: 'Minden formázás eltávolítása a rendelési üzenetből.',
      },
      invoice: {
        title: 'Számla',
        subtitle: 'Márkázott számla a kifizetett rendelésekhez.',
        upgrade: 'Frissítés',
        showLogo: 'Logó megjelenítése',
        header: 'Fejrész',
        footer: 'Lábjegyzet',
        companyName: 'Cégnév',
        companyEmail: 'Cég e-mail címe',
        companyPhone: 'Cég telefonszáma',
        companyAddress: 'Cég címe',
        companyAddressPh: 'Add meg a címet',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Testreszabhatod az oldaladat SEO meta tagekkel',
      titleText: 'Cím',
      titlePlaceholder: 'Add meg az oldal címét',
      description: 'Leírás',
      descriptionPlaceholder: 'Add meg az oldal leírását',
      favicon: 'Favicon',
      uploadFavicon: 'Favicon feltöltése',
      imagePreview: 'Kép előnézete',
      useCustom: 'Egyéni kép használata',
      save: 'Mentés',
      visualise: 'Nézd meg, hogy nézne ki a weboldalad előnézete a Google-ben',
      inMessengers: 'Üzenetküldőkben',
      inSocial: 'Közösségi médiában',
      searchEngine: 'Keresőmotor',
      googleIndexable: 'Google által indexelhető',
      sitemap: {
        title: 'Oldaltérkép',
        entryHint: 'Kezeld, mely oldalakat és termékeket indexelhetik a keresőmotorok.',
        setupLink: 'testreszabás',
        mainEntry: 'Weboldal indexelése',
        subtitle: 'Válaszd ki, mely oldalakat indexeljék a keresőmotorok. A letiltott oldalak noindex tag-et kapnak és kikerülnek az oldaltérképből.',
        mainPage: 'Fő profiloldal',
        pagesSection: 'Oldalak',
        pagesHint: 'Kapcsold be/ki az indexelést az oldalad minden további oldalára.',
        noPages: 'Még nincs további oldal.',
        productsSection: 'Termékek',
        productsHint: 'Kapcsold be/ki az indexelést az egyes termékoldalakra.',
        noProducts: 'Még nincs termék.',
        postsSection: 'Bejegyzések',
        postsHint: 'Kapcsold be/ki az indexelést az egyes bejegyzésekre.',
        noPosts: 'Még nincs bejegyzés.',
        blogSection: 'Blogcikkek',
        blogHint: 'Kapcsold be/ki az indexelést az egyes blogcikkekre.',
        noArticles: 'Még nincs blogcikk.',
        loadMore: 'Továbbiak betöltése',
        loading: 'Betöltés…',
      },
    },
    analytics: {
      title: 'Analitika',
      subtitle: 'Integráld a Facebook Pixelt, a Google Analyticset és UTM paramétereket',
      facebookTooltip: 'Csatlakoztasd a Facebookot az analitika megjelenítéséhez',
      googleAnalyticsTooltip: 'A Google Analytics segítségével mérheted a hirdetéseid megtérülését, és nyomon követheted az összes linkedet.',
      googleTagManagerTooltip: 'A Google Tag Manager segítségével beállíthatod és azonnal telepítheted a tag-eket a weboldaladra',
      tikTokPixelTooltip: 'A TikTok Pixel egy erőteljes mérőeszköz, amely nyomon követi a TikTok hirdetéseid hatását a weboldaladon',
      pinterestTag: 'Pinterest tag',
      pinterestTagTooltip:
        'A Pinterest tag egy kódrészlet, amelyet hozzáadsz a weboldaladhoz, így a Pinterest nyomon követheti a látogatókat és az általuk tett műveleteket, miután megtekintették a Pinterest hirdetésedet.',
      tag: 'tag',
      headerTagTooltip: 'Illeszd be a tag-et, amely a weboldalad fejrészében jelenik meg',
      bodyTagTooltip: 'Illeszd be a tag-et, amely a weboldalad törzsében jelenik meg',
      utmParameters: 'UTM paraméterek',
      utmParametersTooltip: 'Gyűjts kampányadatokat egyéni URL-ekkel. Adj paramétereket az URL-ekhez, hogy azonosítsd a forgalmat hozó kampányokat.',
      makeAnalytics: 'A Google Analytics jelenítse meg a UniLink forgalmat közösségi médiaként',
      the: 'A',
      campaign: 'campaign',
      parameter: 'paraméter dinamikusan az egyes bejegyzések vagy linkek címéből áll össze',
      save: 'Mentés',
    },
    customDomain: {
      title: 'Egyéni domain',
      subtitle: 'Testreszabhatod az oldaladat egyéni domainnel',
      titleTooltip: 'Egyéni domain hozzáadása',
      save: 'Mentés',
      connect: 'Csatlakozás',
      connecting: 'Csatlakozás',
      instructions: 'Útmutató',
      submit: 'Beküldés',
      submitting: 'Beküldés...',
      enterDomain: 'Add meg a domainedet',
      domainPlaceholder: 'sajat-domain.com',
      steps: {
        submitting: 'Kérés beküldése',
        validation: 'Domain érvényesítése',
        certificate: 'Tanúsítvány kiállítása',
        complete: 'Kész',
      },
      txtRecord: {
        title: 'TXT rekord',
        description: 'Add hozzá a következő TXT rekordot a DNS beállításaidhoz:',
        verifyButton: 'TXT rekord ellenőrzése',
        verifying: 'Ellenőrzés...',
        verified: 'TXT rekord ellenőrizve',
      },
      cnameRecord: {
        title: 'CNAME rekord',
        description: 'Add hozzá a következő CNAME rekordot a DNS beállításaidhoz:',
        verifyButton: 'CNAME rekord ellenőrzése',
        verifying: 'Ellenőrzés...',
        verified: 'CNAME rekord ellenőrizve',
      },
      dnsTable: {
        type: 'Típus',
        host: 'Host',
        value: 'Érték',
        ttl: 'TTL',
        copy: 'Másolás',
        copied: 'Kimásolva!',
      },
      provisioning: {
        title: 'SSL tanúsítvány kiállítása folyamatban...',
        description: 'Ez néhány percet is igénybe vehet. Kérünk, várj.',
        timeout: 'A tanúsítvány kiállítása tovább tart, mint várt. Nézz vissza később.',
      },
      complete: {
        title: 'A HTTPS sikeresen bekapcsolva a domainedhez.',
        connected: 'Csatlakoztatva',
      },
      failed: {
        title: 'A domain csatlakozása sikertelen',
        tryAgain: 'Próbáld újra',
      },
      rootDomainWarning: 'A gyökérdomainekhez a DNS-szolgáltatódnak támogatnia kell a CNAME flattening funkciót (pl. Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Domain leválasztása',
        message: 'Biztosan leválasztod ezt a domaint? A weboldalad többé nem lesz elérhető ezen a domainen keresztül.',
        confirm: 'Leválasztás',
        cancel: 'Mégse',
      },
    },
    developerApi: {
      title: 'Fejlesztői API',
      subtitle: 'Hozz létre API kulcsokat, hogy elérd a rendeléseidet, termékeidet és ügyfeleidet a /api/v2 végpontokon keresztül.',
      keyName: 'Kulcs neve',
      keyNamePh: 'pl. Raktár szinkron',
      scopes: 'Jogosultságok',
      scopeLabels: {
        'orders:read': 'Rendelések olvasása',
        'products:read': 'Termékek olvasása',
        'products:write': 'Termékkészlet frissítése',
        'customers:read': 'Ügyfelek olvasása',
      },
      create: 'Kulcs létrehozása',
      creating: 'Létrehozás…',
      created: 'API kulcs létrehozva',
      copyWarning: 'Másold ki most a kulcsot — nem jelenik meg újra.',
      done: 'Kész',
      revoke: 'Visszavonás',
      revoked: 'Visszavonva',
      confirmRevoke: 'Visszavonod ezt az API kulcsot? Az azt használó alkalmazások leállnak.',
      empty: 'Még nincs API kulcs.',
    },
    whatsapp: {
      title: 'WhatsApp Business',
      subtitle: 'Csatlakoztasd a WhatsApp Business számodat, hogy fogadd és megválaszold az ügyfélüzeneteket.',
      phoneNumberId: 'Telefonszám azonosító',
      accessToken: 'Hozzáférési token',
      displayPhone: 'Megjelenített telefonszám (opcionális)',
      connect: 'Csatlakozás',
      connecting: 'Csatlakozás…',
      connected: 'Csatlakoztatva',
      disconnect: 'Leválasztás',
      confirmDisconnect: 'Leválasztod a WhatsAppot?',
      webhookHelp: 'Állítsd be ezt a Callback URL-t és Verify tokent a Meta App → WhatsApp → Configuration menüben:',
      webhookUrl: 'Callback URL',
      verifyToken: 'Verify token',
      inbox: 'Beérkező üzenetek',
      noMessages: 'Még nincs üzenet.',
      selectThread: 'Válassz egy beszélgetést.',
      replyPlaceholder: 'Írj egy üzenetet…',
      send: 'Küldés',
      broadcast: {
        title: 'Körüzenet',
        audienceInbox: 'Beérkező üzenetek kontaktjai',
        audienceCrm: 'CRM közönség (sablon)',
        message: 'Üzenet',
        inboxHint: 'Szabad szöveg — csak a 24 órás ügyfélszolgálati időkereten belüli kontaktoknak kézbesítve.',
        templateName: 'Sablon neve',
        templateLang: 'Sablon nyelve',
        crmHint: 'Használj jóváhagyott WhatsApp sablont — ez szükséges a 24 órás időkereten kívüli kontaktok eléréséhez.',
        send: 'Körüzenet küldése',
        sending: 'Küldés…',
        empty: 'Még nincs körüzenet.',
        sent: 'elküldve',
        failed: 'sikertelen',
      },
      autoReply: {
        title: 'Automatikus válaszok',
        type: 'Típus',
        typeKeyword: 'Kulcsszó',
        typeGreeting: 'Köszöntés (első üzenet)',
        typeAway: 'Távollét (nyitvatartáson kívül)',
        keyword: 'Kulcsszó',
        from: 'Kezdő időpont',
        to: 'Befejező időpont',
        reply: 'Válasz szövege',
        add: 'Szabály hozzáadása',
        empty: 'Még nincs automatikus válasz szabály.',
        delete: 'Törlés',
      },
    },
    webhooks: {
      title: 'Webhookok',
      subtitle: 'Valós idejű esemény-értesítések küldése külső szolgáltatásoknak',
      webhook: 'Webhook',
      webhookTooltip: 'Webhook hozzáadása',
      send: 'Események küldése harmadik féltől való weboldalra',
      webhookUrl: 'Webhook URL (POST kérés)',
      error: 'Adj meg egy helyes linket',
      save: 'Módosítások mentése',
      enableWebhooks: 'Webhookok engedélyezése',
      enableDescription: 'POST kérések a kiválasztott eseményeknél',
      endpointUrl: 'Végpont URL',
      endpointTooltip: 'Az URL, amely POST kéréseket fogad a kiválasztott események bekövetkezésekor',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Események',
      selectAll: 'Összes kijelölése',
      deselectAll: 'Kijelölés törlése',
      filterPlaceholder: 'Események szűrése...',
      all: 'Összes',
      none: 'Semmi',
      active: 'Aktív',
      inactive: 'Inaktív',
      categories: {
        submissions: 'Beküldések',
        engagement: 'Elköteleződés',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Fejrész feliratkozás',
        SubmitHeaderMessage: 'Fejrész üzenet',
        SubmitDataCollect: 'Adatgyűjtés',
        SubmitForm: 'Űrlap beküldése',
        SubmitShop: 'Bolt rendelés',
        SubmitShopPreorder: 'Bolt előrendelés',
        SubmitDigital: 'Digitális termék',
        SubmitAppointment: 'Időpont',
        SubmitService: 'Szolgáltatás rendelés',
        SubmitEvent: 'Esemény regisztráció',
        SubmitCourse: 'Kurzus regisztráció',
        SubmitDonation: 'Adomány',
        SubmitMembership: 'Tagság',
        SubmitBlog: 'Blog vásárlás',
        SubmitCoupon: 'Kupon felhasználva',
        SubmitTip: 'Borravaló',
        SubmitLink: 'Link vásárlás',
        SubmitProductMessage: 'Termékkel kapcsolatos kérdés',
        SubmitPodcast: 'Podcast vásárlás',
        SubmitBooking: 'Foglalás',
        SubmitRental: 'Bérlés',
        SubmitSingleProduct: 'Egyedi termék',
        SubmitDiscount: 'Kedvezményes rendelés',
        SubmitListing: 'Hirdetés kérése',
        SubmitUnlock: 'Tartalom feloldása',
        SubmitChatAi: 'AI Chat üzenet',
        ClickLink: 'Link kattintás',
        ClickContact: 'Kapcsolat kattintás',
        AddToCart: 'Kosárba helyezés',
        AddToCartSingleProduct: 'Egyedi termék kosárba',
        AddToWishlist: 'Kívánságlistához adás',
        InitiateCheckout: 'Fizetés megkezdése',
        DownloadFile: 'Fájl letöltés',
        DownloadMusic: 'Zene letöltés',
        CopyCoupon: 'Kupon kimásolása',
        CopyDiscount: 'Kedvezmény kimásolása',
        QR_ScanQrCode: 'QR kód beolvasás',
        VisitPage: 'Oldal megtekintés',
      },
    },
    sensitive: {
      title: 'Érzékeny tartalom',
      subtitle: 'Érzékeny tartalomra figyelmeztető üzenet megjelenítése a weboldalad előtt',
    },
    socialIntegration: {
      title: 'Közösségimédia-integrációk',
      subtitle: 'Kezeld az Instagram és TikTok integrációidat',
      connectInstagram: 'Instagram csatlakoztatása',
    },
    emailIntegration: {
      title: 'Közönség-integrációk',
      subtitle: 'Küldd tovább a látogatóid e-mail címét a MailChimpnek, Replynek',
      emailCaption: 'Adj hozzá egy integrációt, hogy a követőid e-mail címét a MailChimpnek küldhesd',
      mailChimp: 'MailChimp integrációk',
      selzy: 'Selzy integrációk',
      selzyCaption: 'Adj hozzá egy API kulcsot, hogy a követőid e-mail címét a Selzynek küldhesd',
      sendPulse: 'SendPulse integrációk',
      sendPulseCaption: 'Adj hozzá egy API kulcsot, hogy a követőid e-mail címét a SendPulsenak küldhesd',
      reply: 'Reply integrációk',
      replyCaption: 'Adj hozzá egy API kulcsot, hogy a követőid e-mail címét elküldhesd a',
      integrations: 'integrációk',
    },
    calendarIntegration: {
      title: 'Naptár-integrációk',
      subtitle: 'Csatlakoztasd a naptárszolgáltatásaidat',
      calendly: 'Calendly',
      calendlyDescription: 'Csatlakoztasd a Calendlyt, hogy szinkronizáld az esemény-típusaidat és elérhetőségedet',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Csatlakoztasd a Google Calendart az események szinkronizálásához és Google Meet linkek létrehozásához',
      zoom: 'Zoom',
      zoomDescription: 'Csatlakoztasd a Zoomot, hogy automatikusan hozz létre találkozó-linkeket',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Google Meet linkek automatikus létrehozása (Google Calendar szükséges)',
    },
    storage: {
      title: 'Tárhely',
      subtitle: 'Mentsd a látogatók rendeléseit Google Táblázatba',
      storageCaption: 'Adj hozzá egy integrációt, hogy minden ügyfélrendelést mentsd a Google Táblázatba',
      emailSignup: 'E-mail feliratkozás',
      emailSignupsCaption: 'Válassz táblázatot az e-mail feliratkozások mentéséhez',
      formSignups: 'Űrlap feliratkozás',
      forSignupsCaption: 'Válassz táblázatot az űrlap feliratkozások mentéséhez',
      shopOrders: 'Bolt rendelések',
      shopOrderCaption: 'Válassz táblázatot a bolt rendelések mentéséhez',
      disconnect: 'Táblázat leválasztása',
      storageUsage: 'Tárhely-felhasználás',
      of: '/',
      uses: 'Ez az app',
      space: '-t használ az ingyenes tárhelyedből',
      view: 'részletek megtekintése',
      noItems: 'Nincsenek elemek',
      files: 'Fájlok',
      images: 'Képek',
      videos: 'Videók',
      audio: 'Hang',
      settings: 'beállítások',
      free: 'ingyenes',
      needMoreSpace: 'Több helyre van szükséged?',
      unlockStorage: 'Oldd fel a korlátlan tárhelyet, 4K videót',
      upgradePlan: 'Csomag frissítése',
      addFile: 'Fájl hozzáadása',
      uploading: 'Feltöltés...',
      dragDrop: 'vagy húzd ide',
      noFilesYet: 'Még nincs fájl',
      noImagesYet: 'Még nincs kép',
      noVideosYet: 'Még nincs videó',
      noAudioYet: 'Még nincs hangfájl',
      filesHint: 'Tölts fel PDF-eket, dokumentumokat és egyéb letölthető fájlokat, hogy csatold őket a bio oldalad linkjeihez.',
      imagesHint: 'Tölts fel képeket, amelyeket a bio oldaladon használhatsz.',
      videosHint: 'Tölts fel videókat, hogy beágyazd a bio oldaladba.',
      audioHint: 'Tölts fel hangfelvételeket, hogy megoszd a bio oldaladon.',
    },
  },
  productStore: {
    title: 'Bolt fül megjelenítése a link-in-bio oldaladon',
    subtitle: 'A Boltod jelenleg rejtve van.',
  },
  sections: {
    splashScreen: {
      title: 'Betöltőképernyő',
      subtitle: 'Megjelenik, amíg az oldal betöltődik',
    },
    promo: {
      title: 'Akciós sáv',
      subtitle: 'Kiemelés, amellyel megjelenítheted az akcióidat',
      masterPromoMessage: 'A Fő akciós sáv jelenleg engedélyezve van. Ha egyéni akciós sávot szeretnél létrehozni ehhez az oldalhoz, előbb ki kell kapcsolnod a Fő akciós sávot.',
      titlePlaceholder: 'Üdvözlünk a weboldalamon!',
      switcherIsMasterPromobar: 'Megjelenítés minden oldalon',
    },
    contact: {
      title: 'Kapcsolatok',
      subtitle: 'Add meg, hogyan léphetnek kapcsolatba veled',
      caption: 'Adj hozzá üzenetküldő gombokat a gyors kapcsolatfelvételhez az ügyfeleiddel egy kattintással',
      tooltip:
        'A Kapcsolatok lehetővé teszi, hogy a felhasználók közvetlenül kapcsolatba lépjenek veled. Add hozzá telefonszámodat, e-mail címedet, üzenetküldődet vagy helyszínedet',
      addNewContact: 'Új kapcsolat hozzáadása',
      addContact: 'Kapcsolat hozzáadása',
      chooseContact: 'Válassz kapcsolatot',
      enterLink: 'Add meg a kapcsolat linkjét',
      showDetails: 'Részletek megjelenítése',
      enterAnyContact: 'Adj meg legalább egy kapcsolatot',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Tagság',
      subtitle: 'Hozz létre ingyenes vagy fizetős előfizetést a tartalmadhoz',
      addNewTier: 'Új szint hozzáadása',
      editTier: 'Szint szerkesztése',
      name: 'Név',
      nameCaption: 'Add meg a szinted nevét',
      price: 'Havi ár',
      priceCaption: 'Add meg a szinted árát',
      month: 'hónap',
      image: 'Kép',
      imageCaption: 'Tölts fel képet a szintedhez',
    },
    pricing: {
      title: 'Árlista',
      subtitle: 'Hozz létre árakat tartalmazó menüt',
      add: 'Új tétel hozzáadása',
      edit: 'Tétel szerkesztése',
      name: 'Név',
      nameCaption: 'Add meg a tételed nevét',
      duration: 'Jellemző',
      durationCaption: 'Add meg a tételed idejét, mennyiségét vagy időtartamát',
      category: 'Kategória',
      categoryCaption: 'Add meg a tételed kategóriáját',
      price: 'Ár',
      priceCaption: 'Add meg a tételed árát',
      month: 'hónap',
      image: 'Kép',
      imageCaption: 'Tölts fel képet a tételedhez',
    },
    subscribe: {
      dataCollectTitle: 'Adatgyűjtés',
      title: 'Feliratkozás',
      subtitle: 'Gyűjts e-mail címeket vagy telefonszámokat a látogatóidtól',
      instructionsMessage: 'Adj hozzá egy e-mail feliratkozási mezőt az oldaladhoz, hogy a látogatóid könnyen feliratkozhassanak!',
      instructionsLink: 'Küldd tovább az e-maileket a MailChimpnek marketingkampányok futtatásához.',
      sectionHeaderCaption: 'Iratkozz fel a hírlevelünkre',
      collecting: 'Gyűjtés',
      collectingCaption: 'Válassz beviteli típust',
      addDataToCollect: 'Gyűjtendő adat hozzáadása',
      email: 'E-mail',
      enterEmail: 'Add meg az e-mail címed',
      thanksForEmail: 'Köszönjük az e-mail címedet',
      phone: 'Telefon',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Frissített linkek hozzáadása',
      placeholder: 'Helykitöltő',
      placeholderCaption: 'Add meg a helykitöltő szövegét',
      button: 'Gomb',
      buttonCaption: 'Szöveg, amely arra motiválja a látogatót, hogy megadja az e-mail címét (10% kedvezmény, feliratkozás most, fájl letöltése stb.)',
      submitButton: 'Beküldés gomb',
      enterButton: 'Belépés gomb',
      thanksMessage: 'Köszönő üzenet',
      thanksMessageCaption: 'A feliratkozóidnak szóló köszönő üzenet',
      resultAction: 'Művelet (beküldés után)',
      resultActionCaption: 'Az űrlap kitöltése utáni művelet',
      sendAnEmail: 'E-mail küldése',
      downloadFile: 'Fájl letöltése',
      redirect: 'Átirányítás',
      messageBody: 'Üzenet törzse',
      messageBodyCaption: 'Ez az adat kerül elküldésre a felhasználó e-mail címére ajándékként (kupon, letöltési link stb.)',
      integration: 'Integráció',
      integrationCaption: 'Küldd a látogatóid e-mail címét a MailChimp, Reply felé',
      storage: 'Tárolás',
      storageCaption: 'Mentsd a látogatók rendelését Google Táblázatba',
      maxSize: 'Legfeljebb 3 csatornát adhatsz hozzá',
    },
    text: {
      title: 'Szöveg',
      subtitle: 'Írj valamit magadról/a cégedről',
      trimBio: 'Szöveg csonkolása',
    },
    header: {
      title: 'Fejléc',
      subtitle: 'Nagyított kiemelt kép vagy videó az oldaladon',
      verifiedBadge: 'Hitelesített jelvény',
      showProfilePic: 'Profilkép megjelenítése',
      profilePicRatio: 'Arány',
      profilePicRatioSquare: 'Négyzet',
      profilePicRatioLandscape: 'Fekvő',
      profilePicRatioPortrait: 'Álló',
      verticalCropStep: 'álló fotó',
      squareCropStep: 'négyzet alakú profilkép',
      namePlaceholder: 'A neved',
      shortBioPlaceholder: 'Rövid bemutatkozásom',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Város',
      addSocial: '+ Közösségi hozzáadása',
      addCover: '+ Borítókép hozzáadása',
      addButton: '+ Gomb hozzáadása',
      topButtons: 'Felső gombok',
      bottomButtons: 'Alsó gombok',
      buttonSubtitleLanguage: 'Nyelvváltó',
      buttonSubtitleContact: 'Hívás / üzenet',
      buttonSubtitleCart: 'Bevásárlókosár',
      buttonSubtitleCta: 'Cselekvésre felhívás',
      buttonSubtitleMessage: 'Üzenet',
      buttonSubtitleSubscribe: 'Feliratkozás',
      buttonSubtitleQrcode: 'QR-kód',
      buttonSubtitleSearch: 'Termékkeresés',
      buttonDisabledHint: 'Rejtett · letiltva',
      addText: '+ Szöveg hozzáadása',
      addLabel: '+ Címke hozzáadása',
      subtitleName: 'Testreszabhatod a neved megjelenését',
      subtitleShortBio: 'Testreszabhatod a rövid bemutatkozásod megjelenését',
      shortBioSize: 'Rövid bemutatkozás mérete',
      subtitleShortBioSize: 'Módosíthatod a rövid bemutatkozás méretét',
      subtitleLocation: 'Állítsd be a várost/országot, hogy a látogatókat egy adott helyre irányítsd',
      headerCoverWarningMessage: 'A böngésződ nem támogatja a videó címkét.',
      headerCoverTitle: 'Állíts be borítót a fejléc fölé',
      coverHeight: 'Borító magassága',
      subtitleCoverHeight: 'Módosíthatod a borító magasságát',
      coverDarkness: 'Borító sötétítése',
      subtitleCoverDarkness: 'Húzd a csúszkát a borítókép sötétítéséhez',
      nameSize: 'Név mérete',
      subtitleNameSize: 'Módosíthatod a név méretét',
      positionText: 'Név pozíciója',
      subtitlePositionName: 'Húzd a csúszkát a név pozíciójának beállításához',
      positionContent: 'Tartalom pozíciója',
      subtitlePositionContent: 'Állítsd be a bemutatkozás, link, város pozícióját',
      coverText: 'Szöveg a borítón',
      subtitleCoverText: 'Adj szöveget a borítódhoz',
      position: 'Pozíció',
      subtitlePosition: 'Húzd a csúszkát a gomb pozíciójának beállításához',
      buttonCover: 'Gomb a borítón',
      subtitleButtonCover: 'Adj gombot a borítódhoz egy művelet kiválasztásával',
      subtitleFollow: 'A követés gomb lehetővé teszi a felhasználóknak, hogy kövessék a híreidet',
      buttonOpacity: 'Húzd a csúszkát a gomb átláthatóságának módosításához',
      subtitleCart: 'Bevásárlókosár ikon a vásárlási élmény biztosításához',
      subtitleDirect: 'Gyors gomb, amely az üzenetküldőkhöz irányítja a látogatót',
      subtitleCTAButton: '(cselekvésre felhívó) gomb, amely kattintásra motiválja a felhasználót',
      subtitleSocialLinks: 'Adj vizuális megjelenést a közösségi hálóidnak',
      chooseSocialLink: 'Válassz közösségi linket',
      alignSocialLink: 'Közösségi linkek igazítása',
      enterYourSocialLink: 'Add meg a közösségi linkedet',
      blockShadow: 'Blokk árnyék',
      activeButtonPosition: 'Aktív gomb pozíciója',
      gradientColor: 'Színátmenet színe',
      bottomGradient: 'Alsó színátmenet',
      autoGradient: 'Automatikus',
      customGradient: 'Egyéni',
      transparentGradient: 'Átlátszó',
      gradientPositionLabel: 'Árnyék pozíciója',
      gradientPositionPhoto: 'Fotó alatt',
      gradientPositionHeader: 'Lejjebb a fejlécben',
      uploadLogo: 'Logó feltöltése',
      customBackground: 'Egyéni háttér',
      headingLabel: 'Fejléc címke',
      customizeLabel: 'Testreszabhatod a fejléc címke megjelenését',
      labelText: 'Címke szövege',
      enterLabelText: 'Add meg a fejléc címke szövegét',
      bottomBadge: 'Alsó árnyalat',
      addTint: 'Árnyalat hozzáadása',
      bottomBadgeText: 'Szöveg (opcionális)',
      bottomBadgePreset: 'Előre beállított',
      bottomBadgeShape: 'Alakzat',
      bottomBadgeSize: 'Magasság',
      bottomBadgeAction: 'Művelet',
      bottomBadgeBgColor: 'Háttérszín',
      bottomBadgeTextColor: 'Szöveg színe',
      bottomBadgeGradientFrom: 'Színátmenet innen',
      bottomBadgeGradientTo: 'Színátmenet ide',
      bottomBadgeGradientAngle: 'Színátmenet szöge',
    },
  },
  billingHistory: {
    title: 'Számlázási előzmények',
    invoices: 'Számlák',
    messageText: 'Még nincs fizetési előzményed.',
  },
  migrate: {
    title: 'Van LinkTree vagy Taplink fiókod?',
    text: 'Illeszd be a linket, és költözz a UniLinkre egy kattintással!',
    button: 'Migrálás',
  },
  pages: {
    title: 'Oldalak',
    addPage: 'Oldal hozzáadása',
    addNewPage: 'Új oldal hozzáadása',
    deleteTitle: 'Biztosan törlöd ezt az oldalt?',
    managePage: 'Fülek kezelése',
    empty: 'Ennek az oldalnak még nincs blokkja.',
    dragAndDrop: 'Húzd a többi fület az átrendezéshez',
    pageNavigation: 'Oldalnavigáció beállításai',
    goToDesign: 'Ugrás a Dizájn beállításokhoz',
    viewArchive: 'Archívum megtekintése',
    archivedBlocks: 'Archivált blokkok',
    noArchivedBlocks: 'Tartsd rendben az oldalad azzal, hogy archiválod a nem használt blokkokat.',
    archiveAllUnpublished: 'Minden nem publikált blokk archiválása',
    restore: 'Visszaállítás',
    permanentDelete: 'Végleges törlés',
  },
  analytics: {
    lifeTimeAnalytics: 'Teljes idejű analitika',
    impressions: 'Megjelenítések',
    impressionsText: 'A megjelenítések statisztikájának teljesítménye a kiválasztott időszakban',
    clicks: 'Kattintások',
    clicksText: 'A „kattintás” események teljesítménye a kiválasztott időszakban',
    signUps: 'Feliratkozások',
    signUpsText: 'A „bezárás” események teljesítménye a kiválasztott időszakban',
    totalInteractions: 'Összes interakció',
    totalInteractionsText: 'Összes kattintás és feliratkozás a kiválasztott időszakban',
    engagementRate: 'Elköteleződési arány',
    engagementRateText: 'A profilmegtekintések aránya, amelyek interakcióhoz vezettek',
    visitor: 'Látogatói források',
    country: 'Ország',
    countries: 'Országok',
    linkClicks: 'Link kattintások',
    content: 'Tartalom',
    views: 'Megtekintések',
    links: 'Linkek',
    products: 'Termékek',
    blocks: 'Blokkok',
    pages: 'Oldalak',
    clicksLower: 'kattintás',
    of: '/',
    noContentData: 'Még nincs adat a kiválasztott időszakra',
  },
  aiInsights: {
    title: 'AI-elemzések',
    generate: 'Profilom elemzése',
    description: 'Szerezz AI-alapú javaslatokat a profilod teljesítményének javításához.',
    analyzing: 'Profilod elemzése...',
    refresh: 'Frissítés',
    action: 'Művelet',
  },
  post: {
    subscriptionTypePlaceholder: `Elérhető 'type' előfizetéstől kezdve`,
    postButtonText: 'Közzététel',
    newPostPlaceholder: 'Mi jár a fejedben',
    free: 'Ingyenes',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'Még nincs bejegyzésed',
    editPost: 'Bejegyzés szerkesztése',
  },
  preview: {
    buy: 'Vásárlás',
    connect: 'Csatlakozás',
  },
  activeButton: {
    initialText: 'Weboldal',
    inputPlaceholder: 'Műveletek keresése...',
    existing: 'Meglévő',
    redirect: 'Átirányítás',
    scroll: 'Görgetés',
    title: 'Aktív gomb',
    modalTitle: 'Aktív gomb művelete',
    subtitle: 'Gomb, amely cselekvésre motiválja a felhasználót',
    next: 'Következő',
    save: 'Mentés',
    opensALinkFromLinksBlock: 'Megnyit egy linket a Linkek blokkból',
    url: 'URL',
    opensAWebsite: 'Megnyit egy weboldalt',
    openInApp: 'Megnyitás az appban',
    addAction: 'Művelet hozzáadása',
    actionTitle: 'Művelet',
    actionCaption: 'Művelet típusának szerkesztése',
    chooseOption: 'Válassz egy opciót',
    tellPeople: 'Mondd meg az embereknek, hogyan lépjenek kapcsolatba a cselekvésgombbal',
    urlRedirect: 'URL átirányítás',
    customUrl: 'Egyéni URL',
    customUrlText: 'Megnyit egy weboldalt',
    links: 'Linkek',
    linksText: 'Megnyit egy linket a Linkek blokkból',
    downloadDocument: 'Dokumentum letöltése',
    sendEmail: 'E-mail küldése',
    opensEmailClient: 'Megnyitja az e-mail kliens',
    phoneCall: 'Telefonhívás',
    initiatesPhoneCall: 'Telefonhívást indít',
    navigation: 'Navigáció',
    openPage: 'Oldal megnyitása',
    opensInternalPage: 'Belső oldalt nyit meg',
    openPageText: 'Belső oldalt nyit meg',
    openProduct: 'Termék megnyitása',
    openProductText: 'Megnyitja a termékoldalt az Áruházból',
    openBlog: 'Blog megnyitása',
    opensBlogPageFromStore: 'Megnyitja a blogoldalt az Áruházból',
    openBlock: 'Blokk megnyitása',
    opensContentBlock: 'Megnyit egy tartalomblokkot',
    openItem: 'Elem megnyitása',
    opensItemPageFromStore: 'Megnyitja az elem oldalát az Áruházból',
    showNewModal: 'Új felugró ablak megjelenítése',
    displayContentInModalWindow: 'Tartalom megjelenítése felugró ablakban',
    showProduct: 'Termék megjelenítése',
    displayProductInModalWindow: 'Termék megjelenítése felugró ablakban',
    showBlog: 'Blog megjelenítése',
    scrollToBlock: 'Görgetés blokkhoz',
    scrollToBlockText: 'Görgetés a megadott oldalblokkhoz',
    scrollToItem: 'Görgetés elemhez',
    action: 'Művelet',
    showBlock: 'Blokk megjelenítése',
    showBlockText: 'Tartalomblokk az Áruházból',
    showItem: 'Elem megjelenítése',
    showItemText: 'Megnyitja az elem oldalát az Áruházból',
    linksCaption: 'Linkek',
    linksTooltip: 'Válassz linket a linkek blokkból',
    pagesCaption: 'Oldalak',
    pagesTooltip: 'Válassz oldalt az oldalak közül',
    productsCaption: 'Termékek',
    productsTooltip: 'Válassz terméket a listából',
    blocksCaption: 'Blokkok',
    blocksTooltip: 'Válassz blokkot a listából',
    itemsCaption: 'Elemek',
    itemsTooltip: 'Válassz elemet a listából',
    showProductText: 'Megjeleníti a terméket egy felugró ablakban az oldalon',
    more: 'Több megjelenítése',
    less: 'Kevesebb megjelenítése',
    showNewModalTitle: 'Új felugró ablak adatai',
    uploadDocumentTitle: 'Kattints a feltöltéshez vagy húzd ide',
    uploadProgressTitle: 'Feltöltés...',
    haveNoModal: 'Nincs felugró ablakod',
    haveModal: 'Kiválasztott felugró ablakod van',
    openNewModalHandler: 'Új felugró ablak létrehozása',
    linkGroupSubTitle: 'Válassz blokkot',
    linkItemSubTitle: 'Válassz linket',
    urlItemSubTitle: 'Weboldal URL',
    openInAppItemSubTitle: 'App URL',
    sendEmailItemSubTitle: 'E-mail cím',
    phoneCallItemSubTitle: 'Telefonszám',
    openPageGroupSubTitle: 'Válassz oldalt',
    openPageItemSubTitle: 'Válassz oldalt',
    openProductGroupSubTitle: 'Válassz terméktípust',
    openProductItemSubTitle: 'Válassz terméket',
    openBlogGroupSubTitle: 'Válassz blogcsatornát',
    openBlogItemSubTitle: 'Válassz blogcikket',
    openBlockGroupSubTitle: 'Válassz oldalt',
    openBlockItemSubTitle: 'Válassz blokkot',
    openItemGroupSubTitle: 'Válassz blokkot',
    openItemItemSubTitle: 'Válassz elemet',
    showProductGroupSubTitle: 'Válassz terméktípust',
    showProductItemSubTitle: 'Válassz terméket',
    showBlogGroupSubTitle: 'Válassz blogcsatornát',
    showBlogItemSubTitle: 'Válassz blogcikket',
    showBlockGroupSubTitle: 'Válassz oldalt',
    showBlockItemSubTitle: 'Válassz blokkot',
    showItemGroupSubTitle: 'Válassz blokkot',
    showItemItemSubTitle: 'Válassz elemet',
    scrollToBlockGroupSubTitle: 'Válassz oldalt',
    scrollToBlockItemSubTitle: 'Válassz blokkot',
    scrollToItemGroupSubTitle: 'Válassz blokkot',
    scrollToItemItemSubTitle: 'Válassz elemet',
    linkGroupPlaceholder: 'Válassz blokkot...',
    linkItemPlaceholder: 'Válassz linket...',
    openPageItemPlaceholder: 'Válassz oldalt...',
    openProductGroupPlaceholder: 'Válassz terméktípust...',
    openProductItemPlaceholder: 'Válassz terméket...',
    showProductGroupPlaceholder: 'Válassz termékcsoportot...',
    showProductItemPlaceholder: 'Válassz terméket...',
    openBlogGroupPlaceholder: 'Válassz blogcsatornát...',
    openBlogItemPlaceholder: 'Válassz blogcikket...',
    openBlockGroupPlaceholder: 'Válassz oldalt...',
    openBlockItemPlaceholder: 'Válassz blokkot...',
    openItemGroupPlaceholder: 'Válassz oldalt és blokkot...',
    openItemItemPlaceholder: 'Válassz elemet...',
    showBlogGroupPlaceholder: 'Válassz blogcsoportot...',
    showBlogItemPlaceholder: 'Válassz blogbejegyzést...',
    showBlockGroupPlaceholder: 'Válassz oldalt...',
    showBlockItemPlaceholder: 'Válassz blokkot...',
    showItemGroupPlaceholder: 'Válassz oldalt és blokkot...',
    showItemItemPlaceholder: 'Válassz elemet...',
    scrollToBlockGroupPlaceholder: 'Válassz oldalt...',
    scrollToBlockItemPlaceholder: 'Válassz blokkot...',
    scrollToItemGroupPlaceholder: 'Válassz oldalt és blokkot...',
    scrollToItemItemPlaceholder: 'Válassz elemet...',
    linkReadable: 'Link',
    urlReadable: 'Url',
    openInAppReadable: 'Megnyitás az appban',
    downloadDocumentReadable: 'Dokumentum letöltése',
    sendEmailReadable: 'E-mail küldése',
    phoneCallReadable: 'Telefonhívás',
    openPageReadable: 'Oldal megnyitása',
    openProductReadable: 'Termék megnyitása',
    showNewModalReadable: 'Új felugró ablak megjelenítése',
    showProductReadable: 'Termék megjelenítése',
    openBlogReadable: 'Blog megnyitása',
    openBlockReadable: 'Blokk megnyitása',
    openItemReadable: 'Elem megnyitása',
    showBlogReadable: 'Blog megjelenítése',
    showBlockReadable: 'Blokk megjelenítése',
    showItemReadable: 'Elem megjelenítése',
    scrollToBlockReadable: 'Görgetés blokkhoz',
    scrollToItemReadable: 'Görgetés elemhez',
  },
  design: {
    tabs: 'Fülek',
    imageView: 'Kép nézet',
    preview: 'Előnézet',
    buttonOpacity: 'Gomb átláthatósága',
    buttonBorder: 'Gomb kerete',
    buttonShadow: 'Gomb árnyéka',
    itemView: 'Elem nézet',
    itemViewTooltip: 'Válassz elemnézetet',
    itemLayout: 'Elem elrendezése',
    itemLayoutTooltip: 'Válassz elemelrendezést',
    top: 'Fent',
    center: 'Középen',
    bottom: 'Lent',
    bottomLeft: 'Lent balra',
    bottomHorizontal: 'Lent, vízszintesen',
    under: 'Alatta',
    title: 'Cím',
    titleButton: 'Cím és gomb',
    displayOptions: 'Megjelenítési beállítások',
    displayOptionsTooltip: 'Válassz megjelenítési beállításokat',
    landscape: 'Fekvő',
    square: 'Négyzet',
    portrait: 'Álló',
    desktopMode: 'Asztali mód',
    mobile: 'Kompakt',
    desktop: 'Széles',
    responsive: 'Reszponzív',
    custom: 'Egyéni',
    templates: 'Sablonok',
    chooseTemplates: 'Válassz sablonokat',
    viewAll: 'Összes megtekintése',
    previousTheme: 'Ne feledd, hogy az előző téma véglegesen törlődik.',
    useThisTemplate: 'Sablon használata',
    notSupportedVideo: 'A böngésződ nem támogatja a videó címkét.',
    photosBy: 'Fotók készítője',
    animationBy: 'Animáció készítője',
    searchTheSame: 'Keresd meg újra ugyanazt a kifejezést más eredményekért.',
    addImage: 'Kép hozzáadása',
    addVideo: 'Videó hozzáadása',
    orSelectFrom: 'vagy válassz innen',
    noImagesYet: 'Még nincsenek képek',
    noVideosYet: 'Még nincsenek videók',
    videoBy: 'Videó készítője',
    hamburgerMenu: 'Hamburger menü',
    tabsOnTop: 'Fülek fent',
    tabsOnBottom: 'Fülek lent',
    borderType: 'Keret típusa',
    subTitle: 'Válassz alakzatot, keret típusát, árnyékot stb.',
    icon: 'Ikon',
    iconTooltip: 'Válaszd ki a megfelelő ikont a gombodhoz',
    background: 'Háttér',
    color: 'Szín',
    backgroundOpacity: 'Háttér átláthatósága',
    backgroundOpacityTooltip: 'Húzd a csúszkát a háttér átláthatóságának beállításához',
    gradient: 'Színátmenet',
    color1: '1. szín',
    color2: '2. szín',
    direction: 'Irány',
    directionTooltip: 'Húzd a csúszkát a színátmenet irányának beállításához',
    offset: 'Eltolás',
    offsetTooltip: 'Húzd a csúszkát a színátmenet eltolásának beállításához',
    minHeight: 'Minimális magasság',
    minHeightTooltip: 'Húzd a csúszkát a gomb minimális magasságának módosításához',
    align: 'Igazítás',
    alignTooltip: 'Módosítsd a gomb pozícióját',
    insert: 'URL beszúrása',
    upload: 'Videó feltöltése',
    search: 'Videó keresése',
    layout: 'Elrendezés',
    layoutTooltip: 'Válassz elrendezést',
    view: 'Nézet',
    viewTooltip: 'Válassz nézetet',
    media: 'Média',
    mediaTooltip: 'Válassz médiát',
    none: 'Nincs',
    small: 'Kicsi',
    medium: 'Közepes',
    large: 'Nagy',
    round: 'Kerek',
    feed: 'Hírfolyam',
    slider: 'Csúszka',
    text: 'Szöveg',
    colorTooltip: 'Válassz színeket',
    button: 'Gomb',
    buttonTooltip: 'Válassz gombszíneket',
    chooseEmoji: 'Válassz emojit',
    changeEmoji: 'Módosítsd az emojidat',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Link hozzáadása',
      addVideo: 'Videó hozzáadása',
      addProduct: 'Termék hozzáadása',
      addPost: 'Bejegyzés hozzáadása',
      addArticle: 'Cikk hozzáadása',
      addPhoto: 'Fotó hozzáadása',
      addMusic: 'Zene hozzáadása',
      addFiles: 'Fájlok hozzáadása',
      addStory: 'Story hozzáadása',
    },
    emoji: {
      search: 'Keresés',
      clear: 'Törlés',
      notfound: 'Nincs találat',
      skintext: 'Válaszd ki az alapértelmezett bőrszínedet',
      categories: {
        search: 'Keresési eredmények',
        recent: 'Gyakran használt',
        smileys: 'Mosolyok és emóciók',
        people: 'Emberek és testrészek',
        nature: 'Állatok és természet',
        foods: 'Étel és ital',
        activity: 'Tevékenység',
        places: 'Utazás és helyek',
        objects: 'Tárgyak',
        symbols: 'Szimbólumok',
        flags: 'Zászlók',
        custom: 'Egyéni',
      },
      categorieslabel: 'Emoji kategóriák',
      skintones: {
        1: 'Alapértelmezett bőrszín',
        2: 'Világos bőrszín',
        3: 'Közepesen világos bőrszín',
        4: 'Közepes bőrszín',
        5: 'Közepesen sötét bőrszín',
        6: 'Sötét bőrszín',
      },
    },
    blogPreviewModal: {
      title: 'Blog előnézet',
      notify: 'Feliratkozók értesítése',
    },
    standAloneModal: {
      title: 'Link előnézet',
      save: 'Mentés',
      chooseLayout: 'Válassz elrendezést a linkedhez',
      linkSettings: 'Link beállításai',
      linkSettingsSubtitle: 'Átirányítás, megjelenés',
      whenVisitorsClicks: 'Amikor egy látogató rákattint erre a linkre:',
      redirect: 'Átirányítás',
      redirectText: 'A látogatókat közvetlenül az URL-re irányítja',
      highlight: 'Kiemelés',
      highlightText: 'A látogatókat a UniLinkedre irányítja és kiemeli',
      standalone: 'Önálló',
      standaloneText: 'Tedd kiemelkedővé a YouTube linkedet, hogy a tartalom közvetlenül lejátszódjon a',
      cover: 'Borító',
      imageTab: 'Kép',
      videoTab: 'Videó',
      uploadImage: 'Kép feltöltése',
      whenVisitors: 'Amikor egy látogató kiválasztja a megosztott linket:',
      compact: 'Kompakt nézet',
      fullView: 'Teljes nézet',
      videoSound: 'Videó lejátszása hanggal',
    },
    instagramModal: {
      title: 'Automatikus Instagram DM-ek küldése',
      subtitle: 'Küldd el ezt a linket privát üzenetben, amikor valaki hozzászól az IG bejegyzésedhez vagy Reeledhez',
      promo: 'Válaszd ki, melyik IG fiókból szeretnél küldeni',
      connect: 'Instagram fiók csatlakoztatása',
      added: 'Instagram fiók hozzáadva',
      addNew: 'Új automatizálás hozzáadása',
      igContent: 'IG tartalom',
      trigger: 'Kiváltó',
      dmContent: 'DM',
      linkDestination: 'Link célja',
      buttonTitle: 'Gomb címe',
      buttonTitleTooltip: 'Add meg a gomb címét',
      directMessage: 'Privát üzenet',
      directMessageTooltip: 'Add meg a privát üzenetet',
      selectPosts: 'Válaszd ki a bejegyzést vagy Reelt, amely elindítja az automatikus DM-et.',
      onePost: 'Egy konkrét bejegyzés vagy Reel',
      allPosts: 'Összes bejegyzés vagy Reel',
      triggerText: 'Ha a hozzászólások ezt tartalmazzák, elküldjük a DM-edet.',
      addMessage: 'Adj hozzá egy üzenetet, amelyet automatikusan elküldünk a linkeddel.',
      clickLink: 'Amikor valaki a linkre kattint a DM-edben:',
      anyComment: 'Bármilyen hozzászólás',
      storiesAndDms: 'Storyk és DM-ek',
      anyMessage: 'Bármilyen üzenet',
      specificKeywords: 'Meghatározott kulcsszavakat tartalmazó hozzászólások',
      sendLink: 'Küldd őket a UniLinkedre és emeld ki ',
      skipLink: 'Hagyd ki a UniLinket, és küldd őket egyenesen',
      keywordsTitle: 'Meghatározott kulcsszavakat tartalmazó hozzászólások',
      keywordsText: 'A DM-jeid akkor kerülnek elküldésre, ha a hozzászólások tartalmaznak vagy kizárnak\nbizonyos kulcsszavakat (nem kis- és nagybetű érzékeny):',
      keywordsPlaceholder: 'Írj be egy kulcsszót',
      keywordsExclude: 'Kulcsszavak kizárása',
      keywordsExcludeText: 'Ki kell zárnia ezek közül valamelyiket',
      replyComment: 'Válasz hozzászólás',
      replyCommentTooltip: 'Add meg a válasz hozzászólást',
    },
    blockEditProduct: {
      productPreview: 'Bélyegkép',
      productDetails: 'Részletek',
      settings: 'Beállítások',
      design: 'Dizájn',
    },
    editMenuItems: {
      overview: 'Áttekintés',
      analytics: 'Analitika',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Add meg a botod tokenjét',
      connect: 'Csatlakozás',
      token: 'Token',
    },
    rewards: {
      title: 'Cím',
      titleTooltip: 'Add meg a válasz címét',
      text: 'Szöveg',
      textTooltip: 'Add meg a válasz szövegét',
      link: 'Link',
      linkTooltip: 'Add meg a válasz linkjét',
      code: 'Kód',
      codeTooltip: 'Add meg a válasz kódját',
      files: 'Fájlok',
      filesTooltip: 'Add meg a válasz fájljait',
      removeReward: 'Biztosan eltávolítod ezt a választ?',
    },
    addRewardModal: {
      addReward: 'Válasz hozzáadása',
      textTitle: 'Szöveg',
      textText: 'Adj hozzáférést útmutatóhoz vagy bármilyen szöveghez a Rich Editorral',
      fileTitle: 'Fájlok',
      fileText: 'Adj hozzáférést fájlokhoz és gyűjts elérhetőségi adatokat',
      linkTitle: 'Link',
      linkText: 'Adj hozzáférést exkluzív tartalomhoz és gyűjts elérhetőségi adatokat',
      codeTitle: 'Kód',
      codeText: 'Adj hozzáférést exkluzív promóciókhoz és gyűjts elérhetőségi adatokat',
    },
    blockEmpty: {
      isNotAdded: 'nincs hozzáadva',
      itSeems: 'Úgy tűnik, a',
      itemsNot: 'elemeid még nincsenek hozzáadva. Add hozzá a videóidat most',
      add: 'Hozzáadás',
    },
    blockList: {
      add: 'Hozzáadás',
      item: 'elem',
    },
    submitAction: {
      action: 'Művelet (beküldés után)',
      actionTooltip: 'Válassz műveletet a beküldés után',
      upload: 'Mellékletek feltöltése',
      none: 'Nincs',
      page: 'Visszaigazoló oldal megjelenítése',
      email: 'Visszaigazoló e-mail küldése',
      redirect: 'Átirányítás URL-re',
    },
    blockEditItem: {
      content: 'Tartalom',
      preview: 'Előnézet',
      settings: 'Beállítások',
    },
    domainButton: {
      customizeDomain: 'Testreszabhatod a domainedet.',
      upgradeToLink: 'Válts Link in Bio Pro-ra, és használj egyéni domaint.',
    },
    coverText: {
      text: 'Szöveg',
      textTooltip: 'Adj meg szöveget a borítóhoz',
      description: 'Leírás',
      descriptionTooltip: 'Adj meg leírást a borítóhoz',
      textColor: 'Szövegszín',
    },
    itemModal: {
      edit: 'Szerkesztés',
      addNew: 'Új hozzáadása',
      item: 'elem',
      update: 'Frissítés',
      add: 'Hozzáadás',
    },
    viewDesign: {
      compact: 'Kompakt',
      card: 'Kártya',
      button: 'Gomb',
      list: 'Lista',
      hero: 'Hero',
      featured: 'Kiemelt',
    },
    moveItemModal: {
      title: 'Elem áthelyezése másik oldalra',
      cancel: 'Mégse',
      move: 'Áthelyezés',
      page: 'Oldal',
      pageTooltip: 'Válassz oldalt az elem áthelyezéséhez',
      blocks: 'Blokkok',
      blocksTooltip: 'Válassz blokkot az elem áthelyezéséhez',
      emptyBlocks: 'Ezen az oldalon nincs megfelelő blokk.',
    },
    limitModal: {
      title: 'Elérted a limitet',
      text1: 'Elérted az oldalad limitjét.',
      text2: 'Vedd fel velünk a kapcsolatot a csomagod frissítéséhez.',
      close: 'Bezárás',
    },
    cropPicture: {
      title: 'Kép vágása',
      cancel: 'Mégse',
      save: 'Mentés',
    },
    uploadFile: {
      uploadProductImage: 'Termékkép feltöltése',
      coverImage: 'Borítókép',
      uploadImages: 'Ide csak képet tölthetsz fel',
    },
    userMediaLibrary: {
      addImage: 'Kép hozzáadása',
      uploadImage: 'Kép feltöltése',
      orSelectFrom: 'vagy feltöltés',
      orSelectLink: 'vagy link beillesztése',
      myMedia: 'Saját médiatár',
      stockImages: 'Stockképek',
      gifs: 'GIF-ek',
      icons: 'Ikonok',
      noImagesYet: 'Még nincs kép',
      loadMore: 'Továbbiak betöltése',
    },
    itemMenu: {
      active: 'Aktív',
      willBeAvailable: 'Az elem itt lesz elérhető:',
      save: 'Mentés',
      copied: 'Kimásolva',
      copyLink: 'Link másolása',
      delete: 'Törlés',
    },
    itemDesign: {
      linkColor: 'Link színe',
      gradient: 'Színátmenet',
      background: 'Háttér',
      backgroundOpacity: 'Háttér átlátszósága',
      backgroundOpacityTooltip: 'Húzd a csúszkát a háttér átlátszóságának beállításához',
      backgroundDarkness: 'Háttér sötétsége',
      backgroundDarknessTooltip: 'Húzd a csúszkát a háttér sötétségének beállításához',
      text: 'Szöveg',
      color1: '1. szín',
      color2: '2. szín',
      direction: 'Irány',
      directionTooltip: 'Húzd a csúszkát a színátmenet irányának beállításához',
      offset: 'Eltolás',
      offsetTooltip: 'Húzd a csúszkát a színátmenet eltolásának beállításához',
      linkHeight: 'Link magassága',
      linkHeightTooltip: 'Húzd a csúszkát a gomb magasságának módosításához',
      icon: 'Ikon',
      iconTooltip: 'Válassz ikont a gombhoz',
      imageShape: 'Kép alakja',
      imageShapeTooltip: 'Válassz kép alakot a linkhez',
    },
    menu: {
      linkInBio: 'Link in bio',
      linkInBioApps: 'Link in Bio',
      posts: 'Bejegyzések',
      audience: 'Közönség',
      orders: 'Rendelések',
      marketing: 'Marketing',
      emailMarketing: 'Email marketing',
      socialPlanner: 'Social Planner',
      shortLinks: 'Rövid linkek',
      businessCards: 'Névjegykártyák',
      emailSignatures: 'Email aláírások',
      virtualBackgrounds: 'Virtuális hátterek',
      recentProfiles: 'Legutóbbi profilok',
      standalonePage: 'Önálló oldal',
      soloApps: 'App in Bio',
      bots: 'Botok',
      smartReply: 'Instagram válasz',
      analytics: 'Analitika',
      settings: 'Beállítások',
      shop: 'Kereset',
      publish: 'Publikálás',
      studio: 'Studio',
      blog: 'Blog',
      qrCodes: 'QR-kódok',
      singlePages: 'Appok',
      forms: 'Űrlapok',
      form: 'Űrlapok',
      automations: 'Automatizálások',
      community: 'Közösség',
      messages: 'Beérkezett üzenetek',
      agents: 'Ügynökök',
      apps: 'Appok',
    },
    notificationsBlockSetting: {
      title: 'Értesítések',
      setUp: 'Beállítás',
      notifications: 'értesítések',
      connect: 'Csatlakoztatás',
      telegramText: 'Telegram-értesítés fogadása, ha valaki',
      change: 'módosítást hajt végre',
      email: 'Email',
      emailText: 'Email fogadása, ha valaki',
      webhook: 'Webhook',
      webhookTooltip: 'Webhook hozzáadása',
      activate: 'Aktiválás',
      webhookText: 'Esemény küldése egy harmadik féltől származó weboldalra, ha valaki',
      webhookURL: 'Webhook URL (POST kérés)',
      error: 'Adj meg helyes linket',
      save: 'Mentés',
    },
    navigation: {
      content: 'Tartalom',
      pages: 'Oldalak',
      posts: 'Bejegyzések',
      shop: 'Bolt',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Analitika',
      settings: 'Beállítások',
      apps: 'Appok',
      store: 'Bolt',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Analitika',
      settings: 'Beállítások',
      editTabs: 'Fülek szerkesztése',
    },
    unlockModal: {
      title: 'Pro funkciók feloldása',
      text: 'Hozz ki még többet a link-in-bio oldaladból. Csupán $5/hónap — oldd fel mindazt, amit a Pro nyújt:',
      checkBoxTitle1: 'Több blokk:',
      checkBoxText1: 'Adj hozzá űrlapokat, boltokat, visszaszámlálókat és médialejátszókat',
      checkBoxTitle2: 'Speciális analitika:',
      checkBoxText2: 'Kövesd a kattintásokat, megtekintéseket és a közönség adatait',
      checkBoxTitle3: 'Egyéni domain:',
      checkBoxText3: 'Használd saját domainedet a professzionális megjelenésért',
      checkBoxTitle4: 'Beépített bolt:',
      checkBoxText4: 'Adj el termékeket, és kezeld egyszerűen a rendeléseket',
      checkBoxTitle5: 'SEO eszközök:',
      checkBoxText5: 'Kerülj előrébb meta tagekkel, UTM-mel és egyéni slugokkal',
      checkBoxTitle6: 'Integrációk:',
      checkBoxText6: 'Szinkronizálj a Mailchimp-pel, Zapier-rel és más eszközökkel',
      checkBoxTitle7: 'Email marketing:',
      checkBoxText7: 'Gyűjts leadeket, és küldj automatizált kampányokat',
      checkBoxTitle8: 'Elsőbbségi támogatás:',
      checkBoxText8: 'Kapj gyorsabb segítséget, amikor csak szükséges',
      upgradeToPro: 'Frissítés Pro-ra',
      viewAllPlans: 'Összes csomag megtekintése',
    },
    profileSwitcher: {
      title: 'Összes profil',
      button: 'Új profil hozzáadása',
    },
    account: {
      signOut: 'Kijelentkezés',
      createNew: 'Új Link in Bio létrehozása',
      tryPro: 'Próbáld ki a Pro-t most!',
      tryProText: 'Szerezz speciális testreszabást és mélyebb közönség-elemzést, hogy több látogatót érj el!',
    },
    accountSettings: {
      title: 'Fiókbeállítások',
    },
    billingHistory: {
      title: 'Számlázási előzmények',
    },
    pages: {
      home: 'Kezdőlap',
      newPage: 'Új oldal',
      managePages: 'Oldalak kezelése',
    },
    blockItem: {
      actionRequired: 'beavatkozás szükséges',
      hidden: 'Rejtett · senki sem látja',
    },
    blockContent: {
      untitled: 'Névtelen',
      clickToRename: 'Kattints az alcím átnevezéséhez',
      saving: 'mentés',
      saved: 'mentve',
      deleteTitle: 'Biztosan törlöd ezt a blokkot?',
      cancel: 'Mégse',
      yes: 'Igen',
    },
    addButtonModal: {
      title: 'Akciógomb hozzáadása',
      close: 'Bezárás',
      added: 'Hozzáadva',
      add: 'Hozzáadás',
      messageTitle: 'Üzenet',
      messageText: 'Az Üzenet gomb lehetővé teszi, hogy a felhasználók üzenetküldőn keresztül kapcsolatba lépjenek veled',
      subscribeTitle: 'Feliratkozás',
      subscribeText: 'A Feliratkozás gomb lehetővé teszi, hogy a felhasználók feliratkozzanak az email vagy üzenetküldő listádra',
      ctaTitle: 'CTA gomb',
      ctaText: 'A CTA egy felszólítás a weboldalon, amely arra kéri a felhasználót, hogy egy meghatározott műveletet végezzen',
      cartTitle: 'Kosár',
      cartText: 'Jelenítsd meg a bevásárlókosár ikont, hogy a látogatók lássák, vásárolhatnak az oldaladon',
      contactTitle: 'Kapcsolat',
      contactText: 'Tedd lehetővé, hogy a látogatók gyorsan elérjék a kapcsolati adataidat',
      qrcodeTitle: 'QR-kód',
      qrcodeText: 'Jelenítsd meg a QR-kódot, hogy a látogatók gyorsan beolvashassák és megoszthassák az oldaladat',
      languageTitle: 'Nyelv',
      languageText: 'Tedd lehetővé, hogy a látogatók váltsák az oldalad nyelvét',
      searchTitle: 'Keresés',
      searchText: 'Engedd meg a látogatóknak, hogy a fejlécből keressenek a bolt termékei között',
    },
    inputMask: {
      copyLink: 'Link másolása',
    },
    videoLibrary: {
      addVideo: 'Videó hozzáadása',
      myVideos: 'Saját videók',
      stockVideos: 'Stockvideók',
      pasteUrl: 'URL beillesztése',
      uploadVideo: 'Videó feltöltése',
    },
    createBlockModal: {
      searchTitle: 'Válassz blokkot az oldaladhoz',
      title: 'Hozzáadás a UniLinkhez',
      contentTitle: 'Tartalom',
      contentText: 'Hozd létre és kezeld az oldaladat',
      growTitle: 'Leadek',
      growText: 'Gyűjts leadeket és növeld az elköteleződést',
      monetizeTitle: 'Pénzkeresés',
      monetizeText: 'Adj el termékeket, tartalmat és szolgáltatásokat',
      monetizationTitle: 'Keress és gyűjts pénzt',
      monetizationText: 'Adj el termékeket, szolgáltatásokat, és gyűjts borravalót',
      socialTitle: 'Közösségi média tartalom',
      socialText: 'Ossz meg közösségi média tartalmat a UniLinkeden',
      toolsTitle: 'Növekedési eszközök',
      toolsText: 'Növeld, kezeld és lépj kapcsolatba a közönségeddel',
      search: 'Keresés',
      all: 'Összes',
      allCategories: 'Összes kategória',
      content: 'Tartalom',
      monetization: 'Pénzkeresés',
      social: 'Közösségi',
      tools: 'Eszközök',
      header: 'Fejléc',
      headerText: 'Adj hozzá profilképet és bemutatkozást',
      link: 'Linkek',
      linkText: 'Válassz link elrendezést',
      text: 'Szöveg',
      textText: 'Válassz szöveg elrendezést',
      videos: 'Videók',
      videosText: 'Válassz videótípust',
      image: 'Kép',
      imageText: 'Adj hozzá kép blokkokat',
      music: 'Zene',
      musicText: 'Válassz zenetípust',
      socialFeeds: 'Közösségi hírfolyamok',
      socialFeedsText: 'Válassz közösségi hírfolyam típust',
      moreContent: 'Több',
      moreContentText: 'Adj hozzá további tartalom blokkokat',
      dataCollect: 'Adatgyűjtés',
      dataCollectText: 'Válassz adatgyűjtési típust',
      form: 'Űrlap',
      formText: 'Válassz űrlaptípust',
      conversionTools: 'Elköteleződési eszközök',
      conversionToolsText: 'Adj hozzá konverziós blokkokat',
      products: 'Termékek',
      productsText: 'Adj hozzá termékblokkokat',
      donation: 'Borravalók és adományok',
      tipsAndDonations: 'Borravalók és adományok',
      tipsDonationsText: 'Borravaló és adomány blokkok',
      event: 'Esemény',
      eventText: 'Válassz eseménytípust',
      quickAdd: 'Összes blokk',
      quickAddText: 'Adj hozzá bármilyen blokkot',
    },
    addBlockModal: {
      title: 'Hozzáadás a UniLinkhez',
      dragToAdd: 'Húzd a hozzáadáshoz',
      contentTitle: 'Ossz meg alapvető tartalmat',
      contentText: 'Ossz meg tartalmat közvetlenül a UniLinkeden',
      monetizationTitle: 'Keress és gyűjts pénzt',
      monetizationText: 'Adj el termékeket, szolgáltatásokat, és gyűjts borravalót',
      socialTitle: 'Közösségi média tartalom',
      socialText: 'Ossz meg közösségi média tartalmat a UniLinkeden',
      toolsTitle: 'Növekedési eszközök',
      toolsText: 'Növeld, kezeld és lépj kapcsolatba a közönségeddel',
      search: 'Keresés',
      searchPlaceholder: 'Tartalom keresése...',
      all: 'Összes',
      allCategories: 'Összes kategória',
      content: 'Tartalom',
      monetization: 'Pénzkeresés',
      social: 'Közösségi',
      tools: 'Eszközök',
      suggestTitle: 'Javasold a saját blokkod',
      suggestText: 'Hiányzik egy blokk? Mondd el, mit szeretnél látni',
      suggestModalTitle: 'Blokk javaslása',
      suggestModalSubtitle: 'Írd le, milyen blokkot szeretnél a UniLinkben. Minden ötletet elolvasunk.',
      suggestPlaceholder: 'pl. Foglalási blokk Google Calendar szinkronizálással...',
      suggestSubmit: 'Javaslat elküldése',
      suggestSending: 'Küldés...',
      suggestSuccessTitle: 'Javaslat elküldve!',
      suggestSuccess: 'Köszönjük! Minden ötletet elolvasunk, és felhasználjuk a fejlesztési terv alakításához.',
      suggestError: 'Nem sikerült elküldeni. Próbáld újra.',
    },
    tabNavigation: {
      tabView: 'Fül nézet',
      tabViewTooltip: 'Válassz fülnézetet a navigációhoz',
      colors: 'Színek',
      colorsTooltip: 'Válassz színt a bejegyzésekhez és gombokhoz',
      tabs: 'Fülek',
      tabsTooltip: 'Válassz füleket, amelyek megjelennek az oldal navigációjában',
      content: 'Tartalom',
      posts: 'Bejegyzések',
      store: 'Bolt',
      shop: 'Bolt',
      tabsSettings: 'Fülnavigáció beállításai',
    },
    hideLogo: {
      text: 'Mutasd a UniLink logót az oldalad lábjegyzetében.',
      text2: 'Mutasd a UniLink logót az oldalad lábjegyzetében.',
    },
    palettePreview: {
      custom: 'Egyéni háttérszín',
      hexColor: 'Hex szín',
      hexColorTooltip: 'Add meg az előnézet hex színét',
    },
    backgroundVideo: {
      insert: 'URL beszúrása',
      upload: 'Videó feltöltése',
      search: 'Videó keresése',
    },
    periodDropdown: {
      today: 'Mai nap',
      yesterday: 'Tegnap',
      last7days: 'Elmúlt 7 nap',
      last30days: 'Elmúlt 30 nap',
      allTime: 'Teljes időszak',
      custom: 'Egyéni',
    },
    subsections: {
      content: 'Tartalom',
      design: 'Design',
      settings: 'Beállítások',
    },
    wrapperSettings: {
      lock: 'Frissíts PRO csomagra',
    },
    shareModal: {
      addSocials: 'Hozzáadás a közösségi médiához',
      shareTo: 'Megosztás',
      qrCode: 'QR-kód',
      customizeUrl: 'URL testreszabása',
      goToMy: 'Ugrás a saját',
      print: 'Kinyomtathatod az egyedi QR-kódodat',
      cards: 'névjegykártyákra és szórólapokra',
      download: 'Letöltés',
      copy: 'Másolás',
      previewMobile: 'Előnézet mobilon',
      scanMobilePreview: 'Olvasd be a QR-kódot a mobileszközöddel, hogy megnézd az előnézetet',
      types: {
        socials: 'közösségi',
        shareTo: 'megosztás',
        qrCode: 'QR',
        title: 'Oszd meg a UniLinkedet',
        titleSocials: 'Add hozzá a UniLinket a közösségi médiádhoz',
        titleShareTo: 'Megosztás...',
        titleQRCode: 'QR-kód',
        titlePreviewMobile: 'Előnézet mobilon',
      },
      socialList: {
        instagramText:
          'Add hozzá a UniLinkedet az Instagram-profilodhoz. Egyszerűen másold ki a UniLink URL-edet, lépj a Profil szerkesztése menübe, és illeszd be a Weboldal mezőbe.',
        facebookText:
          'Add hozzá a UniLinkedet a Facebook-profilodhoz. Egyszerűen másold ki a UniLink URL-edet, lépj a profilod Névjegy oldalára, kattints a Kapcsolat és alapinformációk menüre, majd a + Weboldal hozzáadására, illeszd be a UniLink URL-edet a Weboldal cím mezőbe, és kattints a Mentésre.',
        tikTokText:
          'Add hozzá a UniLinkedet a Facebook-profilodhoz. Egyszerűen másold ki a UniLink URL-edet, lépj a profilod Névjegy oldalára, kattints a Kapcsolat és alapinformációk menüre, majd a + Weboldal hozzáadására, illeszd be a UniLink URL-edet a Weboldal cím mezőbe, és kattints a Mentésre.',
        twitchText:
          'Add hozzá a UniLinkedet a Twitch csatornádhoz. Egyszerűen másold ki a UniLink URL-edet, lépj a Twitch csatornádra, kattints a Névjegyre, majd a Névjegy és linkek beállításai szerkesztésére, görgess le a Közösségi linkekhez, add hozzá a UniLinket az első szövegmezőbe, illeszd be a UniLink URL-edet a második szövegmezőbe, majd kattints a Hozzáadásra.',
        youTubeText:
          'Add hozzá a UniLinkedet a YouTube csatornádhoz. Egyszerűen másold ki a UniLink URL-edet, lépj a YouTube csatornádra, kattints a Csatorna testreszabására, majd az Alapinformációkra, és a Linkeknél adj hozzá egy link címet, illeszd be a UniLink URL-edet az URL mezőbe, majd kattints a Közzétételre.',
        linkedInText:
          'Add hozzá a UniLinkedet a LinkedIn-profilodhoz. Egyszerűen másold ki a UniLink URL-edet, lépj a LinkedIn-profilodra, kattints a ceruza ikonra, görgess le a Kapcsolati adatokhoz, illeszd be a UniLink URL-edet a Weboldal URL mezőbe, majd kattints az Alkalmazásra.',
        pinterestText:
          'Add hozzá a UniLinkedet a Pinterest-profilodhoz. Egyszerűen másold ki a UniLink URL-edet, lépj a Pinterest beállításaidhoz, illeszd be a UniLink URL-edet a Weboldal URL mezőbe, majd kattints a Mentésre.',
        twitterText:
          'Add hozzá a UniLinkedet a Twitter-profilodhoz. Egyszerűen másold ki a UniLink URL-edet, lépj a profilodra, kattints a Profil szerkesztésére, és illeszd be a UniLink URL-edet a Weboldal mezőbe.',
      },
      share: {
        shareFacebook: 'Megosztás Facebookon',
        shareLinkedIn: 'Megosztás LinkedInen',
        shareTwitter: 'Megosztás Twitteren',
        shareWhatsApp: 'Megosztás WhatsAppon',
        shareMessenger: 'Megosztás Messengeren',
        shareEmail: 'Megosztás emailben',
      },
    },
  },
  popupMenu: {
    edit: 'Oldal szerkesztése',
    openInNewTab: 'Megnyitás új lapon',
    copyLink: 'URL másolása',
    delete: 'Törlés',
    showThumbnail: 'Oldal miniatűrök megjelenítése az irányítópulton',
    manageTabs: 'Fülek kezelése',
  },
  tabsDashboard: {
    labelAddNewTab: 'Új fül',
  },
  blocks: {
    header: {
      blockTitle: 'Fejléc',
      blockText: 'Testreszabhatod a profilképedet, hozzáadhatsz egy rövid bemutatkozást, és frissítheted a közösségimédia-ikonjaidat',
      blockShortText: 'Testreszabd a profilodat',
      layout: 'Elrendezés',
      layoutTooltip: 'Hozd létre a kívánt fejléc-elrendezést',
      layoutAlign: 'Elrendezés igazítása',
      layoutAlignTooltip: 'Szöveg igazítása',
      bottomButtonsSettings: 'Alsó gombok',
      bottomButtonsLayout: 'Elrendezés',
      bottomButtonsRow: 'Egymás mellett',
      bottomButtonsColumn: 'Egymás alatt',
      profilePicture: 'Profilkép',
      profilePictureTooltip: 'Módosítsd a profilképedet',
      cropMismatch: 'Ez a fotó egy másik elrendezéshez van vágva.',
      adjustCrop: 'Vágás módosítása',
      photoShapeLabel: 'Fotó alakja',
      photoShapeTooltip: 'Válaszd ki, hogy ez az elrendezés a négyzetes fotót vagy egy vertikális vágást mutassa.',
      photoShapeSquare: 'Négyzet',
      photoShapeVertical: 'Vertikális',
      photoStyleProTitle: 'Oldd fel a speciális fotóstílusokat',
      photoStyleProDesc: 'A Háttér nélkül és a Szöveg mögötte PRO funkciók.',
      photoShapeCustom: 'Egyéni',
      sliderStyleLabel: 'Csúszka stílusa',
      sliderStyleTooltip: 'A Swipe egyszerre egy fotót mutat; a Gallery egy miniatűrsort mutat — koppints egy miniatűrre a főkép cseréjéhez.',
      sliderStyleSwipe: 'Swipe',
      sliderStyleGallery: 'Gallery',
      photoPositionLabel: 'Fotó pozíciója',
      photoPositionHint: 'Vertikális keretezés',
      verticalCropHint: 'Ez az elrendezés az eredeti fotót mutatja. Válaszd ki a megjelenítendő vertikális területet.',
      verticalCropReady: 'Finomítsd az ebben az elrendezésben megjelenő vertikális területet.',
      pickVerticalArea: 'Vertikális terület kiválasztása',
      pictureSize: 'Kép mérete',
      pictureSizeTooltip: 'Módosíthatod a kép méretét',
      pictureHeight: 'Kép magassága',
      pictureHeightCaption: 'Módosíthatod a kép magasságát',
      photoStyle: 'Fotóstílus',
      photoStyleTooltip: 'Jelenítsd meg a fotót eredeti formában, háttér nélkül, vagy tegyél szöveget az alany mögé.',
      avatarModeOriginal: 'Eredeti',
      avatarModeCutout: 'Háttér nélkül',
      avatarModeLayered: 'Szöveg mögötte',
      overlayText: 'Szöveg',
      overlayTextPlaceholder: 'A neved (alapértelmezett)',
      overlayColor: 'Szövegszín',
      overlaySize: 'Méret',
      overlayY: 'Vertikális pozíció',
      overlayEffect: 'Animáció',
      overlayEffectNone: 'Nincs',
      overlayEffectShimmer: 'Csillogás',
      overlayEffectGlow: 'Ragyogás',
      overlayEffectGradient: 'Színátmenet',
      overlayEffectSparkle: 'Szikrázás',
      overlayUsesName: 'Ezen az elrendezésen a szöveg a profilneved — mögötted jelenik meg. Szerkesztheted a „Név” szekcióban.',
      cutoutGenerate: 'Kivágás létrehozása',
      cutoutRegenerate: 'Újragenerálás',
      cutoutUpload: 'Feltöltés',
      cutoutOr: 'vagy',
      cutoutGenerating: 'Generálás...',
      cutoutUploading: 'Feltöltés...',
      cutoutVideoHint: 'A háttér eltávolítása csak fotókkal működik, videóval nem.',
      cutoutTimeout: 'A háttér eltávolítása túl sokáig tart. Próbáld újra.',
      preview: 'Előnézet',
      badge: 'Jelvény',
      badgeTooltip: 'Adj hozzá egy hitelesített jelvényt a fejléchez',
      profileBadges: 'Jelvények',
      profileBadgesTooltip: 'Válassz legfeljebb 3 jelvényt, amely a neved mellett jelenik meg',
      profileBadgesProLockHint: 'Frissíts PRO-ra ennek a jelvénynek a használatához',
      profileBadgesAdd: 'Jelvények hozzáadása',
      profileBadgesManage: 'Jelvények kezelése',
      profileBadgesModalTitle: 'Jelvények hozzáadása a profilodhoz',
      profileBadgesModalSubtitle: 'Mutasd meg az eredményeidet és elismeréseidet.',
      profileBadgesCustomCta: 'Töltsd fel a saját jelvényedet',
      profileBadgesCustomDesc: 'Egyéni jelvényed',
      profileBadgesCustomName: 'Jelvény neve',
      profileBadgesCustomChoose: 'Kép választása',
      profileBadgesCustomChange: 'Kép módosítása',
      profileBadgesCustomUploading: 'Feltöltés…',
      profileBadgesCustomAdd: 'Jelvény hozzáadása',
      tags: 'Címkék',
      tagsTooltip: 'Mutasd a kategóriacímkéket a neved alatt (legfeljebb 5)',
      tagsAdd: 'Címkék hozzáadása',
      addTags: '+ Címkék hozzáadása',
      tagsEdit: 'Címkék szerkesztése',
      tagsCustomPlaceholder: 'Egyéni címke hozzáadása',
      tagsCustomAdd: 'Hozzáadás',
      tagsSuggested: 'Javasolt kategóriák',
      tagsSelected: 'Kiválasztva',
      tagsEmpty: 'Még nincs címke — válassz a javaslatokból, vagy adj hozzá saját címkét',
      tagsLimit: 'Legfeljebb 5 címke',
      visibility: 'Láthatóság',
      visibilityTooltip: 'Profilkép megjelenítése vagy elrejtése',
      cover: 'Borító',
      coverTooltip: 'Adj hozzá képet vagy videót a fejléc borítójához',
      addCover: 'Borító hozzáadása',
      image: 'Kép',
      video: 'Videó',
      positionCover: 'Szöveg és gomb pozíciója',
      positionCoverTooltip: 'Húzd a csúszkát a pozíció módosításához',
      buttons: 'Gombok',
      block: 'Blokk',
      videoProcessing: 'Videó feldolgozása',
      vibe: 'Vibe',
      vibeTooltip: 'Add hozzá a vibed',
      stories: 'Történetek',
      storiesTooltip: 'Adj hozzá történeteket',
      addStory: 'Történet hozzáadása',
      storiesSubtitle: 'Adj hozzá képet vagy videót a történeteidhez',
      subscribeMethod: 'Feliratkozási mód',
      subscribeMethodTooltip: 'Válassz feliratkozási módot',
      subscribeLink: 'Feliratkozási link',
      subscribeLinkTooltip: 'Másold ki a feliratkozási linkedet',
      minWidth: 'Minimális szélesség',
      addVCard: 'vCard hozzáadása',
      vCard: 'vCard',
      vCardTooltip: 'Hozzáadhatsz információt magadról',
      buttonInline: 'Gomb a fejlécen belül',
      buttonInsideContact: 'Gomb a Kapcsolat gombon belül',
      showSaveContact: 'Kapcsolat mentése megjelenítése',
      options: 'Beállítások',
      showBusinessCard: 'Névjegykártya megjelenítése',
      showBusinessCardCaption: 'Hozzáadja a „Kapcsolat mentése” gombot ide.',
      editBusinessCard: 'Kártya szerkesztése',
      editContactDetails: 'Kapcsolati adatok szerkesztése a névjegykártyákon',
      needAddContact: 'Hozzá kell adnod a Kapcsolat gombot',
      socialGap: 'Térköz',
      socialGapCaption: 'Módosíthatod a térközt',
      socialSize: 'Méret',
      socialSizeCaption: 'Módosíthatod a méretet',
      icons: 'Ikonok',
      iconsTooltip: 'Adj hozzá ikont a gombhoz',
      ribbonLabel: 'Dekoratív szalag',
      ribbonLabelTooltip: 'Adj hozzá egy színes sávot a fejléc hero alá',
      addTint: 'Szalag hozzáadása',
      ribbonTitle: 'Szalag',
      ribbonText: 'Szalag szövege',
      ribbonTextPlaceholder: 'pl. 20% kedvezmény a hónap végéig',
      ribbonColor: 'Szalag színe',
      ribbonTheme: 'Stílus',
      ribbonThemes: {
        none: 'Nincs dekoráció',
        birthday: 'Születésnap',
        newyear: 'Újév',
        valentine: 'Valentin-nap',
        halloween: 'Halloween',
        summer: 'Nyár',
      },
      ribbonEffect: 'Effekt',
      ribbonEffects: {
        none: 'Nincs',
        gradient: 'Animált színátmenet',
        shimmer: 'Csillogás',
        lights: 'Fényfüzér',
      },
      ribbonPosition: 'Pozíció',
      ribbonPositions: {
        bottom: 'Fejléc alatt',
        underPhoto: 'Fotó alatt',
      },
      ribbonRemove: 'Szalag eltávolítása',
      statusBadges: 'Aktivitás',
      statusBadgesTooltip: 'Mutass valós idejű aktivitást az oldaladon',
      addStatus: 'Aktivitás hozzáadása',
      statusDisabledHint: 'Rejtett · kikapcsolva',
      followersTitle: 'Követők',
      followersCounter: 'Követőszámláló',
      followersTooltip: 'Mutasd az összesített követőszámot a csatlakoztatott közösségimédia-fiókjaidból',
    },
    text: {
      blockTitle: 'Szöveg',
      blockText: 'Általános szövegblokk, amelybe bármit írhatsz. A szöveget WYSIWYG szerkesztővel formázhatod',
      blockShortText: 'Általános szövegblokk',
      title: 'Cím',
      titleText: 'Testreszabhatod a cím méretét',
      orderOfElements: 'Elemek sorrendje',
      orderOfElementsTooltip: 'Húzd a csúszkát az elemek sorrendjének módosításához',
      changeOrder: 'Sorrend módosítása',
      text: 'Szöveg',
      content: 'Tartalom',
      image: 'Kép',
      button: 'Gomb',
      addButtons: 'További gombok hozzáadása',
      displayedContent: 'Megjelenített tartalom',
      displayedContentTooltip: 'Tartalom megjelenítése vagy elrejtése',
      buttonLayout: 'Gomb elrendezése',
      buttonLayoutTooltip: 'Válassz vertikális vagy horizontális gombelrendezést',
    },
    timeline: {
      blockTitle: 'Idővonal',
      blockText: 'Jeleníts meg egy vertikális idővonalat eseményekkel. Minden esemény tartalmazhat dátumot/időt, címet, leírást és opcionális képet',
      blockShortText: 'Események idővonalának megjelenítése',
      editItem: 'Esemény szerkesztése',
      title: 'Cím',
      titlePlaceholder: 'Esemény címe',
      subtitle: 'Alcím',
      subtitlePlaceholder: 'Szerepkör vagy hovatartozás (opcionális)',
      description: 'Leírás',
      descriptionPlaceholder: 'Esemény leírása (opcionális)',
      startTime: 'Kezdés időpontja',
      endTime: 'Befejezés időpontja',
      startDate: 'Kezdő dátum',
      endDate: 'Befejező dátum',
      showEndDate: 'Befejező dátum megjelenítése',
      showEndDateTooltip: 'Kapcsold ki a folyamatban lévő eseményekhez (pl. „itt dolgozom 2023 óta”)',
      includeTime: 'Idő megjelenítése',
      includeTimeTooltip: 'Ha ki van kapcsolva, csak a dátum jelenik meg, idő nélkül',
      image: 'Kép',
      imagePlaceholder: 'Avatar vagy ikon feltöltése',
      imageUploadFailed: 'A képet nem sikerült feltölteni. Használd a Saját médiatárat, vagy illessz be linket.',
      untitled: 'Névtelen',
      listLayout: 'Lista elrendezés',
      lineColor: 'Vonal színe',
    },
    trust: {
      blockTitle: 'Bizalom',
      blockShortText: 'Ossz meg partnerségeket',
      blockText: 'Helyezd egy helyre az összes kapcsolatodat.',
      titleText: 'Testreszabhatod a cím méretét',
      orderOfElements: 'Elemek sorrendje',
      orderOfElementsTooltip: 'Húzd a csúszkát az elemek sorrendjének módosításához',
      changeOrder: 'Sorrend módosítása',
      text: 'Szöveg',
      content: 'Tartalom',
      image: 'Kép',
      button: 'Gomb',
      displayedContent: 'Megjelenített tartalom',
      displayedContentTooltip: 'Tartalom megjelenítése vagy elrejtése',
      enterTrustLink: 'Add meg a partner URL-jét',
      enterTrustLinkTooltip: 'Illessz be a partner URL-jét',
      enterPartnerName: 'Add meg a partner nevét',
      enterPartnerUrl: 'https://www.yourPartner.com/',
      enterDescription: 'Add meg a leírást (opcionális)',
      partnerLogo: 'Partner logó',
      uploadPartnerLogo: 'Töltsd fel a partnered logóját',
    },
    wall: {
      blockTitle: 'Fal',
      blockShortText: 'Üzenetek gyűjtése látogatóktól',
      blockText: 'Nyilvános fal megjelenítése, ahol a látogatók üzenetet hagyhatnak és interakcióba léphetnek a tartalommal',
    },
    'live-stream': {
      blockTitle: 'Élő közvetítés',
      blockShortText: 'Élő közvetítés az oldaladon',
      blockText: 'Közvetíts élőben a közönségednek — natívan a platformunkon, vagy ágyazz be YouTube / Twitch tartalmat',
    },
    workout: {
      blockTitle: 'Edzés',
      blockShortText: 'Ossz meg és adj el edzéseket',
      blockText: 'Ossz meg egy strukturált edzést — gyakorlatok sorozatokkal, ismétlésekkel és bemutató videókkal. Add el vagy oszd meg ingyen',
    },
    videoFeedback: {
      blockTitle: 'Videós visszajelzés',
      blockShortText: 'Videós vélemények gyűjtése',
      blockText: 'Gyűjts rövid videós véleményeket és visszajelzéseket a közönségedtől',
    },
    'premium-inbox': {
      blockTitle: 'Prémium beérkező üzenetek',
      blockShortText: 'Fizetett üzenetek a követőktől',
      blockText: 'Engedd, hogy a követőid fizetett üzeneteket és kéréseket küldjenek közvetlenül a prémium beérkező mappádba',
    },
    'order-form': {
      blockTitle: 'Megrendelőlap',
      blockShortText: 'Rendelések gyűjtése az oldaladról',
      blockText: 'Gyűjts rendeléseket közvetlenül az oldaladról egy testreszabható megrendelőlappal',
    },
    link: {
      blockTitle: 'Linkek',
      blockText: 'Irányíts forgalmat a weboldaladra, blogodra, webáruházadba vagy más weboldalakra',
      blockShortText: 'Forgalom irányítása a weboldalra',
      addLink: 'Link hozzáadása',
      addNewLink: 'Új link hozzáadása',
      restrictedTitle: 'A {platform} linkek PRO funkciók',
      restrictedText: 'A {platform} linkek hozzáadása csak PRO csomagban elérhető. Frissítsd a csomagod, hogy hozzáadhasd ezt a linket az oldaladhoz.',
      upgradeToPro: 'Frissítés PRO-ra',
      showMore: 'Több megjelenítése',
      showLess: 'Kevesebb megjelenítése',
      viewArchive: 'Archívum megtekintése',
      archivedLinks: 'Archivált linkek',
      noArchivedLinks: 'Tartsd rendben és fókuszáltan a link-adminisztrációt azáltal, hogy archiválod azokat a linkeket, amiket most nem használsz.',
      archiveAllUnpublished: 'Minden nem publikált link archiválása',
      addFormExisting: 'Hozzáadás meglévő linkekből',
      addYourLink: 'Add hozzá a linkedet a csoporthoz',
      add: 'Hozzáadás',
      otherTypes: 'Művelet típusa',
      link: 'Link',
      navigate: 'Navigálás',
      navigateTo: 'Navigálás ide',
      scrollBlock: 'Görgetés ide',
      copyText: 'Szöveg másolása',
      navigatePage: 'Oldal',
      navigateProduct: 'Termék',
      navigateBlock: 'Blokk',
      modal: 'Felugró ablak',
      showModal: 'Felugró ablak megjelenítése',
      modalBlock: 'Blokk megjelenítése',
      modalItem: 'Elem megjelenítése',
      modalCustom: 'Egyéni',
      document: 'Dokumentum',
      privat24: 'Privat24',
      phone: 'Telefonhívás',
      viber: 'Viber megnyitása',
      skype: 'Skype megnyitása',
      email: 'E-mail küldése',
      discount: 'Kedvezmény',
      smartLink: 'Smart Link',
      mobileApp: 'Deep Link',
      enterURL: 'Add meg az URL-t',
      enterPrivat: 'Add meg a Privat Bank kártyaszámodat',
      enterPhone: 'Add meg a telefonszámot',
      enterViber: 'Add meg a Viber számot',
      enterSkype: 'Add meg a Skype-ot',
      enterEmail: 'Add meg az e-mail címet',
      enterTitle: 'Add meg a címet',
      enterCopyText: 'Add meg a másolandó szöveget',
      enterPromoCode: 'Add meg a promóciós kódot',
      group: 'Csoport létrehozása',
      content: 'Tartalom',
      links: 'Linkek',
      heading: 'Fejlécszöveg',
      settings: 'Beállítások',
      thumbnail: 'Bélyegkép',
      typeTooltip: '  A kattintás megnyitja ezt a linket',
      title: 'Cím',
      titleTooltip: 'A linked neve',
      description: 'Leírás',
      descriptionTooltip: 'A link jellemzőinek, típusának, színének, méretének stb. opcionális leírása',
      label: 'Címke',
      labelTooltip: 'Add meg a címke nevét',
      button: 'Gomb',
      buttonTooltip: 'Add meg a gomb nevét',
      buttonText: 'Gomb szövege',
      buttonTextTooltip: 'A gombod neve',
      buttonUrl: 'Gomb URL-je',
      buttonUrlTooltip: 'Add meg a gomb URL-jét',
      addLinkToGroup: 'Link hozzáadása a csoporthoz',
      removeFromGroup: 'Eltávolítás a csoportból',
      deletePermanently: 'Végleges törlés',
      image: 'Kép',
      buttonBg: 'Gomb háttere',
      postPreview: 'Bejegyzés előnézete',
      separatorType: 'Elválasztó típusa',
      separatorTypeTooltip: 'Adj hozzá elválasztó típust a gombhoz',
      section: 'Szakasz',
      sectionTooltip: 'A link szakasza',
      descriptionSeparator: 'Leírás',
      descriptionSeparatorTooltip: 'A szakasz opcionális leírása',
      sectionText: 'Szakasz szövege',
      linkInstant: 'Azonnali linktovábbítás',
      spotlight: 'Link kiemelése',
      addEffect: 'Speciális effekt hozzáadása',
      countdown: 'Visszaszámlálás',
      countdownTimer: 'Visszaszámláló időzítő',
      countdownText: 'Adj hozzá élő visszaszámlálást ahhoz, amikor a linked kattinthatóvá válik',
      chooseDate: 'Válassz dátumot',
      chooseDateTooltip: 'Válassz dátumot a linkedhez',
      chooseAction: 'Válassz műveletet',
      chooseActionTooltip: 'Válassz műveletet a linkedhez',
      addCountdown: 'Visszaszámlálás hozzáadása a linkhez',
      scheduler: 'Ütemező',
      schedule: 'Ütemezés',
      scheduleText: 'Válassz egy jövőbeli dátumot és időpontot, amikor a linked aktiválódik',
      activateOn: 'Aktiválás',
      activateOnTooltip: 'Válassz dátumot',
      deactivateOn: 'Deaktiválás',
      deactivateOnTooltip: 'Válassz dátumot',
      addSchedule: 'Ütemezés hozzáadása',
      scheduleError: 'A záró dátum nem lehet korábbi a kezdő dátumnál, és a kezdő dátum nem lehet a múltban.',
      scheduleErrorPast: 'Az aktiválás dátuma nem lehet a múltban.',
      scheduleErrorPastDeactivate: 'A deaktiválás dátuma nem lehet a múltban.',
      scheduleErrorOrder: 'A deaktiválás dátumának az aktiválás dátuma után kell lennie.',
      activatesIn: 'Aktiválódik',
      deactivatesIn: 'Deaktiválódik',
      lock: 'Zár',
      lockText: 'A látogatók csak akkor férhetnek hozzá ehhez a linkhez, ha teljesítik az egyik feltételt.',
      lockCode: 'Kód',
      lockCodeTitle: 'Kód a link feloldásához',
      lockCodeText: 'A látogatóknak egy 4 számjegyű kódot kell megadniuk a link feloldásához',
      lockSubscribe: 'Feliratkozás',
      lockSubscribeTitle: 'A látogatóknak fel kell iratkozniuk a UniLinkedre a link feloldásához.',
      lockSubscribeText: 'A zár beállítása sikeresen megtörtént.',
      lockPayment: 'Fizetés',
      lockPaymentText: 'A zár beállítása sikeresen megtörtént.',
      price: 'Ár',
      priceTooltip: 'Add meg a terméked árát',
      lockAge: 'Születési dátum (életkor)',
      lockAgeTitle: 'Minimális életkor beállítása',
      lockAgeText: 'A látogatóknak egy adott életkor felett kell lenniük, hogy a link feloldhassák a születési dátumukkal',
      lockAgeAlert: 'A zár beállítása sikeresen megtörtént.',
      lockSensitive: 'Érzékeny tartalom',
      lockSensitiveText: 'A látogatóknak el kell fogadniuk, hogy ez a link olyan tartalmat tartalmazhat, amely nem alkalmas minden közönség számára.',
      makeLink: 'Link fizetőssé tétele',
      addLock: 'Zár hozzáadása a linkhez',
      save: 'Mentés',
      clear: 'Törlés',
      buttonColor: 'Gomb színe',
      labelColor: 'Címke színe',
      background: 'Háttér',
      imageHeight: 'Kép magassága',
      imageHeightTooltip: 'Húzd a csúszkát a kép magasságának módosításához',
      buttonMinimum: 'Minimális magasság',
      buttonMinimumTooltip: 'Húzd a csúszkát a gomb magasságának módosításához',
      textPosition: 'Szöveg pozíciója',
      textPositionTooltip: 'Válassz vertikális szövegpozíciót',
      preview: 'előnézet',
      defaultDesign: 'Alapértelmezett dizájn',
      defaultDesignTooltip: 'Állítsd be az alapértelmezett dizájnt a linkekhez',
      defaultDesignTitle: 'Vedd figyelembe, hogy ez a dizájn minden linkre alkalmazva lesz.',
      defaultDesignText: 'Módosíthatod az alapértelmezett link-dizájnt',
      changeDefault: 'Alapértelmezett módosítása',
      applyDefault: 'Alapértelmezett alkalmazása',
      scheduled: 'Ütemezve',
      scheduledVisible: 'Az ütemezett link most láthatóvá vált',
      scheduledHidden: 'Az ütemezett link most elrejtve',
      linkClickable: 'A link kattinthatóvá válik',
      linkDisable: 'A link letiltásra kerül',
      lockedBy: 'Zárolta',
      items: 'Elemek',
      doNotAnyLinks: 'Még nincs semmilyen linked',
      sublinks: 'Allinkek',
      layout: 'Elrendezés',
      layoutTooltip: 'Válassz elrendezést az allinkekhez',
      hideGroupLink: 'Csoportlink elrejtése',
      rules: 'Szabályok',
      rulesText: 'Módosítsd a link láthatóságát attól függően, ki nézi meg az oldaladat.',
      rulesEmpty: 'Még nincs feltétel. Adj hozzá egy feltételt, hogy szabályozd, ki lássa ezt a linket.',
      rulesAddCondition: 'Feltétel hozzáadása',
      rulesActive: 'Láthatósági szabályok',
      rulesIf: 'Ha',
      rulesThen: 'Akkor',
      ruleTypeLocation: 'Helyszín',
      ruleTypeDevice: 'Eszköz',
      ruleTypeTime: 'Nap és idő',
      ruleOperatorIs: 'az',
      ruleOperatorIsNot: 'nem az',
      ruleActionHide: 'Link elrejtése',
      ruleActionShow: 'Link megjelenítése',
      ruleSelectLocations: 'Válassz helyszíneket',
      ruleSearchLocations: 'Országok keresése…',
      ruleFrom: 'Ettől',
      ruleTo: 'Eddig',
      ruleAnyTime: 'Bármikor',
    },
    'data-collect': {
      blockTitle: 'Adatgyűjtés',
      blockText: 'Gyűjts e-mail címeket vagy telefonszámokat a látogatóidtól',
      blockShortText: 'E-mailek gyűjtése',
      maxSize: 'Maximum 3 csatornát adhatsz hozzá',
      customTerms: 'Egyéni ÁSZF',
      customTermsTooltip: 'Adj hozzá egyéni ÁSZF-et az űrlapodhoz',
      termsConditions: 'Általános Szerződési Feltételek',
      text: 'Szöveg',
      subscribe: 'Feliratkozás',
      title: 'Cím',
      titleTooltip: 'Add meg az ÁSZF címét',
      titleResultTooltip: 'Add meg a beküldés címét',
      url: 'URL',
      urlTooltip: 'Add meg az URL-t',
      editItem: 'Elem szerkesztése',
      placeholder: 'Helyőrző szöveg',
      placeholderTooltip: 'Add meg a helyőrző szöveget',
      button: 'Gomb',
      buttonTooltip: 'Szöveg, amely motiválja a látogatót az e-mail megadására (10% kedvezmény, feliratkozás most, fájl letöltése stb.)',
      successMessage: 'Sikerüzenet',
      successMessageTooltip: 'A feliratkozók sikerüzenete',
      botURL: 'Bot URL (opcionális)',
      botURLTooltip: 'Add meg a botod URL-jét',
      botToken: 'Bot token',
      botTokenTooltip: 'Add meg a botod tokenjét',
      rewards: 'Válaszok',
      rewardsTooltip: 'Adj hozzá válaszokat a feliratkozóidnak',
      addReward: 'Válasz hozzáadása',
      thankYou: 'Köszönő üzenet',
      email: {
        none: 'Nincs',
        display: 'Válasz azonnali megjelenítése',
        send: 'Válasz küldése e-mailben',
        redirect: 'Átirányítás URL-re',
      },
      phone: {
        none: 'Nincs',
        display: 'Válasz azonnali megjelenítése',
        send: 'Válasz küldése telefonra',
        redirect: 'Átirányítás URL-re',
      },
      telegram: {
        none: 'Nincs',
        display: 'Válasz azonnali megjelenítése',
        send: 'Válasz küldése Telegram botban',
        redirect: 'Átirányítás URL-re',
      },
      whatsapp: {
        none: 'Nincs',
        display: 'Válasz azonnali megjelenítése',
        send: 'Válasz küldése WhatsApp botban',
        redirect: 'Átirányítás URL-re',
      },
      instagram: {
        none: 'Nincs',
        display: 'Válasz azonnali megjelenítése',
        send: 'Válasz küldése Instagram botban',
        redirect: 'Átirányítás URL-re',
      },
      messenger: {
        none: 'Nincs',
        display: 'Válasz azonnali megjelenítése',
        send: 'Válasz küldése Messenger botban',
        redirect: 'Átirányítás URL-re',
      },
      viber: {
        none: 'Nincs',
        display: 'Válasz azonnali megjelenítése',
        send: 'Válasz küldése Viber botban',
        redirect: 'Átirányítás URL-re',
      },
      connect: 'Csatlakozás',
      toChangeReward: 'A válasz típusának módosításához el kell távolítanod a jelenlegit',
      remove: 'Eltávolítás',
      viewTypes: 'Nézettípusok',
    },
    form: {
      blockTitle: 'Űrlap',
      blockText: 'Lehetővé teszi, hogy információt és adatokat gyűjts a közönségedtől',
      blockShortText: 'Információ gyűjtése',
      fields: 'Mezők',
      fieldsTooltip: 'Adj hozzá mezőket az űrlaphoz',
      addCustomField: 'Egyéni mező hozzáadása',
      addItem: 'Elem hozzáadása',
      editItem: 'Elem szerkesztése',
      type: 'Típus',
      typeTooltip: 'Válassz mezőtípust',
      string: 'Rövid válasz',
      textarea: 'Hosszú válasz',
      dropdown: 'Legördülő menü',
      radio: 'Választógomb',
      checkbox: 'Jelölőnégyzet',
      date: 'Dátum',
      time: 'Idő',
      country: 'Ország',
      fieldName: 'Mező neve',
      fieldNameTooltip: 'Add meg a mező nevét',
      name: 'Név',
      placeholder: 'Helyőrző szöveg',
      placeholderTooltip: 'Add meg a helyőrző szöveget',
      required: 'Kötelező',
      requiredTooltip: 'Jelöld be, ha a mező kötelező',
      value: 'Érték',
      enterTitle: 'Add meg a címet',
      addValue: 'Érték hozzáadása',
      delete: 'Törlés',
      update: 'Frissítés',
      add: 'Hozzáadás',
      confirmationPage: 'Megerősítési művelet',
      confirmationPageSubtitle: 'Válassz eredményműveletet az űrlap beküldése után',
      successMessage: 'Sikerüzenet',
      successMessageTooltip: 'Sikerüzenet az űrlap beküldése után',
      thankYou: 'Köszönő üzenet',
      submit: 'Beküldés',
    },
    contact: {
      blockTitle: 'Kapcsolatok',
      blockText:
        'A Kapcsolatok blokk lehetővé teszi, hogy a felhasználók közvetlenül kommunikáljanak veled. Add hozzá a telefonszámodat, e-mail címedet, üzenetküldődet vagy helyszínedet',
      blockShortText: 'Kommunikáció a felhasználókkal',
      addNewContact: 'Új kapcsolat hozzáadása',
      newContact: 'Új kapcsolat',
      friendlyName: 'Megjelenített név',
    },
    faq: {
      blockTitle: 'GYIK',
      blockText: 'Gyakran Ismételt Kérdések — a felhasználók által gyakran feltett kérdésekre adott válaszok listája',
      blockShortText: 'Gyakori kérdések',
      addNewItem: 'Új elem hozzáadása',
      editItem: 'Elem szerkesztése',
      title: 'Cím',
      titleTooltip: 'Add meg a címet',
      description: 'Leírás',
      descriptionTooltip: 'Add meg a leírást',
      update: 'Frissítés',
      add: 'Hozzáadás',
      howToFind: 'Hogyan találj ránk',
      view: 'Nézet',
      viewTooltip: 'Válassz megjelenítési módot a GYIK elemekhez',
      feed: 'Lista',
      slider: 'Csúszka',
      emptyTitle: 'Még nincs semmilyen elemed',
      emptyText: 'Add hozzá az első kérdésedet, hogy feltöltsd ezt a blokkot.',
    },
    ama: {
      blockTitle: 'Kérdezz bármit',
      blockShortText: 'Válaszolj a követők kérdéseire',
      blockText: 'Engedd, hogy a közönséged kérdéseket tegyen fel, és válaszolj rájuk közvetlenül az oldaladon',
    },
    feature: {
      blockTitle: 'Jellemzők',
      blockText: 'Szöveges szakasz képpel, hogy elmondd a felhasználóidnak, miért a legjobb a vállalkozásod',
      blockShortText: 'Mondd el a felhasználóidnak, miért',
      title: 'Cím',
      titleTooltip: 'Az elem címének módosítása',
      description: 'Leírás',
      descriptionTooltip: 'Az elem leírásának módosítása',
    },
    highlight: {
      blockTitle: 'Kiemelések',
      blockText: 'Emeld ki a legfontosabb linkeket bélyegképekkel (max. 3)',
      blockShortText: 'Emeld ki a legfontosabbakat',
      title: 'Cím',
      titleTooltip: 'Az elem címének módosítása',
      url: 'URL',
      urlTooltip: 'Az elem URL-jének módosítása',
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Emelj ki egy képet, videót vagy legújabb terméket, hogy kitűnjön. CTA gombot is hozzáadhatsz, hogy a felhasználókat a konverziós cél felé vezesd',
      blockShortText: 'Emelj ki egy képet, videót',
      height: 'Magasság',
      heightTooltip: 'Módosítsd a banner magasságát',
    },
    slider: {
      blockTitle: 'Csúszka',
      blockText: 'Képkarusszel, amellyel bemutathatod a képes tartalmadat és különböző funkciókat adhatsz hozzá',
      blockShortText: 'Képkarusszel',
      image: 'Kép',
      imageTooltip: 'A galériád képe',
      addText: 'Szöveg hozzáadása',
      title: 'Cím',
      titleTooltip: 'A dia címe',
      titleSize: 'Cím mérete',
      titleSizeTooltip: 'Válassz méretet a jobb olvashatóság érdekében',
      description: 'Leírás',
      descriptionTooltip: 'A dia leírása',
      textColor: 'Szöveg színe',
      addButton: 'Gomb hozzáadása',
      url: 'URL',
      urlTooltip: 'A képed URL-je',
      button: 'Gomb',
      buttonTooltip: 'A gombod címe',
      buttonText: 'Gomb szövege',
      buttonColor: 'Gomb színe',
      height: 'Magasság',
      heightTooltip: 'Módosítsd a diák magasságát',
      view: 'Nézet',
      viewTooltip: 'Válassz nézetet a csúszkához',
      auto: 'Automatikus',
      square: 'Négyzet',
      rectangle: 'Téglalap',
      single: 'Egyes',
      multi: 'Több',
    },
    gallery: {
      blockTitle: 'Galéria',
      blockText: 'Képkarusszel, amellyel bemutathatod a képes tartalmadat',
      blockShortText: 'Képkarusszel',
      image: 'Kép',
      imageTooltip: 'A galéria elem képe',
      layout: 'Elrendezés',
      layoutTooltip: 'Válassz elrendezést a galériához',
      feed: 'Lista',
      slider: 'Csúszka',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Hozz létre blogot a bejegyzéseidből',
      blockShortText: 'Blog létrehozása',
      writeYourStory: 'Írd meg a történeted',
      shortDescription: 'Rövid leírás',
      shortDescriptionTooltip: 'Opcionális leírás a blogodhoz',
      description: 'Leírás',
    },
    map: {
      blockTitle: 'Térkép',
      blockText: 'Adj hozzá Google térképet, hogy segíts a felhasználóknak eljutni a helyi vállalkozásodhoz',
      blockShortText: 'Google térkép hozzáadása',
      buttonText: 'Gomb szövege',
      buttonTextTooltip: 'A gomb akkor jelenik meg, ha a második nézet van kiválasztva',
      text: 'Szöveg',
      addAddress: 'Másik cím hozzáadása',
      address: 'Cím',
      addressTooltip: 'Illessz be egy címet például a Google Térképről',
      googleMap: 'Google térkép (beágyazási kód)',
      googleMapTooltip: 'Illessz be egy beágyazási kódot a Google Térképről',
      howToFind: 'Hogyan találod meg a beágyazási kódot',
      incorrectCode: 'Helytelen beágyazási kód.',
      moreInfo: 'Bővebb információ',
      code: 'Kód',
      addressSettings: 'Cím beállításai',
      addressContent: 'Adj hozzá URL-t, címet és gomb szöveget vagy ikont',
      title: 'Cím',
      titleTooltip: 'A címed neve',
      url: 'URL',
      urlTooltip: 'Illessz be egy cím URL-t például a Google Térképről',
      directionText: 'Útirány szövege',
      directionTextTooltip: 'Cselekvésre ösztönző szöveg a felhasználóidnak',
    },
    footer: {
      blockTitle: 'Lábjegyzet',
      blockText: 'Az oldal legalján található tartalmi szakasz. Hozzáadhatsz elérhetőségi adatokat, közösségi média ikonokat és e-mail feliratkozási űrlapot',
      blockShortText: 'Alsó tartalmi szakasz',
      addBlock: 'Blokk hozzáadása',
      blockType: 'Blokk típusa',
      blockTypeTooltip: 'Válassz blokktípust',
      addBlockTitle: 'Blokk címe',
      addBlockTitleTooltip: 'Válassz blokkcímet',
      faq: 'GYIK',
      'data-collect': 'Adatgyűjtés',
      contact: 'Kapcsolat',
      pages: 'Oldalak',
      payments: 'Fizetések',
      social: 'Közösségi',
      cancel: 'Mégse',
      add: 'Hozzáadás',
      None: 'Nincs',
      text: 'Szöveg',
      link: 'Linkek',
      image: 'Kép',
      divider: 'Elválasztó',
      linkViewLabel: 'Elrendezés',
      linkViewTooltip: 'Hogyan legyenek elrendezve a linkek',
      linkViewSingle: 'Egymás alatt',
      linkViewRow: 'Egy sorban',
      linkItemsLabel: 'Linkek',
      linkItemsTooltip: 'Adj hozzá legfeljebb 5 linket (pl. Adatvédelmi tájékoztató, Feltételek)',
      linkLabelPlaceholder: 'Címke',
      linkUrlPlaceholder: 'URL',
      linkAddMore: '+ Link hozzáadása',
      alignLabel: 'Igazítás',
      alignTooltip: 'Vízszintes igazítás',
      alignLeft: 'Balra',
      alignCenter: 'Középre',
      alignRight: 'Jobbra',
      imageLabel: 'Kép',
      imageTooltip: 'Tölts fel egy logót vagy képet',
      imageLinkLabel: 'Link (opcionális)',
      imageLinkTooltip: 'Tedd a képet kattinthatóvá',
      dividerLabel: 'Elválasztó típusa',
      dividerTooltip: 'Vonal vagy üres hely',
      dividerLine: 'Vonal',
      dividerSpace: 'Hely',
      picker: {
        subtitle: 'Válassz egy elemet a lábjegyzetedhez',
        configureSubtitle: 'Konfiguráld, majd add hozzá a lábjegyzetedhez',
        back: 'Vissza',
        saveButton: 'Mentés',
        availableTitle: 'Hozzáadható',
        addedTitle: 'Már hozzáadva',
        addedLabel: 'Hozzáadva',
        addButton: 'Blokk hozzáadása',
        linkTitle: 'Linkek',
        linkSub: 'Gombok bármely URL-hez',
        socialTitle: 'Közösségi',
        socialSub: 'Ikonok a közösségi profilokhoz',
        textTitle: 'Szöveg',
        textSub: 'Egy fejlécszöveg vagy bekezdés',
        pagesTitle: 'Oldalak',
        pagesSub: 'Link beágyazott aloldalakhoz',
        paymentsTitle: 'Fizetések',
        paymentsSub: 'Elfogadott fizetési módok',
        imageTitle: 'Kép',
        imageSub: 'Egy logó vagy kép',
        dividerTitle: 'Elválasztó',
        dividerSub: 'Egy vonal vagy térköz',
        faqTitle: 'GYIK',
        faqSub: 'Gyakran ismételt kérdések',
        dataCollectTitle: 'Adatgyűjtés',
        dataCollectSub: 'E-mail feliratkozási űrlap',
        contactTitle: 'Kapcsolat',
        contactSub: 'Elérhetőségi adatok',
        importMode: 'Importálás blokkból',
        manualMode: 'Kézi hozzáadás',
        noContactsToImport: 'Nincs importálható kapcsolat — add hozzá kézzel.',
        noSocialsToImport: 'Nincs importálható közösségi ikon — add hozzá kézzel.',
        manualItemsLabel: 'Elemek',
        manualItemsTooltip: 'Válassz egy típust, és add meg az értékét.',
        contactValuePlaceholder: '@felhasználónév / e-mail / telefon',
        socialUrlPlaceholder: 'https://...',
        addMore: '+ Több hozzáadása',
      },
      faqText: 'A gyakran ismételt kérdéseket a GYIK blokkban szerkesztheted. Ide kattintva navigálhatsz oda',
      socialText: 'A közösségi ikonokat a Fejléc blokkban szerkesztheted. Ide kattintva navigálhatsz oda',
      dataCollectText: 'Az adatgyűjtést az Adatgyűjtés blokkban szerkesztheted. Ide kattintva navigálhatsz oda',
      contactText: 'A kapcsolatot a Kapcsolat blokkban szerkesztheted. Ide kattintva navigálhatsz oda',
      contactDesign: {
        editSource: 'Szerkeszd magukat a kapcsolatokat a Kapcsolat blokkban —',
        variantLabel: 'Stílus',
        variantList: 'Lista',
        variantButton: 'Gomb',
        shapeLabel: 'Forma',
        shape_square: 'Négyzet',
        shape_rounded: 'Kerekített',
        shape_pill: 'Pill',
        widthLabel: 'Szélesség',
        widthFull: 'Teljes',
        widthHalf: 'Fél',
        widthHalfStacked: 'Fél oszlop',
        borderLabel: 'Keret',
        borderOn: 'Be',
        borderOff: 'Ki',
        borderColorLabel: 'Keret színe',
      },
      pagesText: 'Új oldalakat adhatsz hozzá a Weboldalon',
      paymentsText: 'A fizetési módok megjelennek',
      showOnAllpages: 'Megjelenítés minden oldalon',
      layout: 'Elrendezés',
      splitImage: 'Oldalsó kép',
      footerText: 'A Kezdőlap lábjegyzete jelenleg engedélyezve van.',
      editSocialIcons: 'A közösségi ikonokat a Fejléc szakaszban szerkesztheted. Ide kattintva navigálhatsz oda',
      editSubscribe: 'A feliratkozást a Feliratkozás szakaszban szerkesztheted. Ide kattintva navigálhatsz oda',
      editContacts: 'A kapcsolatokat a Kapcsolatok szakaszban szerkesztheted. Ide kattintva navigálhatsz oda',
      editFrequently: 'A gyakran ismételt kérdéseket a GYIK szakaszban szerkesztheted. Ide kattintva navigálhatsz oda',
    },
    'chat-ai': {
      blockTitle: 'AI Chat',
      blockShortText: 'Csevegés AI-val',
      blockText: 'Csevegés AI-val',
      suggestionsTitle: 'Javaslatok',
      suggestionsSubtitle: 'Gyors promptok',
    },
    custom: {
      blockTitle: 'Egyéni',
      blockShortText: 'AI-alapú blokk',
      blockText: 'Írj le egy mini interaktív alkalmazást, és az AI legenerálja neked',
    },
    shop: {
      blockTitle: 'Bolt',
      blockText: 'Add hozzá a terméklistádat',
      blockShortText: 'Add hozzá a termékeidet',
      view: 'Nézet',
      cardLayout: 'Kártya elrendezés',
      cardLayoutTooltip: 'A Showcase minden terméket részletes értékesítési kártyaként jelenít meg, soronként egyet',
      standardCards: 'Standard',
      showcaseCards: 'Showcase',
      products: 'Termékek',
      categories: 'Kategóriák',
      featured: 'Kiemelt',
    },
    digital: {
      blockTitle: 'Digitális termékek',
      blockText: 'Adj el digitális letöltést: PDF-ek, táblázatok, sablonok, exkluzív tartalmak',
      blockShortText: 'Adj el digitálisan',
    },
    podcast: {
      blockTitle: 'Podcastok',
      blockText: 'Mutasd be a podcastjaidat',
      blockShortText: 'Mutasd be a podcastjaidat',
    },
    'page-list': {
      blockTitle: 'Oldallista',
      blockText: 'Hozd létre az oldalaid listáját',
      description: 'Leírás',
      blockShortText: 'Hozd létre az oldalaid listáját',
      addNewPageItem: 'Oldal hivatkozás hozzáadása',
    },
    appointment: {
      blockTitle: 'Foglalások',
      blockText: 'Hagyd, hogy a látogatók időpontot foglaljanak a naptáradban',
      blockShortText: 'Engedd a foglalást',
    },
    service: {
      blockTitle: 'Szolgáltatások',
      blockText: 'E-mail értesítést kapsz, amikor kérést küldenek neked',
      blockShortText: 'E-mail értesítés',
    },
    requests: {
      blockTitle: 'Szolgáltatások',
      blockText: 'E-mail értesítést kapsz, amikor kérést küldenek neked',
      blockShortText: 'E-mail értesítés',
    },
    tips: {
      blockTitle: 'Borravaló',
      blockText: 'Az UniLink szórakoztatóvá és egyszerűvé teszi a támogatást. Néhány koppintással a rajongóid fizethetnek és üzenetet hagyhatnak',
      blockShortText: 'Szórakoztató támogatás',
    },
    tip: {
      blockTitle: 'Borravaló',
      blockText: 'Az UniLink szórakoztatóvá és egyszerűvé teszi a támogatást. Néhány koppintással a rajongóid fizethetnek és üzenetet hagyhatnak',
      blockShortText: 'Szórakoztató támogatás',
    },
    donation: {
      blockTitle: 'Adományok',
      blockText: 'Az UniLink szórakoztatóvá és egyszerűvé teszi a támogatást. Néhány koppintással a rajongóid fizethetnek és üzenetet hagyhatnak',
      blockShortText: 'Szórakoztató támogatás',
    },
    course: {
      blockTitle: 'Kurzus vagy oktatóanyag',
      blockText: 'Hagyd, hogy a látogatók időpontot foglaljanak a naptáradban',
      blockShortText: 'Engedd a foglalást',
    },
    event: {
      blockTitle: 'Események vagy jegyek',
      blockText: 'Engedd, hogy a közönség megnézze az eseményeidet',
      blockShortText: 'Mutasd az eseményeidet',
    },
    menu: {
      blockTitle: 'Menü',
      blockText: 'Hozz létre egyedi menüt árakkal',
      blockShortText: 'Egyedi menü létrehozása',
    },
    recipe: {
      blockTitle: 'Recept',
      blockText: 'Oszd meg a receptet hozzávalókkal, lépésekkel és fotókkal',
      blockShortText: 'Oszd meg a receptet',
    },
    booking: {
      blockTitle: 'Foglalás',
      blockText: 'Hagyd, hogy a látogatók lefoglalják a helyiségeidet',
      blockShortText: 'Engedd a foglalást',
      name: 'Név',
      nameCaption: 'Add meg a helyiség nevét',
      description: 'Leírás',
      descriptionCaption: 'Rövid leírás erről a helyiségről',
      rentalType: 'Bérlés típusa',
      rentalTypeCaption: 'Például: lakás, autó, iroda',
      duration: 'Időtartam',
      durationCaption: 'Például: naponta, hetente, havonta',
      price: 'Ár',
      priceCaption: 'Alapár ehhez a helyiséghez',
      oldPrice: 'Régi ár',
      oldPriceCaption: 'Opcionális korábbi ár',
      rating: 'Értékelés',
      ratingCaption: 'Átlagos értékelés (opcionális)',
      label: 'Címke',
      labelCaption: 'Rövid jelvény, például HOT vagy NEW',
      image: 'Kép',
      imageCaption: 'Tölts fel borítóképet ehhez a helyiséghez',
      location: 'Helyszín',
      locationCaption: 'Város, terület vagy cím',
      capacity: 'Kapacitás (vendégek)',
      capacityCaption: 'Maximális vendégszám',
      rooms: 'Helyiségek és terület',
      roomsCaption: 'Hálószobák, fürdőszobák és terület',
      bedrooms: 'Hálószobák',
      bathrooms: 'Fürdőszobák',
      areaSqM: 'Terület (m²)',
      minStay: 'Minimális tartózkodás (nap)',
      minStayCaption: 'A foglaláshoz szükséges minimális napok száma',
      requiresDeposit: 'Előleg szükséges',
      depositAmount: 'Előleg összege',
      depositAmountCaption: 'Előre fizetendő előleg a foglalás megerősítéséhez',
      noSmoking: 'Dohányzás tilos',
      noPets: 'Háziállatok tilosak',
      amenitiesWifi: 'Wi-Fi',
      amenitiesParking: 'Parkolás',
      amenitiesKitchen: 'Konyha',
      amenitiesHeating: 'Fűtés',
      amenitiesAC: 'Légkondicionálás',
      amenitiesPool: 'Medence',
      amenitiesSauna: 'Szauna',
      amenitiesRestrooms: 'Mosdók',
      validationNameRequired: 'A név megadása kötelező',
      validationPriceRequired: 'Az árnak nem negatív számnak kell lennie',
      validationDepositRequired: 'Az előleg összege kötelező, ha az előleg engedélyezve van',
      validationCapacityNumber: 'A kapacitásnak nem negatív számnak kell lennie',
      validationOldPriceNumber: 'A régi árnak nem negatív számnak kell lennie',
      brand: 'Márka',
      brandCaption: 'Autómárka, például Tesla',
      model: 'Modell',
      modelCaption: 'Autómodell, például Model 3',
      year: 'Évjárat',
      yearCaption: 'Gyártási év',
      color: 'Szín',
      colorCaption: 'Külső szín, például fekete',
      fuelType: 'Üzemanyag típusa',
      fuelTypeCaption: 'Benzin, dízel, elektromos, hibrid stb.',
      transmission: 'Váltó',
      transmissionCaption: 'Automata vagy manuális',
      seatCount: 'Ülések száma',
      seatCountCaption: 'Az autó üléseinek száma',
      edit: 'Elem szerkesztése',
      add: 'Elem hozzáadása',
    },
    membership: {
      blockTitle: 'Tagság',
      blockText: 'Hozz létre ingyenes vagy fizetős előfizetést a tartalmadhoz',
      blockShortText: 'Előfizetés létrehozása',
    },
    pricing: {
      blockTitle: 'Árazás',
      blockText: 'Hozz létre egyedi menüt árakkal',
      blockShortText: 'Egyedi menü létrehozása',
      name: 'Név',
      nameTooltip: 'Add meg a terméked nevét',
      pricingPlanName: 'Árazási csomag neve',
      pricingPlanNameTooltip: 'Add meg az árazási csomagod nevét',
      description: 'Leírás',
      descriptionTooltip: 'Add meg a terméked leírását',
      pricingPlanDescriptionTooltip: 'Add meg az árazási csomagod leírását',
      priceValue: 'Ár értéke',
      priceUnit: 'Ár egysége',
      label: 'Címke',
      labelTooltip: 'Add meg az árazási csomagod címkéjét',
      orderButtonText: 'Rendelés gomb szövege',
      orderButtonTextDescriptionTooltip: 'Add meg az árazási csomagod rendelés gombjának szövegét',
      orderButtonLink: 'Rendelés gomb hivatkozása',
      orderButtonLinkDescriptionTooltip: 'Add meg az árazási csomagod rendelés gombjának hivatkozását',
      subtitle: 'Alcím',
      subtitleTooltip: 'Add meg a terméked alcímét',
      price: 'Ár',
      priceTooltip: 'Add meg a terméked árát',
      pricingTiers: 'Árazási szintek',
      pricingTiersTooltip: 'Add meg a terméked árazási szintjeit',
      addPriceValue: 'Több ár hozzáadása',
      group: 'Csoport',
      groupTooltip: 'Válaszd ki a terméked csoportját',
      image: 'Kép',
      imageTooltip: 'Tölts fel képet a terékedhez',
      unit: 'Ár egysége',
      unitTooltip: 'Add meg az áradad egységét',
      addUnitTitle: 'Ár egységei',
      addPriceUnitValue: 'Több ár egység hozzáadása',
      addUnitButtonText: 'Mentés',
      button: 'Gomb',
      buttonTooltip: 'Adj hozzá gombot a terékedhez',
      buttonAddText: '+ Gomb hozzáadása',
      buttonModalTextField: 'Gomb szövege',
      buttonModalTextFieldTooltip: 'Add meg a gomb szövegét',
      buttonModalURLField: 'Gomb URL-je',
      buttonModalURLFieldTooltip: 'Add meg a gomb URL-jét',
      buttonModalTitle: 'Gomb hozzáadása',
      groups: {
        title: 'Csoportok',
        subtitle: 'Csoportok hozzáadása, szerkesztése és törlése',
        groups: 'Csoportok',
        groupsTooltip: 'Csoportok hozzáadása, szerkesztése és törlése',
        addNewGroup: 'Új csoport hozzáadása',
        newGroup: 'Új csoport',
        titleGroup: 'Cím',
        titleGroupTooltip: 'Add meg a csoportod címét',
        descriptionGroup: 'Leírás',
        descriptionGroupTooltip: 'Add meg a csoportod leírását',
      },
    },
    menuBlock: {
      title: 'Menü',
      subtitle: 'Hozz létre menüt elemekkel és árakkal',
      add: 'Új elem hozzáadása',
      edit: 'Elem szerkesztése',
      name: 'Név',
      nameCaption: 'Add meg az elem nevét',
      description: 'Leírás',
      descriptionCaption: 'Adj meg egy rövid leírást',
      ingredients: 'Hozzávalók',
      ingredientsCaption: 'Sorold fel a hozzávalókat vagy összetételt',
      price: 'Ár',
      priceCaption: 'Add meg az árat',
      weight: 'Súly (g)',
      weightCaption: 'Add meg a súlyt grammban',
      calories: 'Kalória (kcal)',
      caloriesCaption: 'Add meg a kalóriát kcal-ban',
      label: 'Címke',
      labelCaption: 'Add meg a címke szövegét',
      labelColor: 'Címke színe',
      labelColorCaption: 'Válaszd ki a címke háttérszínét',
      image: 'Kép',
      imageCaption: 'Tölts fel képet az elemedhez',
      available: 'Rendelhető',
      visible: 'Látható az oldalon',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Jelenítsd meg NFT-det az OpenSea platformról vagy a saját pénztáradból',
      blockShortText: 'Jelenítsd meg az NFT-det',
    },
    wallet: {
      wallet: 'Pénztár',
      blockTitle: 'Bank/Kripto pénztár',
      blockText: 'Jelenítsd meg bankkártyádat vagy Bitcoin pénztáradat, hogy a felhasználóid könnyebben átmásolhassák az átutaláshoz',
      blockShortText: 'Jelenítsd meg a pénztáraidat',
      title: 'Cím',
      titleTooltip: 'A pénztárad címe',
      walletNumber: 'Pénztár száma',
      walletNumberTooltip: 'Illeszd be a pénztárad számát',
      icon: 'Ikon',
      iconTooltip: 'Állítsd be a pénztárad ikonját',
      card: 'Kártya',
      bank: 'Bank',
      crypto: 'Kripto',
      transfer: 'Átutalás',
      paymentLink: 'Fizetési hivatkozás',
      cardNumber: 'Kártyaszám',
      cardNumberTooltip: 'Illeszd be a kártyaszámodat',
      cardHolder: 'Kártyabirtokos',
      cardHolderTooltip: 'Add meg a kártyabirtokost',
      bankAccountDetails: 'Bankszámla adatai',
      bankAccountDetailsTooltip: 'Add meg a bankszámlád adatait',
      walletAddress: 'Pénztár címe',
      walletAddressTooltip: 'Add meg a pénztárad címét',
      network: 'Hálózat',
      networkTooltip: 'Add meg a hálózatodat',
      publicKey: 'Nyilvános kulcs',
      publicKeyTooltip: 'Add meg a nyilvános kulcsodat',
      providerName: 'Szolgáltató neve',
      providerNameTooltip: 'Add meg a szolgáltatód nevét',
      link: 'Hivatkozás',
      linkTooltip: 'Add meg a hivatkozásodat',
      serviceName: 'Szolgáltatás neve',
      serviceNameTooltip: 'Add meg a szolgáltatásod nevét',
      email: 'E-mail',
      emailTooltip: 'Add meg az e-mail címedet',
      phone: 'Telefon',
      phoneTooltip: 'Add meg a telefonszámodat',
      username: 'Felhasználónév',
      usernameTooltip: 'Add meg a felhasználóneved',
      fullName: 'Teljes név',
      fullNameTooltip: 'Add meg a teljes nevedet',
      referenceNumber: 'Referenciaszám',
      referenceNumberTooltip: 'Add meg a referenciaszámodat',
      country: 'Ország',
      countryTooltip: 'Add meg az országodat',
      transferProvider: 'Átutalási szolgáltató',
      transferProviderTooltip: 'Add meg az átutalási szolgáltatódat',
      cryptoCurrency: 'Kriptovaluta',
      cryptoCurrencyTooltip: 'Add meg a kriptovalutádat',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Mutasd be a legjobb Instagram médiádat és videóidat, vagy add el termékeidet vásárolható Instagram-hírfolyammal',
      blockShortText: 'A legjobb Instagram médiád',
      blockConnectTitle: 'Az Instagram nincs csatlakoztatva',
      blockConnectText: 'Úgy tűnik, az Instagram termékeid még nincsenek importálva. Csatlakoztasd fiókodat most',
      blockConnectButton: 'Instagram hozzáadása',
      emptyList: 'Még nincs Instagram médiád.',
      addInstagramUsername: 'Instagram felhasználónév hozzáadása',
      username: 'Felhasználónév',
      downloadTakes: 'A letöltés akár 2 percet is igénybe vehet',
      displayPost: 'Bejegyzés megjelenítése a weboldaladon',
      view: 'Megtekintés',
      redirect: 'URL átirányítás',
      text: 'Szöveg és gomb',
      actionType: 'Művelet típusa',
      url: 'URL',
      openInNewTab: 'Megnyitás új lapon',
      delete: 'Törlés',
      cancel: 'Mégse',
      save: 'Mentés',
      editMedia: 'Média szerkesztése',
      title: 'Cím',
      automation: 'Automatizálás',
      automationText: 'Automatizáld fiókodat az Autopilot funkciókkal',
      autopilot: 'Autopilot',
      autopilotTooltip: 'Tölts fel bejegyzést a minta feliratozással, és a termékcímkéid/hivatkozásaid automatikusan létrejönnek',
      switchTitle: 'Cím, ár és hivatkozások automatikus felismerése',
      sampleCaption: 'Minta feliratozás: #49.99 #NiceDress https://google.com',
      integrations: 'Integrációk',
      integrationsText: 'Adj hozzá Instagramot a weboldaladhoz',
      connectInstagram: 'Instagram csatlakoztatása',
      connectInstagramText: 'Csatlakoztasd Instagram fiókodat, hogy megjelenítsd a kiválasztott bejegyzéseket vagy reeleket.',
      selectAccount: 'Fiók kiválasztása',
      connectNewInstagram: 'Új Instagram fiók csatlakoztatása',
      continue: 'Folytatás',
      disconnectInstagram: 'Instagram leválasztása',
      addTag: 'Címke hozzáadása',
      tagClickHint: 'Kattints a képre a címke elhelyezéséhez',
      tagPositionSet: 'Pozíció beállítva. Töltsd ki az alábbi adatokat.',
      tagTypeLink: 'Hivatkozás',
      tagTypeProduct: 'Termék',
      tagLabel: 'Címke',
      tagSelectProduct: 'Termék kiválasztása',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Mutasd be a legjobb TikTok videódat, vagy add el termékeidet vásárolható TikTok-hírfolyammal',
      blockShortText: 'A legjobb TikTok videód',
      addTikTok: 'TikTok fiók hozzáadása',
      individualVideo: 'Egyedi videó',
      videoCollection: 'Videógyűjtemény',
      add: 'Hozzáadás',
      blockConnectTitle: 'A TikTok nincs csatlakoztatva',
      blockConnectText: 'Úgy tűnik, a TikTok termékeid még nincsenek importálva. Csatlakoztasd fiókodat most',
      blockConnectButton: 'TikTok csatlakoztatása',
      enterUsername: 'Add meg a felhasználónevet',
      enterVideo: 'Add meg egy TikTok videó URL-jét',
      emptyList: 'Még nincs TikTok médiád.',
      editMedia: 'Média szerkesztése',
      addTikTokVideo: 'TikTok videó hozzáadása',
      displayPost: 'Bejegyzés megjelenítése a weboldaladon',
      delete: 'Törlés',
      cancel: 'Mégse',
      save: 'Mentés',
      integrations: 'Integrációk',
      integrationsText: 'Adj hozzá TikTokot a weboldaladhoz',
      connectTikTok: 'TikTok csatlakoztatása',
      disconnectTikTok: 'TikTok leválasztása',
      individualText: `Nem csatlakoztathatsz TikTok fiókot ehhez a blokktípushoz ('individual').`,
      individualText2: 'Kérjük, adj hozzá egyedi TikTok videót helyette.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Mutasd be egy YouTube videót vagy stream-et az oldaladon. Címkézz termékeket a YouTube videón',
      blockShortText: 'Mutass be egy YouTube videót',
      enterYouTubeLink: 'Add meg a YouTube URL-t',
      enterYouTubeLinkTooltip: 'Illeszd be a YouTube URL-t',
    },
    overview: {
      blockTitle: 'Áttekintés',
      blockText: 'Mutasd be egy videót vagy stream-et az oldaladon. Címkézz termékeket a videón',
      blockShortText: 'Címkézz termékeket a videón',
    },
    video: {
      blockTitle: 'Videó',
      blockText: 'Mutasd be egy videót vagy stream-et az oldaladon. Címkézz termékeket a videón',
      blockShortText: 'Mutass be egy videót',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Jelenítsd meg tweetjeidet a UniLink oldaladon az elköteleződés növeléséhez',
      blockShortText: 'Jelenítsd meg a tweetjeidet',
      twitterURL: 'Twitter URL',
      twitterURLTooltip: 'Adj hozzá URL-t a Twitterről a beágyazott kód generálásához',
      enterTwitterURL: 'Add meg egy Twitter URL-t',
    },
    music: {
      blockTitle: 'Zene',
      blockText: 'Ágyazz be Spotify, SoundCloud számot, lejátszási listát, vagy tölts fel saját hangfájlt',
      blockShortText: 'Add hozzá a zenédet',
      brand: 'Márka',
      brandTooltip: 'Válaszd ki a zenéd hozzáadásának típusát',
      url: 'URL',
      embed: 'Beágyazott kód',
      custom: 'Egyéni',
      musicUrl: 'Zene URL-je',
      musicUrlTooltip: 'Add meg a zene URL-jét',
      embedCodeTitle: 'Beágyazott kód',
      embedCodeTooltip: 'Illeszd be a számod beágyazott kódját a kiválasztott zenei platformról',
      audioFile: 'Hangfájl',
      uploadAudios: 'Itt csak hangfájlt tölthetsz fel',
      title: 'Cím',
      titleTooltip: 'Add meg a zenéd címét',
      artist: 'Előadó',
      artistTooltip: 'Add meg a zenéd előadóját',
      audioFileTitle: 'Hangfájl',
      audioFileTooltip: 'A hangfájlod neve',
      coverImage: 'Borítókép',
      coverImageTooltip: 'Tölts fel képet a zenédhez',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Ágyazz be Twitch videót vagy stream-et az oldaladon',
      blockShortText: 'Ágyazz be Twitch videót',
      twitchURL: 'Twitch URL',
      twitchURLTooltip: 'Illeszd be a csatorna URL-jét vagy nevét',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Twitch csatornám megjelenítése',
      displayChat: 'Twitch csatornám és a chat megjelenítése egyaránt',
    },
    splash: {
      blockTitle: 'Splash képernyő',
      blockText: 'Teljes képernyős banner szöveggel és gombbal, amely a webhely betöltése előtt jelenik meg, hogy bemutasson egy terméket vagy eseményt',
      blockShortText: 'Teljes képernyős banner',
    },
    promo: {
      blockTitle: 'Promó sáv',
      blockText: 'Kiemelés, amely lehetővé teszi az akciók megjelenítését',
      blockShortText: 'Emeld ki az akcióidat',
    },
    welcome: {
      blockTitle: 'Üdvözlő üzenet',
      blockText: 'Írj üdvözlő üzeneteket, amelyek a látogatókat csevegésre ösztönzik. Az oldal alján megjelenik, hogy köszöntse a látogatókat és segítséget ajánljon',
      blockShortText: 'Írj üdvözlő üzeneteket',
    },
    review: {
      blockTitle: 'Vélemények',
      blockText: 'A vélemények segítenek az ügyfeleknek jobban megismerni a terméket, és eldönteni, hogy megfelelő-e számukra',
      blockShortText: 'Vélemények segítik az ügyfeleket',
      name: 'Név',
      nameTooltip: 'Add meg a véleményező nevét',
      comment: 'Megjegyzés',
      commentTooltip: 'Add meg a véleményező megjegyzését',
      date: 'Dátum',
      dateTooltip: 'Add meg a véleményezés dátumát',
      rate: 'Értékelés',
      rateTooltip: 'Állítsd be a vélemény értékelését',
      image: 'Kép',
      imageTooltip: 'Tölts fel képet a véleményezőről',
    },
    coupon: {
      blockTitle: 'Kuponok',
      blockText: 'Az online kupon egy kedvezménykód vagy szám, amely beváltható egy weboldalon',
      blockShortText: 'Az online kupon egy kedvezménykód',
    },
    timer: {
      blockTitle: 'Időzítő',
      blockText: 'A visszaszámláló egy virtuális óra egy oldalon, amely egy adott számtól vagy dátumtól visszaszámol egy esemény vagy ajánlat kezdetének vagy végének jelzésére',
      blockShortText: 'Visszaszámláló',
    },
    outfit: {
      blockTitle: 'Ruhaösszeállítások',
      blockText: 'Hozd létre saját terméklistádat',
      blockShortText: 'Terméklista létrehozása',
    },
    spacer: {
      blockTitle: 'Térköz',
      blockText: 'Adj üres függőleges helyet az oldaladhoz',
      blockShortText: 'Adj üres helyet',
    },
    html: {
      blockTitle: 'HTML kód',
      blockText:
        'Beillesztheted saját HTML kódodat a UniLink oldaladra. A HTML egy szabványos jelölőnyelv weboldalak létrehozásához. Lehetővé teszi iframe-eket, szekciókat, bekezdéseket és hivatkozásokat.',
      blockShortText: 'Illeszd be saját HTML-edet',
      markupCode: 'Jelölőkód',
      markupCodeTooltip: 'Illeszd be a HTML jelölőkódodat',
      strippedWarning: 'Biztonsági okokból eltávolítva a megjelenítéskor:',
    },
    unlock: {
      blockTitle: 'Feloldás',
      blockText: 'Hozzáadhatod a zárolt tartalmadat a UniLink oldaladhoz.',
      blockShortText: 'Illeszd be a zárolt fájlodat',
    },
    file: {
      blockTitle: 'Fájl',
      blockText:
        'Ez a blokk lehetővé teszi fájlok — dokumentumok, képek vagy hangfájlok — feltöltését és megosztását. A látogatók közvetlenül az oldaladról megtekinthetik vagy letölthetik azokat.',
      blockShortText: 'Tölts fel és oszd meg a fájljaidat.',
      addNewItem: 'Új fájl hozzáadása',
      editFile: 'Fájl szerkesztése',
      fileName: 'Add meg a fájl nevét',
    },
    stat: {
      blockTitle: 'Statisztika',
      blockText:
        'Ez a blokk lehetővé teszi az oldaladról szóló legfontosabb adatok — például megtekintések, látogatók vagy elköteleződés — megjelenítését. Segít figyelemmel kísérni a közönségedet és megérteni az oldalad teljesítményét.',
      blockShortText: 'Adj statisztikát az oldaladhoz.',
      addNewItem: 'Új statisztika hozzáadása',
      editItem: 'Statisztika szerkesztése',
      statName: 'Add meg a statisztika nevét',
      statValue: 'Add meg a statisztika értékét',
      statDescription: 'Add meg a statisztika leírását',
      statItemFields: 'Válaszd ki a megjelenítendő mezőket.',
      feed: 'Hírfolyam',
      slider: 'Csúszka',
      titleSize: 'Cím mérete',
      subtitleTitleSize: 'Megváltoztathatod a cím méretét',
    },
    listing: {
      blockTitle: 'Hirdetés',
      blockText: 'Jelenítsd meg ingatlan- vagy tételhirdetéseket képekkel, adatokkal és árakkal.',
      blockShortText: 'Adj hirdetéseket az oldaladhoz.',
    },
    rental: {
      blockTitle: 'Bérlés',
      blockText: 'Listázz bérelhető ingatlanokat vagy tételeket elérhetőséggel és időszakos árazással.',
      blockShortText: 'Adj bérléseket az oldaladhoz.',
    },
    'single-product': {
      blockTitle: 'Egyedi termék',
      blockText: 'Mutass be egy terméket képpel, leírással és vásárlás gombbal.',
      blockShortText: 'Mutass be egy terméket.',
    },
    team: {
      blockTitle: 'Csapat',
      blockText: 'Mutasd be csapattagjaidat fotókkal, nevekkel, szerepekkel és közösségi hivatkozásokkal.',
      blockShortText: 'Mutasd be a csapatodat.',
    },
    timetable: {
      blockTitle: 'Órarend',
      blockText: 'Jelenítsd meg a heti ütemtervet órákkal, eseményekkel vagy foglalkozásokkal.',
      blockShortText: 'Adj hozzá egy heti ütemtervet.',
    },
  },
  themeTokens: {
    title: 'Téma stílus',
    subtitle: 'Tipográfia, sarkak és térköz',
    typography: 'Tipográfia',
    corners: 'Sarkak',
    density: 'Sűrűség',
  },
  advancedDesign: {
    title: 'Speciális',
    subtitle: 'Hangold finomra az egyes részeket',
    slot_title: 'Cím',
    slot_description: 'Leírás',
    slot_label: 'Felső címke',
    fontSize: 'Betűméret',
    fontWeight: 'Súly',
    textTransform: 'Kis-/nagybetű',
    textAlign: 'Igazítás',
    color: 'Szín',
  },
  layoutPicker: {
    title: 'Elrendezés',
    tooltip: 'Válaszd ki, hogyan legyenek elrendezve az elemek',
    layout_list: 'Lista',
    layout_grid: 'Rács',
    layout_cards: 'Kártyák',
  },
  importDesign: {
    title: 'Design importálása',
    subtitle: 'Hozz létre újra egy dizájnt egy képernyőképből',
    upload: 'Tölts fel egy képernyőképet',
    extracting: 'Elemzés…',
    apply: 'Alkalmazás az oldalra',
    applying: 'Alkalmazás…',
    blocksCount: '+{n} blokk',
    applied: 'A design alkalmazva — {n} blokk hozzáadva',
  },
};
